// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  var $parcel$bundleURL;function $parcel$resolve(url) {  url = importMap[url] || url;  if (!$parcel$bundleURL) {    try {      throw new Error();    } catch (err) {      var matches = ('' + err.stack).match(        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,      );      if (matches) {        $parcel$bundleURL = matches[0];      } else {        return distDir + url;      }    }  }  return new URL(distDir + url, $parcel$bundleURL).toString();}newRequire.resolve = $parcel$resolve;function $parcel$extendImportMap(map) {  Object.assign(importMap, map);}newRequire.extendImportMap = $parcel$extendImportMap;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"68Vv6":[function(require,module,exports,__globalThis) {
module.bundle.extendImportMap({
    "iLUhZ": "logo-mark.435d0c01.svg",
    "4ej8W": "logo-mark-invert.983c379b.svg",
    "dsini": "august-sander-schuke.0d1cb538.png",
    "cEDX3": "baham.78f9910e.png",
    "dpv7V": "data-and-drama.72f05737.png",
    "8Xndk": "eu.42085570.png",
    "evtvq": "fit-in-frankfurt.6d093b5c.png",
    "lzvHB": "fu.773e4323.png",
    "4WzLt": "games-connect.cc5c0552.png",
    "hm7Lo": "gi.78d31bd8.png",
    "4dSY4": "gi-mmb.80829b6f.png",
    "jMqk0": "kaleidoskop.5f3571db.png",
    "fN1Ce": "monetique.dc1c097e.png",
    "cyJo3": "pre-integration.11e3ff12.png",
    "blD2o": "thewhizstore.5e2d7fb6.png",
    "6RrYp": "you9.8d89e960.png",
    "aecME": "indaf.1adbba0b.png",
    "imrBR": "avera.5d8f68bc.svg",
    "1NRxp": "byov.f3f7a118.svg",
    "lNZtw": "main-photo.0655b104.jpg",
    "asKom": "prayrit.5a6dea2a.jpeg",
    "jCfwA": "About.46556f98.js",
    "gfzcu": "About.5cdc27b6.css",
    "jlkyU": "Contact.fa679961.js",
    "6QlvJ": "Contact.90809938.css",
    "cl9Bd": "Gallery.8217ca74.js",
    "5xZZ1": "2023.46ae93d7.jpg",
    "bBsCb": "2024.ee7cab14.webp",
    "5d1Lc": "2025.9ca0bb51.jpeg",
    "7w8eQ": "1.eb9f428c.jpg",
    "1Af2I": "2.301a0d96.png",
    "js4Bw": "3.92b52b8c.jpg",
    "31omD": "video_1.1164e2fb.mp4",
    "8fVdc": "video_2.2da279cf.mp4",
    "31TrK": "video_3.ebb53034.mp4",
    "hqRgd": "1080x1350.83d50420.jpg",
    "6A6V6": "1.ace11a72.jpg",
    "35Ghy": "2.a13fa353.jpg",
    "hwJVG": "3.febff44f.jpg",
    "2zXnD": "4.f8cafc11.jpg",
    "6u9VK": "5.89962767.jpg",
    "4Jt1T": "7.f4c8a368.jpg",
    "7mErN": "8.dbb9c47f.jpg",
    "hZG8b": "9.a092eaac.jpg",
    "ac8Zg": "10.3a3ae53f.jpg",
    "dV2o0": "11.03baa963.jpg",
    "2mYjY": "12.516c5942.webp",
    "aTiw8": "13.111b5659.jpg",
    "iMgur": "14.263bd19b.webp",
    "8HFDE": "Artboard 1 copy-100.a61eca42.jpg",
    "6jtCp": "Artboard 1 copy 3-100.ab53f47d.jpg",
    "5uUNi": "Artboard 1 copy 4-100.ce68e037.jpg",
    "21F0n": "Insta_.bffce0c1.jpg",
    "7mwHj": "1.fae99fc2.png",
    "6uSxu": "2.a3d83a3a.png",
    "49vMf": "bockenheim.5ccb9a2a.jpg",
    "falN0": "eckenheim.7655ac9a.jpg",
    "eUPh9": "hoechst.735ca138.jpg",
    "lcB68": "innenstadt.fd5cac46.jpg",
    "6bs0U": "nordweststadt.7e089d28.jpg",
    "gZ5EQ": "ostend.687ca56a.jpg",
    "ff2iO": "riederwald.cf0435aa.jpg",
    "7MrRD": "1.a8cce4c0.jpg",
    "9iEi6": "2.217a7ca4.jpg",
    "dQEI8": "3.6401c0c6.jpg",
    "9k7NW": "4.c94b14b4.png",
    "kKJpG": "1.efdebcc3.jpg",
    "lXlmu": "1_Suggestion 2.ad37fee6.jpg",
    "avZrE": "2.49ace9f3.jpg",
    "4UN22": "3.65cf0f3a.jpg",
    "ecATz": "4.dbb67385.jpg",
    "dYEAj": "5.6bacdf27.jpg",
    "ewEWY": "Artboard 1 copy 3-100.78765c76.jpg",
    "dagye": "Artboard 1-100.db9493fa.jpg",
    "lV4EY": "1x1_Keenan.beef4a54.png",
    "lykJt": "1x1_Omed.c47134d4.png",
    "9gke0": "1.8aeddb88.jpg",
    "jdUAH": "2.91b684a3.jpg",
    "lJfgh": "3.ae4362e6.jpg",
    "79vFR": "4.81906215.jpg",
    "8G7dl": "5.c39a4470.jpg",
    "kS5UV": "logo.518ba5ae.jpg",
    "i225n": "1.592e50f2.jpg",
    "gDQN8": "2.0d1c1e97.jpg",
    "68KAJ": "3.856816f7.jpg",
    "7WWAc": "4.8332013b.jpg",
    "iqSFi": "5.eeb3f0f6.jpg",
    "2rxce": "1.425b6758.png",
    "46U9I": "2.1942ff53.jpg",
    "5Yuc5": "Artboard 1-100.3a578118.jpg",
    "lUexA": "1.dd2b2956.jpg",
    "kWl5k": "2.acbe134d.jpg",
    "d1xi0": "3.4c801d88.png",
    "cbVmB": "4.fb988e74.jpg",
    "2tyEK": "5.7b63ea5d.jpg",
    "6Al4q": "1.5f17d1a4.jpg",
    "kLh57": "2.e0b81c68.jpg",
    "dAfiR": "3.97f41f42.jpg",
    "iSA6t": "4.d38a1518.jpg",
    "aMx1h": "1x1.408d7403.jpg",
    "cniSX": "1x1.3424ef87.jpg",
    "1QmaI": "Insta.07b8d627.jpg",
    "5P4iZ": "1.803eb6b2.jpg",
    "gthGW": "2.bb22179f.png",
    "keavo": "3.a27ad50c.jpg",
    "eC3xY": "4.ab8e0dcc.png",
    "42H8B": "Gallery.efa3afaa.css",
    "hCIgL": "Lab.6eba9a89.js",
    "dPM5Q": "argus-logo.66fa1ce1.svg",
    "7CFiB": "atlas-logo.9abab6f9.svg",
    "ifPLv": "proba-logo.5c42f0bf.svg",
    "k6Pf4": "fero-logo.a099adb4.svg",
    "iJLbh": "vex-logo.a39b0802.svg",
    "lyExU": "nyx-logo.eb3520c6.png",
    "athmk": "Lab.5694bae2.css",
    "4ecuy": "Service.27f98064.js",
    "iYQ95": "Service.b72660ad.css",
    "7d7ez": "Principles.ccf5e067.js",
    "gX0Yw": "Principles.a8219a33.css",
    "awgD4": "Privacy.5d955f24.js",
    "fI4oH": "Privacy.7cfffd36.css",
    "95kq0": "Disclaimer.6a0a8fa5.js",
    "bxSu2": "Disclaimer.30654c3f.css",
    "68tww": "Accessibility.9f4f7651.js",
    "9qlZc": "Accessibility.bdaad648.css"
});

},{}],"kwgBA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _client = require("react-dom/client");
var _clientDefault = parcelHelpers.interopDefault(_client);
var _reactRouterDom = require("react-router-dom");
var _header = require("./components/Header/Header");
var _headerDefault = parcelHelpers.interopDefault(_header);
var _footer = require("./components/Footer/Footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
var _main = require("./components/Main/Main");
var _mainDefault = parcelHelpers.interopDefault(_main);
var _error = require("./components/Error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _arrowIcon = require("./components/ArrowIcon/ArrowIcon");
var _arrowIconDefault = parcelHelpers.interopDefault(_arrowIcon);
var _react = require("react");
var _userContext = require("./utils/userContext");
var _userContextDefault = parcelHelpers.interopDefault(_userContext);
var _accessibilityContext = require("./utils/AccessibilityContext");
var _cookieBanner = require("./components/CookieBanner/CookieBanner");
var _cookieBannerDefault = parcelHelpers.interopDefault(_cookieBanner);
var _accessibilityMenu = require("./components/AccessibilityMenu/AccessibilityMenu");
var _accessibilityMenuDefault = parcelHelpers.interopDefault(_accessibilityMenu);
var _i18N = require("./utils/i18n");
var _languageContext = require("./utils/LanguageContext");
var _languageContextDefault = parcelHelpers.interopDefault(_languageContext);
var _translations = require("./utils/translations");
var _scrollToTop = require("./components/ScrollToTop");
var _scrollToTopDefault = parcelHelpers.interopDefault(_scrollToTop);
var _serviceData = require("./components/pages/Service/serviceData");
var _prayritJpeg = require("url:../assets/prayrit.jpeg");
var _prayritJpegDefault = parcelHelpers.interopDefault(_prayritJpeg);
// import { faqSections } from './components/pages/Faq/faqData';
var _bootstrapMinCss = require("bootstrap/dist/css/bootstrap.min.css");
var _indexCss = require("../index.css");
var _responsiveCss = require("./responsive.css");
const About = /*#__PURE__*/ (0, _react.lazy)(()=>require("fb7e1dc472b68f19"));
// const Prayrit = lazy(() => import('./components/pages/Prayrit/Prayrit'));
const Contact = /*#__PURE__*/ (0, _react.lazy)(()=>require("7fb74bf2ff124f5b"));
const Gallery = /*#__PURE__*/ (0, _react.lazy)(()=>require("38948cabcdc586a4"));
const Lab = /*#__PURE__*/ (0, _react.lazy)(()=>require("ced19b91b4a09505"));
const Service = /*#__PURE__*/ (0, _react.lazy)(()=>require("2f3089173665e764"));
// const Wall = lazy(() => import('./components/pages/Wall/Wall'));
// const Faq = lazy(() => import('./components/pages/Faq/Faq'));
// const Verse = lazy(() => import('./components/pages/Verse/Verse'));
const Principles = /*#__PURE__*/ (0, _react.lazy)(()=>require("f57f2db9c4e1faeb"));
const Privacy = /*#__PURE__*/ (0, _react.lazy)(()=>require("9823dfb7b3e7dc57"));
const Disclaimer = /*#__PURE__*/ (0, _react.lazy)(()=>require("73544b3b9b56b420"));
const Accessibility = /*#__PURE__*/ (0, _react.lazy)(()=>require("5a34e641adf789c2"));
const withRouteSuspense = (element)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
        fallback: null,
        children: element
    });
const SITE_TITLE = "thewhizkind";
const SITE_URL = "https://www.thewhizkind.com";
const DEFAULT_TITLE_TEMPLATE = '{title} | {site}';
const buildTitle = (meta, t)=>{
    if (meta.titleKey) {
        const translated = t('common', meta.titleKey, '');
        if (typeof translated === 'string' && translated) {
            const translatedTemplate = meta.titleTemplateKey ? t('common', meta.titleTemplateKey, '') : '';
            const template = typeof translatedTemplate === 'string' && translatedTemplate || meta.titleTemplate || DEFAULT_TITLE_TEMPLATE;
            return template.replace('{title}', translated).replace('{site}', SITE_TITLE);
        }
    }
    return meta.title || SITE_TITLE;
};
const DEFAULT_IMAGE = `${SITE_URL}/assets/seo/og-banner.jpg`;
const PRAYRIT_PORTRAIT_URL = new URL((0, _prayritJpegDefault.default), window.location.origin).href;
const DEFAULT_KEYWORDS = "thewhizkind, independent creative and technology team, AI, digitalisation, process optimisation, web development, automation, branding, graphic design, business, Frankfurt am Main";
const ROUTE_LABELS = {
    home: "Home",
    gallery: "Gallery",
    lab: "The Lab",
    services: "Services",
    wall: "Wall",
    about: "About",
    faq: "FAQ",
    contact: "Contact",
    principles: "Our Principles",
    verse: "Verse",
    store: "Store",
    nyx: "Nyx",
    invoiceMaker: "Invoice Maker",
    privacy: "Privacy Policy",
    disclaimer: "Legal Disclaimer",
    accessibility: "Accessibility",
    notFound: "Not Found"
};
const DEFAULT_META = {
    title: SITE_TITLE,
    description: "thewhizkind is an independent creative and technology team based in Frankfurt am Main, working across design, web development, AI, automation and business.",
    image: DEFAULT_IMAGE,
    imageAlt: "thewhizkind main visual",
    imageWidth: "1200",
    imageHeight: "630",
    type: "website",
    schemaType: "WebPage",
    twitterCard: "summary_large_image",
    robots: "index, follow",
    keywords: DEFAULT_KEYWORDS
};
const PAGE_META = {
    home: (0, _objectSpreadProps._)((0, _objectSpread._)({}, DEFAULT_META), {
        titleKey: 'pageMeta.title.home',
        titleTemplate: "{site} \u2014 {title}",
        datePublished: "2023-01-01",
        dateModified: "2026-09-14",
        keywords: "thewhizkind, independent creative and technology team, AI, digitalisation, process optimisation, web development, automation, graphic design, branding, business, Frankfurt am Main"
    }),
    gallery: {
        titleKey: `pageMeta.title.gallery`,
        description: "A gallery of selected visual work by thewhizkind: branding, identity, graphic design, campaigns, editorial and visual communication for cultural institutions and partners across Germany and India.",
        image: DEFAULT_IMAGE,
        imageAlt: "thewhizkind main visual",
        schemaType: "CollectionPage",
        datePublished: "2023-01-01",
        dateModified: "2026-09-12",
        keywords: "thewhizkind gallery, visual portfolio, branding projects, visual identity work, graphic design, editorial design, Goethe-Institut design, cultural institution branding, visual communication"
    },
    lab: {
        titleKey: `pageMeta.title.lab`,
        description: "Inside thewhizkind's lab: argus, proba, fero, atlas, vex, nyx and sophos \u2014 AI, automation and workflow tools built around real problems for real teams.",
        image: DEFAULT_IMAGE,
        imageAlt: "thewhizkind main visual",
        schemaType: "CollectionPage",
        datePublished: "2026-08-15",
        dateModified: "2026-08-16",
        keywords: "thewhizkind lab, AI tools, automation, process automation, argus, proba, fero, atlas, sophos, vex, nyx, dashboards, custom software"
    },
    services: {
        titleKey: `pageMeta.title.services`,
        description: "thewhizkind's services span brand & design, web & digital, AI, automation & tools, and finance & business \u2014 based in Frankfurt am Main.",
        image: DEFAULT_IMAGE,
        imageAlt: "thewhizkind design and technology services",
        schemaType: "CollectionPage",
        datePublished: "2026-08-22",
        dateModified: "2026-09-14",
        keywords: "design services Frankfurt, web development, branding, AI automation, process optimisation, custom digital tools, finance business support, thewhizkind services"
    },
    wall: {
        title: `Wall \u{2014} ${SITE_TITLE} | Visual Experiments & Posters`,
        description: "Discover visual experiments, posters, and illustrations from thewhizkind across branding, storytelling, and creative technology.",
        image: DEFAULT_IMAGE,
        imageAlt: "thewhizkind main visual",
        schemaType: "CollectionPage",
        datePublished: "2023-01-01",
        dateModified: "2026-01-01",
        keywords: "thewhizkind visual experiments, poster design, graphic illustration, experimental typography, creative posters Germany India, visual storytelling"
    },
    about: {
        titleKey: `pageMeta.title.about`,
        titleTemplateKey: 'pageMeta.template.about',
        description: "thewhizkind is an independent creative and technology team based in Frankfurt am Main \u2014 what we make, how we work, and the people behind it, including co-founder Prayrit Singh.",
        image: PRAYRIT_PORTRAIT_URL,
        imageAlt: "Portrait of Prayrit Singh, co-founder of thewhizkind, in Frankfurt am Main",
        imageWidth: "960",
        imageHeight: "1280",
        type: "website",
        schemaType: "AboutPage",
        datePublished: "2023-01-01",
        dateModified: "2026-09-14",
        keywords: "thewhizkind, about, Prayrit Singh, co-founder, design technology business, Frankfurt am Main"
    },
    faq: {
        title: `FAQ | ${SITE_TITLE} Creative & Tech Partners`,
        description: "Read answers to common questions about thewhizkind's branding, web development, process, pricing, and project collaboration.",
        image: DEFAULT_IMAGE,
        imageAlt: "thewhizkind main visual",
        schemaType: "WebPage",
        keywords: "thewhizkind FAQ, how much does a website cost, branding project timeline, custom website vs WordPress, React SEO, creative agency process India Germany"
    },
    contact: {
        titleKey: `pageMeta.title.contact`,
        description: "Get in touch with thewhizkind, based in Frankfurt am Main, for branding, web development, AI, automation and digital projects.",
        image: DEFAULT_IMAGE,
        imageAlt: "thewhizkind main visual",
        schemaType: "ContactPage",
        datePublished: "2023-01-01",
        dateModified: "2026-09-14",
        keywords: "contact thewhizkind, start a project, branding and web development Frankfurt, AI and automation partner, prayrit@thewhizkind.com"
    },
    principles: {
        titleKey: `pageMeta.title.principles`,
        description: "A few things thewhizkind believes in \u2014 about people, creativity, technology, and how we'd like to exist in the world.",
        image: DEFAULT_IMAGE,
        imageAlt: "thewhizkind main visual",
        schemaType: "WebPage",
        datePublished: "2026-08-16",
        dateModified: "2026-08-16",
        keywords: "thewhizkind principles, company values, independent creative and technology team culture, how we work, humans and AI, accessibility, kindness at work"
    },
    verse: {
        title: `Verse \u{2014} ${SITE_TITLE} Products & Releases`,
        description: "Explore thewhizkind Verse, a growing home for products, releases, Store, and Nyx.",
        image: DEFAULT_IMAGE,
        imageAlt: "thewhizkind main visual",
        schemaType: "CollectionPage",
        datePublished: "2026-04-18",
        dateModified: "2026-04-18",
        keywords: "thewhizkind verse, thewhizkind products, Store, Nyx, creative products, product releases"
    },
    store: {
        title: `Store \u{2014} ${SITE_TITLE}`,
        description: "Visit thewhizkind's store for products and releases.",
        image: DEFAULT_IMAGE,
        imageAlt: "thewhizkind main visual",
        robots: "noindex, nofollow",
        schemaType: "WebPage",
        keywords: DEFAULT_KEYWORDS
    },
    nyx: {
        title: `Nyx \u{2014} ${SITE_TITLE}`,
        description: "Visit Nyx by thewhizkind.",
        image: DEFAULT_IMAGE,
        imageAlt: "thewhizkind main visual",
        robots: "noindex, nofollow",
        schemaType: "WebPage",
        keywords: DEFAULT_KEYWORDS
    },
    invoiceMaker: {
        title: `Invoice Maker \u{2014} ${SITE_TITLE}`,
        description: "Clean, simple invoicing. No ads, no clutter, just a fast way to create professional invoices.",
        image: DEFAULT_IMAGE,
        imageAlt: "thewhizkind main visual",
        robots: "noindex, nofollow",
        schemaType: "WebPage",
        datePublished: "2026-05-07",
        dateModified: "2026-05-07",
        keywords: "Invoice Maker, simple invoice tool, professional invoices, lightweight invoice builder, thewhizkind Verse"
    },
    privacy: {
        titleKey: `pageMeta.title.privacy`,
        titleTemplate: "{title} \u2014 {site}",
        description: "Read how thewhizkind collects, uses, and protects personal data.",
        image: DEFAULT_IMAGE,
        imageAlt: "thewhizkind main visual",
        schemaType: "WebPage",
        datePublished: "2023-01-01",
        dateModified: "2025-12-01",
        keywords: DEFAULT_KEYWORDS
    },
    disclaimer: {
        titleKey: `pageMeta.title.disclaimer`,
        titleTemplate: "{title} \u2014 {site}",
        description: "Read the legal disclaimer for thewhizkind.",
        image: DEFAULT_IMAGE,
        imageAlt: "thewhizkind main visual",
        schemaType: "WebPage",
        datePublished: "2023-01-01",
        dateModified: "2025-12-01",
        keywords: DEFAULT_KEYWORDS
    },
    accessibility: {
        titleKey: `pageMeta.title.accessibility`,
        titleTemplate: "{title} \u2014 {site}",
        description: "How accessibility is built into thewhizkind, our WCAG 2.2 Level AA target, and the preferences available across the website.",
        image: DEFAULT_IMAGE,
        imageAlt: "thewhizkind main visual",
        schemaType: "WebPage",
        datePublished: "2026-08-20",
        dateModified: "2026-08-20",
        keywords: "thewhizkind accessibility, WCAG 2.2 Level AA, accessible web design, keyboard navigation, screen readers, reduced motion"
    },
    notFound: {
        title: `404 Not Found \u{2014} ${SITE_TITLE}`,
        description: "The page you requested does not exist on thewhizkind.",
        image: DEFAULT_IMAGE,
        imageAlt: "thewhizkind main visual",
        robots: "noindex, nofollow",
        keywords: "",
        schemaType: "WebPage"
    }
};
const normalizeSeoText = (text)=>typeof text === "string" ? text.replace(/\s+/g, " ").trim() : "";
/* const FAQ_SCHEMA_ITEMS = faqSections.flatMap((section) =>
    (section.items || []).map((item) => {
        const answerParts = [
            ...(item.answer || []),
            ...(item.list ? [item.list.join(", ")] : []),
            ...(item.link?.label ? [item.link.label] : []),
        ]
            .map(normalizeSeoText)
            .filter(Boolean);
        return {
            "@type": "Question",
            name: normalizeSeoText(item.question),
            acceptedAnswer: {
                "@type": "Answer",
                text: answerParts.join(" "),
            },
        };
    })
); */ // Structured data for /services is derived directly from the visible copy in
// Service.js (serviceGroups/faqs) so the JSON-LD never drifts out of sync with
// what a visitor actually reads on the page.
const PERSON_SCHEMA = {
    "@context": "https://schema.org",
    "@type": "Person",
    "@id": `${SITE_URL}/#prayrit`,
    name: "Prayrit Singh",
    givenName: "Prayrit",
    familyName: "Singh",
    url: `${SITE_URL}/about`,
    image: {
        "@type": "ImageObject",
        "@id": `${SITE_URL}/about#portrait`,
        url: PRAYRIT_PORTRAIT_URL,
        contentUrl: PRAYRIT_PORTRAIT_URL,
        width: 960,
        height: 1280,
        caption: "Portrait of Prayrit Singh in Frankfurt am Main"
    },
    jobTitle: "Co-founder",
    worksFor: {
        "@type": "Organization",
        "@id": `${SITE_URL}/#organization`,
        name: SITE_TITLE
    },
    homeLocation: {
        "@type": "Place",
        name: "Frankfurt am Main",
        address: {
            "@type": "PostalAddress",
            addressLocality: "Frankfurt am Main",
            addressCountry: "DE"
        }
    },
    sameAs: [
        "https://www.linkedin.com/in/prayrit-singh/",
        "https://www.instagram.com/thewhizkind"
    ],
    knowsLanguage: [
        "en",
        "de",
        "hi"
    ],
    description: "Prayrit Singh is the co-founder of thewhizkind, based in Frankfurt am Main with roots in New Delhi, working across design, technology, AI, automation and business."
};
const NotFound = ()=>{
    const location = (0, _reactRouterDom.useLocation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
        className: "not-found-page",
        "aria-labelledby": "not-found-title",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "not-found-eyebrow",
                children: "error / 404"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "not-found-code",
                "aria-hidden": "true",
                children: "404"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                id: "not-found-title",
                className: "not-found-title",
                children: "page not found"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "not-found-copy",
                children: "The page you requested is unavailable or no longer exists."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "not-found-path",
                children: [
                    "requested path ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("code", {
                        children: location.pathname
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                to: "/",
                className: "not-found-home-link",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowIconDefault.default), {
                        direction: "left"
                    }),
                    " back to main page"
                ]
            })
        ]
    });
};
const AppLayout = ()=>{
    const [user, setUser] = (0, _react.useState)("default");
    const [isScrolled, setIsScrolled] = (0, _react.useState)(false);
    const [routeAnnouncement, setRouteAnnouncement] = (0, _react.useState)("");
    const location = (0, _reactRouterDom.useLocation)();
    const appRef = (0, _react.useRef)(null);
    const isFirstRouteRef = (0, _react.useRef)(true);
    const { currentLang } = (0, _languageContext.useLanguage)();
    const normalizedPath = location.pathname.replace(/\/+$/, "") || "/";
    const prevPathRef = (0, _react.useRef)(normalizedPath);
    const pathLang = (0, _i18N.getLangFromPath)(location.pathname);
    const { t } = (0, _translations.useTranslations)();
    const serviceFaqs = t("service", (0, _serviceData.faqs), []);
    const lang = currentLang || pathLang;
    const matchedRouteKey = (0, _i18N.matchRouteKey)(pathLang, location.pathname);
    const routeKey = matchedRouteKey || (normalizedPath === "/" ? "home" : "notFound");
    const isNotFoundPage = routeKey === "notFound";
    (0, _react.useLayoutEffect)(()=>{
        const headerEl = document.querySelector('.header-main');
        const footerEl = document.querySelector('.footer');
        if (!headerEl) return;
        const root = document.documentElement;
        const updateLayoutHeights = ()=>{
            const height = headerEl.getBoundingClientRect().height;
            if (height) root.style.setProperty('--header-height', `${Math.round(height)}px`);
            if (footerEl) {
                const footerHeight = footerEl.getBoundingClientRect().height;
                if (footerHeight) root.style.setProperty('--footer-height', `${Math.round(footerHeight)}px`);
            }
        };
        updateLayoutHeights();
        let headerObserver;
        let footerObserver;
        if (typeof ResizeObserver !== 'undefined') {
            headerObserver = new ResizeObserver(updateLayoutHeights);
            headerObserver.observe(headerEl);
            if (footerEl) {
                footerObserver = new ResizeObserver(updateLayoutHeights);
                footerObserver.observe(footerEl);
            }
        }
        window.addEventListener('resize', updateLayoutHeights);
        return ()=>{
            window.removeEventListener('resize', updateLayoutHeights);
            if (headerObserver) headerObserver.disconnect();
            if (footerObserver) footerObserver.disconnect();
        };
    }, []);
    (0, _react.useEffect)(()=>{
        const setMeta = (key, value, isProperty = false)=>{
            const selector = isProperty ? `meta[property="${key}"]` : `meta[name="${key}"]`;
            let tag = document.head.querySelector(selector);
            if (!tag) {
                tag = document.createElement('meta');
                tag.setAttribute(isProperty ? 'property' : 'name', key);
                document.head.appendChild(tag);
            }
            tag.setAttribute('content', value);
        };
        const removeMeta = (key, isProperty = false)=>{
            const selector = isProperty ? `meta[property="${key}"]` : `meta[name="${key}"]`;
            const tag = document.head.querySelector(selector);
            if (tag) tag.remove();
        };
        const setCanonical = (href)=>{
            let link = document.head.querySelector('link[rel="canonical"]');
            if (!link) {
                link = document.createElement('link');
                link.setAttribute('rel', 'canonical');
                document.head.appendChild(link);
            }
            link.setAttribute('href', href);
        };
        const setAlternate = (hreflang, href)=>{
            let link = document.head.querySelector(`link[rel="alternate"][hreflang="${hreflang}"]`);
            if (!link) {
                link = document.createElement('link');
                link.setAttribute('rel', 'alternate');
                link.setAttribute('hreflang', hreflang);
                document.head.appendChild(link);
            }
            link.setAttribute('href', href);
        };
        const setJsonLd = (id, payload)=>{
            let script = document.head.querySelector(`script[type="application/ld+json"][data-seo-id="${id}"]`);
            if (!script) {
                script = document.createElement('script');
                script.type = 'application/ld+json';
                script.setAttribute('data-seo-id', id);
                document.head.appendChild(script);
            }
            script.textContent = JSON.stringify(payload);
        };
        const removeJsonLd = (id)=>{
            const script = document.head.querySelector(`script[type="application/ld+json"][data-seo-id="${id}"]`);
            if (script) script.remove();
        };
        const toTitleCase = (value)=>value.split(/[-_]/g).filter(Boolean).map((part)=>part.charAt(0).toUpperCase() + part.slice(1)).join(' ');
        const meta = (0, _objectSpread._)({}, DEFAULT_META, PAGE_META[routeKey] || {});
        const pageTitle = buildTitle(meta, t);
        const canonicalUrl = normalizedPath === "/" ? `${SITE_URL}/` : `${SITE_URL}${normalizedPath}`;
        // Get current language for meta tags
        const langForMeta = currentLang || lang || (0, _i18N.DEFAULT_LANG);
        document.title = pageTitle;
        setMeta('author', routeKey === 'about' ? 'Prayrit Singh' : SITE_TITLE);
        setMeta('description', meta.description);
        if (typeof meta.keywords === 'string' && meta.keywords.trim()) setMeta('keywords', meta.keywords);
        else removeMeta('keywords');
        setMeta('robots', meta.robots || DEFAULT_META.robots);
        setMeta('og:title', pageTitle, true);
        setMeta('og:description', meta.description, true);
        setMeta('og:url', canonicalUrl, true);
        setMeta('og:type', meta.type || DEFAULT_META.type, true);
        setMeta('og:site_name', SITE_TITLE, true);
        setMeta('og:locale', langForMeta === 'de' ? 'de_DE' : 'en_US', true);
        setMeta('og:image', meta.image, true);
        setMeta('og:image:secure_url', meta.image, true);
        setMeta('og:image:alt', meta.imageAlt, true);
        setMeta('og:image:width', meta.imageWidth || DEFAULT_META.imageWidth, true);
        setMeta('og:image:height', meta.imageHeight || DEFAULT_META.imageHeight, true);
        setMeta('og:image:type', 'image/jpeg', true);
        removeMeta('profile:first_name', true);
        removeMeta('profile:last_name', true);
        removeMeta('profile:username', true);
        setMeta('twitter:card', meta.twitterCard || DEFAULT_META.twitterCard);
        setMeta('twitter:site', '@thewhizkind');
        setMeta('twitter:creator', '@thewhizkind');
        setMeta('twitter:title', pageTitle);
        setMeta('twitter:description', meta.description);
        setMeta('twitter:image', meta.image);
        setMeta('twitter:image:alt', meta.imageAlt);
        setMeta('twitter:url', canonicalUrl);
        setCanonical(canonicalUrl);
        // hreflang: always derived from the path WITHOUT language prefix
        const basePath = normalizedPath.replace(/^\/(?:de|en)(?=\/|$)/, '') || '/';
        const enUrl = `${SITE_URL}${basePath}`;
        const deUrl = `${SITE_URL}/de${basePath === '/' ? '' : basePath}`;
        setAlternate('en', enUrl);
        setAlternate('de', deUrl);
        setAlternate('x-default', enUrl);
        const GEO_ROUTES = [
            'home',
            'about',
            'contact'
        ];
        if (GEO_ROUTES.includes(routeKey)) {
            setMeta('geo.region', 'DE-HE');
            setMeta('geo.placename', 'Frankfurt am Main');
            setMeta('geo.position', '50.1109;8.6821');
            setMeta('ICBM', '50.1109, 8.6821');
        } else {
            removeMeta('geo.region');
            removeMeta('geo.placename');
            removeMeta('geo.position');
            removeMeta('ICBM');
        }
        const pageSchema = (0, _objectSpread._)({
            "@context": "https://schema.org",
            "@type": meta.schemaType || DEFAULT_META.schemaType,
            "@id": `${canonicalUrl}#webpage`,
            name: pageTitle,
            description: meta.description,
            url: canonicalUrl,
            inLanguage: langForMeta === 'de' ? 'de' : 'en',
            isPartOf: {
                "@id": `${SITE_URL}/#website`
            },
            about: {
                "@id": `${SITE_URL}/#organization`
            }
        }, meta.datePublished ? {
            datePublished: meta.datePublished
        } : {}, meta.dateModified ? {
            dateModified: meta.dateModified
        } : {});
        if (routeKey === 'home') pageSchema.primaryImageOfPage = {
            "@type": "ImageObject",
            url: DEFAULT_IMAGE,
            width: 1200,
            height: 630
        };
        if (routeKey === 'contact') pageSchema.mainEntity = {
            "@type": "ContactPoint",
            contactType: "General inquiries",
            email: "prayrit@thewhizkind.com",
            availableLanguage: [
                "en"
            ]
        };
        if (routeKey === 'about') // The page is primarily about the organisation (hero, philosophy, motto)
        // with one dedicated founder section — so `about`/mainEntity stay on the
        // Organization, and the Person is linked separately via route-person
        // below and Organization.founder in index.html, rather than claimed as
        // this page's mainEntity.
        pageSchema.primaryImageOfPage = {
            "@id": `${SITE_URL}/about#portrait`
        };
        setJsonLd('route-page', pageSchema);
        /* if (routeKey === 'faq' && FAQ_SCHEMA_ITEMS.length) {
            setJsonLd('route-faq', {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                mainEntity: FAQ_SCHEMA_ITEMS,
            });
        } else {
            removeJsonLd('route-faq');
        } */ // Note: /gallery's own ItemList (with real project images and links) is
        // rendered inline by Gallery.js — no separate route-level copy here, to
        // avoid two competing ItemList graphs describing the same projects.
        if (routeKey === 'services') {
            setJsonLd('route-services', {
                "@context": "https://schema.org",
                "@type": "Service",
                "@id": `${SITE_URL}/services#service`,
                name: "Design, web development, AI, automation and business services",
                description: meta.description,
                url: `${SITE_URL}/services`,
                provider: {
                    "@id": `${SITE_URL}/#organization`
                },
                areaServed: [
                    {
                        "@type": "Country",
                        name: "Germany"
                    },
                    {
                        "@type": "Country",
                        name: "India"
                    },
                    {
                        "@type": "Place",
                        name: "Worldwide"
                    }
                ],
                hasOfferCatalog: {
                    "@type": "OfferCatalog",
                    name: "thewhizkind services",
                    itemListElement: (0, _serviceData.serviceGroups).map((group)=>({
                            "@type": "OfferCatalog",
                            "@id": `${SITE_URL}/services#${(0, _serviceData.serviceGroupSlug)(group.title)}`,
                            name: group.title,
                            description: group.intro,
                            itemListElement: group.services.map(([name, description])=>({
                                    "@type": "Offer",
                                    itemOffered: {
                                        "@type": "Service",
                                        name,
                                        description
                                    }
                                }))
                        }))
                }
            });
            setJsonLd('route-service-faq', {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "@id": `${SITE_URL}/services#faq`,
                mainEntity: serviceFaqs.map(([question, answer])=>({
                        "@type": "Question",
                        name: normalizeSeoText(question),
                        acceptedAnswer: {
                            "@type": "Answer",
                            text: normalizeSeoText(answer)
                        }
                    }))
            });
        } else {
            removeJsonLd('route-services');
            removeJsonLd('route-service-faq');
        }
        if (routeKey === 'about') setJsonLd('route-person', PERSON_SCHEMA);
        else removeJsonLd('route-person');
        // Language prefix (e.g. 'de') is not a breadcrumb level of its own
        const allSegments = normalizedPath === "/" ? [] : normalizedPath.split('/').filter(Boolean);
        const crumbLangPrefix = (0, _i18N.LANGUAGES).includes(allSegments[0]) && allSegments[0] !== (0, _i18N.DEFAULT_LANG) ? `/${allSegments[0]}` : '';
        const pathSegments = crumbLangPrefix ? allSegments.slice(1) : allSegments;
        const breadcrumbItems = [
            {
                "@type": "ListItem",
                position: 1,
                name: ROUTE_LABELS.home,
                item: `${SITE_URL}${crumbLangPrefix || '/'}`
            }
        ];
        pathSegments.forEach((segment, index)=>{
            const partialPath = `${crumbLangPrefix}/${pathSegments.slice(0, index + 1).join('/')}`;
            const partialRouteKey = (0, _i18N.matchRouteKey)(pathLang, partialPath);
            breadcrumbItems.push({
                "@type": "ListItem",
                position: index + 2,
                name: ROUTE_LABELS[partialRouteKey] || toTitleCase(segment),
                item: `${SITE_URL}${partialPath}`
            });
        });
        if (breadcrumbItems.length > 1) setJsonLd('route-breadcrumbs', {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: breadcrumbItems
        });
        else removeJsonLd('route-breadcrumbs');
        if (isFirstRouteRef.current) isFirstRouteRef.current = false;
        else {
            var _appRef_current;
            if (prevPathRef.current !== normalizedPath) (_appRef_current = appRef.current) === null || _appRef_current === void 0 ? void 0 : _appRef_current.focus({
                preventScroll: true
            });
            setRouteAnnouncement(pageTitle);
        }
        prevPathRef.current = normalizedPath;
    }, [
        normalizedPath,
        routeKey,
        currentLang
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                href: "#main-content",
                className: "skip-link",
                children: "Skip to main content"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                "aria-live": "polite",
                className: "visually-hidden",
                children: routeAnnouncement
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cookieBannerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accessibilityMenuDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "background-wrapper",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerDefault.default), {
                        scrolled: isScrolled
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _scrollToTopDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("main", {
                        id: "main-content",
                        className: `app${isNotFoundPage ? " app-not-found" : ""}${routeKey === "verse" ? " app-verse" : ""}`,
                        ref: appRef,
                        tabIndex: -1,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "page-load",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Outlet), {})
                        }, `${location.pathname}${location.search}`)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerDefault.default), {})
                ]
            })
        ]
    });
};
const StoreRedirect = ()=>{
    (0, _react.useEffect)(()=>{
        window.location.replace("https://www.thewhizstore.com/");
    }, []);
    return null;
};
const NyxRedirect = ()=>{
    (0, _react.useEffect)(()=>{
        window.location.replace("https://nyx.thewhizkind.com/");
    }, []);
    return null;
};
const InvoiceMakerRedirect = ()=>{
    (0, _react.useEffect)(()=>{
        window.location.replace("https://inv.thewhizkind.com/");
    }, []);
    return null;
};
const buildRoutes = ()=>({
        path: "/",
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _languageContext.LanguageProvider), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accessibilityContext.AccessibilityProvider), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userContextDefault.default).Provider, {
                    value: {
                        user: "default",
                        setUser: ()=>{}
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AppLayout, {})
                })
            })
        }),
        children: [
            {
                index: true,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mainDefault.default), {})
            },
            // English routes (default, no prefix)
            {
                path: `/${(0, _i18N.ROUTE_SLUGS).gallery.en}`,
                element: withRouteSuspense(/*#__PURE__*/ (0, _jsxRuntime.jsx)(Gallery, {}))
            },
            {
                path: `/${(0, _i18N.ROUTE_SLUGS).lab.en}`,
                element: withRouteSuspense(/*#__PURE__*/ (0, _jsxRuntime.jsx)(Lab, {}))
            },
            {
                path: `/${(0, _i18N.ROUTE_SLUGS).services.en}`,
                element: withRouteSuspense(/*#__PURE__*/ (0, _jsxRuntime.jsx)(Service, {}))
            },
            {
                path: `/${(0, _i18N.ROUTE_SLUGS).about.en}`,
                element: withRouteSuspense(/*#__PURE__*/ (0, _jsxRuntime.jsx)(About, {}))
            },
            {
                path: `/${(0, _i18N.ROUTE_SLUGS).contact.en}`,
                element: withRouteSuspense(/*#__PURE__*/ (0, _jsxRuntime.jsx)(Contact, {}))
            },
            {
                path: `/${(0, _i18N.ROUTE_SLUGS).principles.en}`,
                element: withRouteSuspense(/*#__PURE__*/ (0, _jsxRuntime.jsx)(Principles, {}))
            },
            {
                path: `/${(0, _i18N.ROUTE_SLUGS).invoiceMaker.en}`,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InvoiceMakerRedirect, {})
            },
            {
                path: `/${(0, _i18N.ROUTE_SLUGS).store.en}`,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StoreRedirect, {})
            },
            {
                path: `/${(0, _i18N.ROUTE_SLUGS).nyx.en}`,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(NyxRedirect, {})
            },
            {
                path: `/${(0, _i18N.ROUTE_SLUGS).privacy.en}`,
                element: withRouteSuspense(/*#__PURE__*/ (0, _jsxRuntime.jsx)(Privacy, {}))
            },
            {
                path: `/${(0, _i18N.ROUTE_SLUGS).disclaimer.en}`,
                element: withRouteSuspense(/*#__PURE__*/ (0, _jsxRuntime.jsx)(Disclaimer, {}))
            },
            {
                path: `/${(0, _i18N.ROUTE_SLUGS).accessibility.en}`,
                element: withRouteSuspense(/*#__PURE__*/ (0, _jsxRuntime.jsx)(Accessibility, {}))
            },
            // German routes (with /de prefix)
            {
                path: `/de/${(0, _i18N.ROUTE_SLUGS).gallery.de}`,
                element: withRouteSuspense(/*#__PURE__*/ (0, _jsxRuntime.jsx)(Gallery, {}))
            },
            {
                path: `/de/${(0, _i18N.ROUTE_SLUGS).lab.de}`,
                element: withRouteSuspense(/*#__PURE__*/ (0, _jsxRuntime.jsx)(Lab, {}))
            },
            {
                path: `/de/${(0, _i18N.ROUTE_SLUGS).services.de}`,
                element: withRouteSuspense(/*#__PURE__*/ (0, _jsxRuntime.jsx)(Service, {}))
            },
            {
                path: `/de/${(0, _i18N.ROUTE_SLUGS).about.de}`,
                element: withRouteSuspense(/*#__PURE__*/ (0, _jsxRuntime.jsx)(About, {}))
            },
            {
                path: `/de/${(0, _i18N.ROUTE_SLUGS).contact.de}`,
                element: withRouteSuspense(/*#__PURE__*/ (0, _jsxRuntime.jsx)(Contact, {}))
            },
            {
                path: `/de/${(0, _i18N.ROUTE_SLUGS).principles.de}`,
                element: withRouteSuspense(/*#__PURE__*/ (0, _jsxRuntime.jsx)(Principles, {}))
            },
            {
                path: `/de/${(0, _i18N.ROUTE_SLUGS).invoiceMaker.de}`,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InvoiceMakerRedirect, {})
            },
            {
                path: `/de/${(0, _i18N.ROUTE_SLUGS).store.de}`,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StoreRedirect, {})
            },
            {
                path: `/de/${(0, _i18N.ROUTE_SLUGS).nyx.de}`,
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(NyxRedirect, {})
            },
            {
                path: `/de/${(0, _i18N.ROUTE_SLUGS).privacy.de}`,
                element: withRouteSuspense(/*#__PURE__*/ (0, _jsxRuntime.jsx)(Privacy, {}))
            },
            {
                path: `/de/${(0, _i18N.ROUTE_SLUGS).disclaimer.de}`,
                element: withRouteSuspense(/*#__PURE__*/ (0, _jsxRuntime.jsx)(Disclaimer, {}))
            },
            {
                path: `/de/${(0, _i18N.ROUTE_SLUGS).accessibility.de}`,
                element: withRouteSuspense(/*#__PURE__*/ (0, _jsxRuntime.jsx)(Accessibility, {}))
            },
            // Root path for /de
            {
                path: "/de",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mainDefault.default), {})
            },
            {
                path: "*",
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)(NotFound, {})
            }
        ],
        errorElement: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {})
    });
const appRouter = (0, _reactRouterDom.createBrowserRouter)([
    buildRoutes()
], {
    future: {
        v7_relativeSplatPath: true
    }
});
const AppWithProviders = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.RouterProvider), {
        router: appRouter,
        future: {
            v7_startTransition: true
        }
    });
const root = (0, _clientDefault.default).createRoot(document.getElementById('root'));
root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)(AppWithProviders, {}));

},{"@swc/helpers/_/_object_spread":"evX8V","@swc/helpers/_/_object_spread_props":"9c2oY","react/jsx-runtime":"a7gVT","react-dom/client":"6URfd","react-router-dom":[["createBrowserRouter","hhXgL"],["Link","hhXgL"],["RouterProvider","hhXgL"],["useLocation","hhXgL"],["Outlet","bYbo7"]],"./components/Header/Header":"eQKMx","./components/Footer/Footer":"eVQfk","./components/Main/Main":"irnzY","./components/Error":"c3sef","./components/ArrowIcon/ArrowIcon":"dULmT","react":"7d7jl","./utils/userContext":"4rnt2","./utils/AccessibilityContext":"ijseP","./components/CookieBanner/CookieBanner":"aWZ8p","./components/AccessibilityMenu/AccessibilityMenu":"bxZc0","./utils/i18n":"4Kl7i","./utils/LanguageContext":"5u50e","./utils/translations":"kdPrY","./components/ScrollToTop":"hbtmi","./components/pages/Service/serviceData":"G0hsL","url:../assets/prayrit.jpeg":"bdXE0","bootstrap/dist/css/bootstrap.min.css":"262m3","../index.css":"b4Fi2","./responsive.css":"4NlaM","fb7e1dc472b68f19":"feUX4","7fb74bf2ff124f5b":"hF8ot","38948cabcdc586a4":"ccXrN","ced19b91b4a09505":"36z8C","2f3089173665e764":"96YN2","f57f2db9c4e1faeb":"drIH9","9823dfb7b3e7dc57":"8gdbq","73544b3b9b56b420":"23N0I","5a34e641adf789c2":"XtncN","@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"evX8V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_object_spread);
var _definePropertyJs = require("./_define_property.js");
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, _definePropertyJs._)(target, key, source[key]);
        });
    }
    return target;
}

},{"./_define_property.js":"2htks","@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"2htks":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_define_property);
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"aDlyA":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"9c2oY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_object_spread_props);
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"a7gVT":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"3U2Oe"}],"3U2Oe":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var f = require("3fd2a064dc1f3641"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"3fd2a064dc1f3641":"7d7jl"}],"7d7jl":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"hpEvU"}],"hpEvU":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
function X() {
    throw Error("act(...) is not supported in production builds of React.");
}
exports.Children = {
    map: S,
    forEach: function(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.act = X;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = X;
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.3.1";

},{}],"6URfd":[function(require,module,exports,__globalThis) {
'use strict';
var m = require("aaccff5d309d9239");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"aaccff5d309d9239":"6ZjMP"}],"6ZjMP":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"ifsTt"}],"ifsTt":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';
var aa = require("5393afc8c463ef07"), ca = require("ece50e903283a22f");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case wa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, !1);
}
function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = tc(h) : (f &= g, 0 !== f && (d = tc(f)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f && (d = tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
}
function zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
}
function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = !1, Kc = [], Lc = null, Mc = null, Nc = null, Oc = new Map, Pc = new Map, Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Pc.delete(b.pointerId);
    }
}
function Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Lc = Tc(Lc, a, b, c, d, e), !0;
        case "dragenter":
            return Mc = Tc(Mc, a, b, c, d, e), !0;
        case "mouseover":
            return Nc = Tc(Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Ic(a.priority, function() {
                        Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Zc(a, b, c) {
    Xc(a) && c.delete(b);
}
function $c() {
    Jc = !1;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
}
function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = !0, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
    function b(b) {
        return ad(b, a);
    }
    if (0 < Kc.length) {
        ad(Kc[0], a);
        for(var c = 1; c < Kc.length; c++){
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for(c = 0; c < Qc.length; c++)d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Qc.length && (c = Qc[0], null === c.blockedOn);)Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = !0;
function ed(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 1, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function gd(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 4, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function fd(a, b, c, d) {
    if (dd) {
        var e = Yc(a, b, c, d);
        if (null === e) hd(a, b, d, id, c), Sc(a, d);
        else if (Uc(e, a, b, c, d)) d.stopPropagation();
        else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Ec(f);
                f = Yc(a, b, c, d);
                null === f && hd(a, b, d, id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else hd(a, b, d, null, c);
    }
}
var id = null;
function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    id = a;
    return null;
}
function jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = A({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = A({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = A({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = A({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = A({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = A({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = A({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = A({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = A({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = A({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (ia) {
    var xe;
    if (ia) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        Jb(re, b);
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
    }
    return !0;
}
function Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Je(c);
    }
}
function Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Me() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ke(c, f);
                var g = Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var We = {
    animationend: Ve("Animation", "AnimationEnd"),
    animationiteration: Ve("Animation", "AnimationIteration"),
    animationstart: Ve("Animation", "AnimationStart"),
    transitionend: Ve("Transition", "TransitionEnd")
}, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = new Map, ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
    df.set(a, b);
    fa(b, [
        a
    ]);
}
for(var gf = 0; gf < ef.length; gf++){
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = new Set);
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, !1), c.add(d));
}
function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
    if (!a[rf]) {
        a[rf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[rf] || (b[rf] = !0, qf("selectionchange", !1, b));
    }
}
function pf(a, b, c, d) {
    switch(jd(b)){
        case 1:
            var e = ed;
            break;
        case 4:
            e = gd;
            break;
        default:
            e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = df.get(a);
            if (void 0 !== h) {
                var k = td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case $e:
                    case af:
                    case bf:
                        k = Hd;
                        break;
                    case cf:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = Kb(w, x), null != F && t.push(tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? Wc(n) : null, null !== n && (J = Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : ue(k);
                        u = null == n ? h : ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = vf(u))w++;
                            u = 0;
                            for(F = x; F; F = vf(F))u++;
                            for(; 0 < w - u;)t = vf(t), w--;
                            for(; 0 < u - w;)x = vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = vf(t);
                                x = vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && wf(g, h, k, t, !1);
                        null !== n && null !== J && wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = ve;
                else if (me(h)) {
                    if (we) na = Fe;
                    else {
                        na = De;
                        var xa = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = Ee);
                if (na && (na = na(a, d))) {
                    ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && cb(h, "number", h.value);
            }
            xa = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var $a;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), xa = oe(d, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
            if ($a = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        se(g, b);
    });
}
function tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(tf(a, f, e)), f = Kb(a, b), null != f && d.push(tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(tf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {}
var Cf = null, Df = null;
function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
    return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
    setTimeout(function() {
        throw a;
    });
}
function Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    bd(b);
}
function Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[uf] || c[Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Mf(a); null !== a;){
                if (c = a[Of]) return c;
                a = Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(!1), Xf = Vf;
function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f() {
    E(Wf);
    E(H);
}
function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
}
function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
}
function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return !0;
}
function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
}
var eg = null, fg = !1, gg = !1;
function hg(a) {
    null === eg ? eg = [
        a
    ] : eg.push(a);
}
function ig(a) {
    fg = !0;
    hg(a);
}
function jg() {
    if (!gg && null !== eg) {
        gg = !0;
        var a = 0, b = C;
        try {
            var c = eg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            eg = null;
            fg = !1;
        } catch (e) {
            throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
        } finally{
            C = b, gg = !1;
        }
    }
    return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
}
function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        rg = 1 << 32 - oc(b) + e | c << e | d;
        sg = f + a;
    } else rg = 1 << f | c << e | d, sg = a;
}
function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
    for(; a === mg;)mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for(; a === qg;)qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = !1, zg = null;
function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? {
                id: rg,
                overflow: sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, !0) : !1;
        default:
            return !1;
    }
}
function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
    if (I) {
        var b = yg;
        if (b) {
            var c = b;
            if (!Cg(a, b)) {
                if (Dg(a)) throw Error(p(418));
                b = Lf(c.nextSibling);
                var d = xg;
                b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, xg = a);
            }
        } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            xg = a;
        }
    }
}
function Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    xg = a;
}
function Gg(a) {
    if (a !== xg) return !1;
    if (!I) return Fg(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
        if (Dg(a)) throw Hg(), Error(p(418));
        for(; b;)Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            yg = Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            yg = null;
        }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function Hg() {
    for(var a = yg; a;)a = Lf(a.nextSibling);
}
function Ig() {
    yg = xg = null;
    I = !1;
}
function Jg(a) {
    null === zg ? zg = [
        a
    ] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ha && Ng(f) === b.type)) return d = e(b, c.props), d.ref = Lg(a, b, c), d.return = a, d;
        d = Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case va:
                    return c = Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = Lg(a, null, b), c.return = a, c;
                case wa:
                    return b = Sg(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return b = Tg(b, a.mode, c, null), b.return = a, b;
            Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case va:
                    return c.key === e ? k(a, b, c, d) : null;
                case wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), I && tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            I && tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), I && tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            I && tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ha && Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var Ug = Og(!0), Vg = Og(!1), Wg = Uf(null), Xg = null, Yg = null, Zg = null;
function $g() {
    Zg = Yg = Xg = null;
}
function ah(a) {
    var b = Wg.current;
    E(Wg);
    a._currentValue = b;
}
function bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function ch(a, b) {
    Xg = a;
    Zg = Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (dh = !0), a.firstContext = null);
}
function eh(a) {
    var b = a._currentValue;
    if (Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === Yg) {
            if (null === Xg) throw Error(p(308));
            Yg = a;
            Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else Yg = Yg.next = a;
    }
    return b;
}
var fh = null;
function gh(a) {
    null === fh ? fh = [
        a
    ] : fh.push(a);
}
function hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return ih(a, d);
}
function ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var jh = !1;
function kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return ih(a, c);
}
function oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
function ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function qh(a, b, c, d) {
    var e = a.updateQueue;
    jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = A({}, q, r);
                            break a;
                        case 2:
                            jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var th = {}, uh = Uf(th), vh = Uf(th), wh = Uf(th);
function xh(a) {
    if (a === th) throw Error(p(174));
    return a;
}
function yh(a, b) {
    G(wh, b);
    G(vh, a);
    G(uh, th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(uh);
    G(uh, b);
}
function zh() {
    E(uh);
    E(vh);
    E(wh);
}
function Ah(a) {
    xh(wh.current);
    var b = xh(uh.current);
    var c = lb(b, a.type);
    b !== c && (G(vh, a), G(uh, c));
}
function Bh(a) {
    vh.current === a && (E(uh), E(vh));
}
var L = Uf(0);
function Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Dh = [];
function Eh() {
    for(var a = 0; a < Dh.length; a++)Dh[a]._workInProgressVersionPrimary = null;
    Dh.length = 0;
}
var Fh = ua.ReactCurrentDispatcher, Gh = ua.ReactCurrentBatchConfig, Hh = 0, M = null, N = null, O = null, Ih = !1, Jh = !1, Kh = 0, Lh = 0;
function P() {
    throw Error(p(321));
}
function Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Nh(a, b, c, d, e, f) {
    Hh = f;
    M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Fh.current = null === a || null === a.memoizedState ? Oh : Ph;
    a = c(d, e);
    if (Jh) {
        f = 0;
        do {
            Jh = !1;
            Kh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            O = N = null;
            b.updateQueue = null;
            Fh.current = Qh;
            a = c(d, e);
        }while (Jh);
    }
    Fh.current = Rh;
    b = null !== N && null !== N.next;
    Hh = 0;
    O = N = M = null;
    Ih = !1;
    if (b) throw Error(p(300));
    return a;
}
function Sh() {
    var a = 0 !== Kh;
    Kh = 0;
    return a;
}
function Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === O ? M.memoizedState = O = a : O = O.next = a;
    return O;
}
function Uh() {
    if (null === N) {
        var a = M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = N.next;
    var b = null === O ? M.memoizedState : O.next;
    if (null !== b) O = b, N = a;
    else {
        if (null === a) throw Error(p(310));
        N = a;
        a = {
            memoizedState: N.memoizedState,
            baseState: N.baseState,
            baseQueue: N.baseQueue,
            queue: N.queue,
            next: null
        };
        null === O ? M.memoizedState = O = a : O = O.next = a;
    }
    return O;
}
function Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Wh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if ((Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                M.lanes |= m;
                rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        He(d, b.memoizedState) || (dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, M.lanes |= f, rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Xh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Yh() {}
function Zh(a, b) {
    var c = M, d = Uh(), e = b(), f = !He(d.memoizedState, e);
    f && (d.memoizedState = e, dh = !0);
    d = d.queue;
    $h(ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== O && O.memoizedState.tag & 1) {
        c.flags |= 2048;
        bi(9, ci.bind(null, c, d, e, b), void 0, null);
        if (null === Q) throw Error(p(349));
        0 !== (Hh & 30) || di(c, b, e);
    }
    return e;
}
function di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    ei(b) && fi(a);
}
function ai(a, b, c) {
    return c(function() {
        ei(b) && fi(a);
    });
}
function ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !He(a, c);
    } catch (d) {
        return !0;
    }
}
function fi(a) {
    var b = ih(a, 1);
    null !== b && gi(b, a, 1, -1);
}
function hi(a) {
    var b = Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ii.bind(null, M, a);
    return [
        b.memoizedState,
        a
    ];
}
function bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function ji() {
    return Uh().memoizedState;
}
function ki(a, b, c, d) {
    var e = Th();
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function li(a, b, c, d) {
    var e = Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== N) {
        var g = N.memoizedState;
        f = g.destroy;
        if (null !== d && Mh(d, g.deps)) {
            e.memoizedState = bi(b, c, f, d);
            return;
        }
    }
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, f, d);
}
function mi(a, b) {
    return ki(8390656, 8, a, b);
}
function $h(a, b) {
    return li(2048, 8, a, b);
}
function ni(a, b) {
    return li(4, 2, a, b);
}
function oi(a, b) {
    return li(4, 4, a, b);
}
function pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return li(4, 4, pi.bind(null, b, a), c);
}
function ri() {}
function si(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ti(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ui(a, b, c) {
    if (0 === (Hh & 21)) return a.baseState && (a.baseState = !1, dh = !0), a.memoizedState = c;
    He(c, b) || (c = yc(), M.lanes |= c, rh |= c, a.baseState = !0);
    return b;
}
function vi(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Gh.transition;
    Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Gh.transition = d;
    }
}
function wi() {
    return Uh().memoizedState;
}
function xi(a, b, c) {
    var d = yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, c);
    else if (c = hh(a, b, c, d), null !== c) {
        var e = R();
        gi(c, a, d, e);
        Bi(c, b, d);
    }
}
function ii(a, b, c) {
    var d = yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = hh(a, b, e, d);
        null !== c && (e = R(), gi(c, a, d, e), Bi(c, b, d));
    }
}
function zi(a) {
    var b = a.alternate;
    return a === M || null !== b && b === M;
}
function Ai(a, b) {
    Jh = Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
var Rh = {
    readContext: eh,
    useCallback: P,
    useContext: P,
    useEffect: P,
    useImperativeHandle: P,
    useInsertionEffect: P,
    useLayoutEffect: P,
    useMemo: P,
    useReducer: P,
    useRef: P,
    useState: P,
    useDebugValue: P,
    useDeferredValue: P,
    useTransition: P,
    useMutableSource: P,
    useSyncExternalStore: P,
    useId: P,
    unstable_isNewReconciler: !1
}, Oh = {
    readContext: eh,
    useCallback: function(a, b) {
        Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: eh,
    useEffect: mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ki(4194308, 4, pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = xi.bind(null, M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: hi,
    useDebugValue: ri,
    useDeferredValue: function(a) {
        return Th().memoizedState = a;
    },
    useTransition: function() {
        var a = hi(!1), b = a[0];
        a = vi.bind(null, a[1]);
        Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = M, e = Th();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === Q) throw Error(p(349));
            0 !== (Hh & 30) || di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        mi(ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        bi(9, ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = Th(), b = Q.identifierPrefix;
        if (I) {
            var c = sg;
            var d = rg;
            c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Ph = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Wh,
    useRef: ji,
    useState: function() {
        return Wh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Wh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
}, Qh = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Xh,
    useRef: ji,
    useState: function() {
        return Xh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return null === N ? b.memoizedState = a : ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Xh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
};
function Ci(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = R(), d = yi(a), e = mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = nh(a, e, d);
        null !== b && (gi(b, a, d, c), oh(b, a, d));
    }
};
function Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f) : !0;
}
function Gi(a, b, c) {
    var d = !1, e = Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = eh(f) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Ei.enqueueReplaceState(b, b.state, null);
}
function Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = eh(f) : (f = Zf(b) ? Xf : H.current, e.context = Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Ei.enqueueReplaceState(e, e.state, null), qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function Ji(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Mi = "function" === typeof WeakMap ? WeakMap : Map;
function Ni(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Oi || (Oi = !0, Pi = d);
        Li(a, b);
    };
    return c;
}
function Qi(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Li(a, b);
        "function" !== typeof d && (null === Ri ? Ri = new Set([
            this
        ]) : Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Ti.bind(null, a, b, c), b.then(a, a));
}
function Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = mh(-1, 1), b.tag = 2, nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Wi = ua.ReactCurrentOwner, dh = !1;
function Xi(a, b, c, d) {
    b.child = null === a ? Vg(b, null, c, d) : Ug(b, a.child, c, d);
}
function Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    ch(b, e);
    d = Nh(a, b, c, d, f, e);
    c = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Xi(a, b, d, e);
    return b.child;
}
function $i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, bj(a, b, f, d, e);
        a = Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : Ie;
        if (c(g, d) && a.ref === b.ref) return Zi(a, b, e);
    }
    b.flags |= 1;
    a = Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (Ie(f, d) && a.ref === b.ref) {
            if (dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (dh = !0);
            else return b.lanes = a.lanes, Zi(a, b, e);
        }
    }
    return cj(a, b, c, d, e);
}
function dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(ej, fj), fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, G(ej, fj), fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            G(ej, fj);
            fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(ej, fj), fj |= d;
    Xi(a, b, e, c);
    return b.child;
}
function gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function cj(a, b, c, d, e) {
    var f = Zf(c) ? Xf : H.current;
    f = Yf(b, f);
    ch(b, e);
    c = Nh(a, b, c, d, f, e);
    d = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Xi(a, b, c, e);
    return b.child;
}
function hj(a, b, c, d, e) {
    if (Zf(c)) {
        var f = !0;
        cg(b);
    } else f = !1;
    ch(b, e);
    if (null === b.stateNode) ij(a, b), Gi(b, c, d), Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = eh(l) : (l = Zf(c) ? Xf : H.current, l = Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Hi(b, g, d, l);
        jh = !1;
        var r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || Wf.current || jh ? ("function" === typeof m && (Di(b, c, m, d), k = b.memoizedState), (h = jh || Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = eh(k) : (k = Zf(c) ? Xf : H.current, k = Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && Hi(b, g, d, k);
        jh = !1;
        r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || Wf.current || jh ? ("function" === typeof y && (Di(b, c, y, d), n = b.memoizedState), (l = jh || Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return jj(a, b, c, d, f, e);
}
function jj(a, b, c, d, e, f) {
    gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, !1), Zi(a, b, f);
    d = b.stateNode;
    Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Ug(b, a.child, null, f), b.child = Ug(b, null, h, f)) : Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && dg(b, c, !0);
    return b.child;
}
function kj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
    yh(a, b.containerInfo);
}
function lj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Xi(a, b, c, d);
    return b.child;
}
var mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function oj(a, b, c) {
    var d = b.pendingProps, e = L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(L, e & 1);
    if (null === a) {
        Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = pj(g, d, 0, null), a = Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = nj(c), b.memoizedState = mj, a) : qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = Pg(h, f) : (f = Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function qj(a, b) {
    b = pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function sj(a, b, c, d) {
    null !== d && Jg(d);
    Ug(b, a.child, null, c);
    a = qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = Ki(Error(p(422))), sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && Ug(b, a.child, null, g);
        b.child.memoizedState = nj(g);
        b.memoizedState = mj;
        return f;
    }
    if (0 === (b.mode & 1)) return sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = Ki(f, d, void 0);
        return sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (dh || h) {
        d = Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, ih(a, e), gi(d, a, e, -1));
        }
        tj();
        d = Ki(Error(p(421)));
        return sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = !0;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    bh(a.return, b, c);
}
function wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Xi(a, b, d.children, c);
    d = L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && vj(a, c, b);
            else if (19 === a.tag) vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            wj(b, !0, c, null, f);
            break;
        case "together":
            wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function yj(a, b, c) {
    switch(b.tag){
        case 3:
            kj(b);
            Ig();
            break;
        case 5:
            Ah(b);
            break;
        case 1:
            Zf(b.type) && cg(b);
            break;
        case 4:
            yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(L, L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return oj(a, b, c);
                G(L, L.current & 1);
                a = Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(L, L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(L, L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, dj(a, b, c);
    }
    return Zi(a, b, c);
}
var zj, Aj, Bj, Cj;
zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Aj = function() {};
Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        xh(uh.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Dj(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Ej(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return Zf(b.type) && $f(), S(b), null;
        case 3:
            d = b.stateNode;
            zh();
            E(Wf);
            E(H);
            Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Fj(zg), zg = null));
            Aj(a, b);
            S(b);
            return null;
        case 5:
            Bh(b);
            var e = xh(wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Of] = b;
                    d[Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < lf.length; e++)D(lf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), D("invalid", d);
                    }
                    ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Va(d);
                            db(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Of] = b;
                    a[Pf] = d;
                    zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < lf.length; e++)D(lf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                hb(a, d);
                                e = gb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                db(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = xh(wh.current);
                xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = xg, null !== a) switch(a.tag){
                            case 3:
                                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            E(L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f = !1;
                else if (f = Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[Of] = b;
                    } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    S(b);
                    f = !1;
                } else null !== zg && (Fj(zg), zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (L.current & 1) ? 0 === T && (T = 3) : tj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
        case 4:
            return zh(), Aj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return ah(b.type._context), S(b), null;
        case 17:
            return Zf(b.type) && $f(), S(b), null;
        case 19:
            E(L);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Dj(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(L, L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > Gj && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return S(b), null;
                    } else 2 * B() - f.renderingStartTime > Gj && 1073741824 !== c && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = L.current, G(L, d ? c & 1 | 2 : c & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (fj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function Ij(a, b) {
    wg(b);
    switch(b.tag){
        case 1:
            return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return zh(), E(Wf), E(H), Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Bh(b), null;
        case 13:
            E(L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(L), null;
        case 4:
            return zh(), null;
        case 10:
            return ah(b.type._context), null;
        case 22:
        case 23:
            return Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Jj = !1, U = !1, Kj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var Nj = !1;
function Oj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Df = {
        focusedElem: a,
        selectionRange: c
    };
    dd = !1;
    for(V = b; null !== V;)if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for(; null !== V;){
        b = V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (F) {
            W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            V = a;
            break;
        }
        V = b.return;
    }
    n = Nj;
    Nj = !1;
    return n;
}
function Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for(Vj(a, b, c), a = a.sibling; null !== a;)Vj(a, b, c), a = a.sibling;
}
function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Wj(a, b, c), a = a.sibling; null !== a;)Wj(a, b, c), a = a.sibling;
}
var X = null, Xj = !1;
function Yj(a, b, c) {
    for(c = c.child; null !== c;)Zj(a, b, c), c = c.sibling;
}
function Zj(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            U || Lj(c, b);
        case 6:
            var d = X, e = Xj;
            X = null;
            Yj(a, b, c);
            X = d;
            Xj = e;
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Xj;
            X = c.stateNode.containerInfo;
            Xj = !0;
            Yj(a, b, c);
            X = d;
            Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Mj(c, b, g) : 0 !== (f & 4) && Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Yj(a, b, c);
            break;
        case 1:
            if (!U && (Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                W(c, b, h);
            }
            Yj(a, b, c);
            break;
        case 21:
            Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Yj(a, b, c), U = d) : Yj(a, b, c);
            break;
        default:
            Yj(a, b, c);
    }
}
function ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Kj);
        b.forEach(function(b) {
            var d = bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Xj = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            Zj(f, g, e);
            X = null;
            Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)dk(b, a), b = b.sibling;
}
function dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            ck(b, a);
            ek(a);
            if (d & 4) {
                try {
                    Pj(3, a, a.return), Qj(3, a);
                } catch (t) {
                    W(a, a.return, t);
                }
                try {
                    Pj(5, a, a.return);
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 1:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            break;
        case 5:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && ab(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? sb(e, q) : "dangerouslySetInnerHTML" === m ? nb(e, q) : "children" === m ? ob(e, q) : ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            bb(e, f);
                            break;
                        case "textarea":
                            ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? fb(e, !!f.multiple, f.defaultValue, !0) : fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Pf] = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 6:
            ck(b, a);
            ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 3:
            ck(b, a);
            ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
            } catch (t) {
                W(a, a.return, t);
            }
            break;
        case 4:
            ck(b, a);
            ek(a);
            break;
        case 13:
            ck(b, a);
            ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (fk = B()));
            d & 4 && ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (U = (l = U) || m, ck(b, a), U = l) : ck(b, a);
            ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for(V = a, m = a.child; null !== m;){
                    for(q = V = m; null !== V;){
                        r = V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Pj(4, r, r.return);
                                break;
                            case 1:
                                Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, V = y) : gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (t) {
                                W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            ck(b, a);
            ek(a);
            d & 4 && ak(a);
            break;
        case 21:
            break;
        default:
            ck(b, a), ek(a);
    }
}
function ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Uj(a);
                    Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Uj(a);
                    Vj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function hk(a, b, c) {
    V = a;
    ik(a, b, c);
}
function ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== V;){
        var e = V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || U;
                h = Jj;
                var l = U;
                Jj = g;
                if ((U = k) && !l) for(V = e; null !== V;)g = V, k = g.child, 22 === g.tag && null !== g.memoizedState ? jk(e) : null !== k ? (k.return = g, V = k) : jk(e);
                for(; null !== f;)V = f, ik(f, b, c), f = f.sibling;
                V = e;
                Jj = h;
                U = l;
            }
            kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, V = f) : kk(a, b, c);
    }
}
function kk(a) {
    for(; null !== V;){
        var b = V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        U || Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                U || b.flags & 512 && Rj(b);
            } catch (r) {
                W(b, b.return, r);
            }
        }
        if (b === a) {
            V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function gk(a) {
    for(; null !== V;){
        var b = V;
        if (b === a) {
            V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function jk(a) {
    for(; null !== V;){
        var b = V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Qj(4, b);
                    } catch (k) {
                        W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, g, k);
                    }
            }
        } catch (k) {
            W(b, b.return, k);
        }
        if (b === a) {
            V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            V = h;
            break;
        }
        V = b.return;
    }
}
var lk = Math.ceil, mk = ua.ReactCurrentDispatcher, nk = ua.ReactCurrentOwner, ok = ua.ReactCurrentBatchConfig, K = 0, Q = null, Y = null, Z = 0, fj = 0, ej = Uf(0), T = 0, pk = null, rh = 0, qk = 0, rk = 0, sk = null, tk = null, fk = 0, Gj = Infinity, uk = null, Oi = !1, Pi = null, Ri = null, vk = !1, wk = null, xk = 0, yk = 0, zk = null, Ak = -1, Bk = 0;
function R() {
    return 0 !== (K & 6) ? B() : -1 !== Ak ? Ak : Ak = B();
}
function yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Bk && (Bk = yc()), Bk;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
}
function gi(a, b, c, d) {
    if (50 < yk) throw yk = 0, zk = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== Q) a === Q && (0 === (K & 2) && (qk |= c), 4 === T && Ck(a, Z)), Dk(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Gj = B() + 500, fg && jg());
}
function Dk(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? ig(Ek.bind(null, a)) : hg(Ek.bind(null, a)), Jf(function() {
            0 === (K & 6) && jg();
        }), c = null;
        else {
            switch(Dc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = Fk(c, Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Gk(a, b) {
    Ak = -1;
    Bk = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Hk() && a.callbackNode !== c) return null;
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Ik(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = Jk();
        if (Q !== a || Z !== b) uk = null, Gj = B() + 500, Kk(a, b);
        for(;;)try {
            Lk();
            break;
        } catch (h) {
            Mk(a, h);
        }
        $g();
        mk.current = f;
        K = e;
        null !== Y ? b = 0 : (Q = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = xc(a), 0 !== e && (d = e, b = Nk(a, e)));
        if (1 === b) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
        if (6 === b) Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Ok(e) && (b = Ik(a, d), 2 === b && (f = xc(a), 0 !== f && (d = f, b = Nk(a, f))), 1 === b)) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Pk(a, tk, uk);
                    break;
                case 3:
                    Ck(a, d);
                    if ((d & 130023424) === d && (b = fk + 500 - B(), 10 < b)) {
                        if (0 !== uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), b);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 4:
                    Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), d);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 5:
                    Pk(a, tk, uk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Dk(a, B());
    return a.callbackNode === c ? Gk.bind(null, a) : null;
}
function Nk(a, b) {
    var c = sk;
    a.current.memoizedState.isDehydrated && (Kk(a, b).flags |= 256);
    a = Ik(a, b);
    2 !== a && (b = tk, tk = c, null !== b && Fj(b));
    return a;
}
function Fj(a) {
    null === tk ? tk = a : tk.push.apply(tk, a);
}
function Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Ck(a, b) {
    b &= ~rk;
    b &= ~qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Ek(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Hk();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Dk(a, B()), null;
    var c = Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = xc(a);
        0 !== d && (b = d, c = Nk(a, d));
    }
    if (1 === c) throw c = pk, Kk(a, 0), Ck(a, b), Dk(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Pk(a, tk, uk);
    Dk(a, B());
    return null;
}
function Qk(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (Gj = B() + 500, fg && jg());
    }
}
function Rk(a) {
    null !== wk && 0 === wk.tag && 0 === (K & 6) && Hk();
    var b = K;
    K |= 1;
    var c = ok.transition, d = C;
    try {
        if (ok.transition = null, C = 1, a) return a();
    } finally{
        C = d, ok.transition = c, K = b, 0 === (K & 6) && jg();
    }
}
function Hj() {
    fj = ej.current;
    E(ej);
}
function Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
            case 3:
                zh();
                E(Wf);
                E(H);
                Eh();
                break;
            case 5:
                Bh(d);
                break;
            case 4:
                zh();
                break;
            case 13:
                E(L);
                break;
            case 19:
                E(L);
                break;
            case 10:
                ah(d.type._context);
                break;
            case 22:
            case 23:
                Hj();
        }
        c = c.return;
    }
    Q = a;
    Y = a = Pg(a.current, null);
    Z = fj = b;
    T = 0;
    pk = null;
    rk = qk = rh = 0;
    tk = sk = null;
    if (null !== fh) {
        for(b = 0; b < fh.length; b++)if (c = fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        fh = null;
    }
    return a;
}
function Mk(a, b) {
    do {
        var c = Y;
        try {
            $g();
            Fh.current = Rh;
            if (Ih) {
                for(var d = M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Ih = !1;
            }
            Hh = 0;
            O = N = M = null;
            Jh = !1;
            Kh = 0;
            nk.current = null;
            if (null === c || null === c.return) {
                T = 1;
                pk = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Vi(y, g, h, f, b);
                        y.mode & 1 && Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Si(f, l, b);
                            tj();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Vi(J, g, h, f, b);
                        Jg(Ji(k, h));
                        break a;
                    }
                }
                f = k = Ji(k, h);
                4 !== T && (T = 2);
                null === sk ? sk = [
                    f
                ] : sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = Ni(f, k, b);
                            ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Ri || !Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = Qi(f, h, b);
                                ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            Sk(c);
        } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Jk() {
    var a = mk.current;
    mk.current = Rh;
    return null === a ? Rh : a;
}
function tj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === Q || 0 === (rh & 268435455) && 0 === (qk & 268435455) || Ck(Q, Z);
}
function Ik(a, b) {
    var c = K;
    K |= 2;
    var d = Jk();
    if (Q !== a || Z !== b) uk = null, Kk(a, b);
    for(;;)try {
        Tk();
        break;
    } catch (e) {
        Mk(a, e);
    }
    $g();
    K = c;
    mk.current = d;
    if (null !== Y) throw Error(p(261));
    Q = null;
    Z = 0;
    return T;
}
function Tk() {
    for(; null !== Y;)Uk(Y);
}
function Lk() {
    for(; null !== Y && !cc();)Uk(Y);
}
function Uk(a) {
    var b = Vk(a.alternate, a, fj);
    a.memoizedProps = a.pendingProps;
    null === b ? Sk(a) : Y = b;
    nk.current = null;
}
function Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Ej(c, b, fj), null !== c) {
                Y = c;
                return;
            }
        } else {
            c = Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Pk(a, b, c) {
    var d = C, e = ok.transition;
    try {
        ok.transition = null, C = 1, Wk(a, b, c, d);
    } finally{
        ok.transition = e, C = d;
    }
    return null;
}
function Wk(a, b, c, d) {
    do Hk();
    while (null !== wk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Bc(a, f);
    a === Q && (Y = Q = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || vk || (vk = !0, Fk(hc, function() {
        Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = ok.transition;
        ok.transition = null;
        var g = C;
        C = 1;
        var h = K;
        K |= 4;
        nk.current = null;
        Oj(a, c);
        dk(c, a);
        Oe(Df);
        dd = !!Cf;
        Df = Cf = null;
        a.current = c;
        hk(c, a, e);
        dc();
        K = h;
        C = g;
        ok.transition = f;
    } else a.current = c;
    vk && (vk = !1, wk = a, xk = e);
    f = a.pendingLanes;
    0 === f && (Ri = null);
    mc(c.stateNode, d);
    Dk(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (Oi) throw Oi = !1, a = Pi, Pi = null, a;
    0 !== (xk & 1) && 0 !== a.tag && Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === zk ? yk++ : (yk = 0, zk = a) : yk = 0;
    jg();
    return null;
}
function Hk() {
    if (null !== wk) {
        var a = Dc(xk), b = ok.transition, c = C;
        try {
            ok.transition = null;
            C = 16 > a ? 16 : a;
            if (null === wk) var d = !1;
            else {
                a = wk;
                wk = null;
                xk = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                var e = K;
                K |= 4;
                for(V = a.current; null !== V;){
                    var f = V, g = f.child;
                    if (0 !== (V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(V = l; null !== V;){
                                    var m = V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, V = q;
                                    else for(; null !== V;){
                                        m = V;
                                        var r = m.sibling, y = m.return;
                                        Sj(m);
                                        if (m === l) {
                                            V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            V = r;
                                            break;
                                        }
                                        V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, V = g;
                    else b: for(; null !== V;){
                        f = V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            V = x;
                            break b;
                        }
                        V = f.return;
                    }
                }
                var w = a.current;
                for(V = w; null !== V;){
                    g = V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, V = u;
                    else b: for(g = w; null !== V;){
                        h = V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Qj(9, h);
                            }
                        } catch (na) {
                            W(h, h.return, na);
                        }
                        if (h === g) {
                            V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            V = F;
                            break b;
                        }
                        V = h.return;
                    }
                }
                K = e;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, ok.transition = b;
        }
    }
    return !1;
}
function Xk(a, b, c) {
    b = Ji(c, b);
    b = Ni(a, b, 1);
    a = nh(a, b, 1);
    b = R();
    null !== a && (Ac(a, 1, b), Dk(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ri || !Ri.has(d))) {
                a = Ji(c, a);
                a = Qi(b, a, 1);
                b = nh(b, a, 1);
                a = R();
                null !== b && (Ac(b, 1, a), Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = R();
    a.pingedLanes |= a.suspendedLanes & c;
    Q === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - fk ? Kk(a, 0) : rk |= c);
    Dk(a, b);
}
function Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = R();
    a = ih(a, b);
    null !== a && (Ac(a, b, c), Dk(a, c));
}
function uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Yk(a, c);
}
function bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Yk(a, c);
}
var Vk;
Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Wf.current) dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return dh = !1, yj(a, b, c);
            dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else dh = !1, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            ij(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            ch(b, c);
            e = Nh(null, b, d, a, e, c);
            var f = Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f = !0, cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, kh(b), e.updater = Ei, b.stateNode = e, e._reactInternals = b, Ii(b, d, a, c), b = jj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && vg(b), Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = Zk(d);
                a = Ci(d, a);
                switch(e){
                    case 0:
                        b = cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $i(null, b, d, Ci(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), hj(a, b, d, e, c);
        case 3:
            a: {
                kj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                lh(a, b);
                qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Ji(Error(p(423)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Ji(Error(p(424)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else for(yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = !0, zg = null, c = Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Ig();
                    if (d === e) {
                        b = Zi(a, b, c);
                        break a;
                    }
                    Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Ah(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f && Ef(d, f) && (b.flags |= 32), gj(a, b), Xi(a, b, g, c), b.child;
        case 6:
            return null === a && Eg(b), null;
        case 13:
            return oj(a, b, c);
        case 4:
            return yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Ug(b, null, d, c) : Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), Yi(a, b, d, e, c);
        case 7:
            return Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (He(f.value, g)) {
                        if (f.children === e.children && !Wf.current) {
                            b = Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, ch(b, c), e = eh(e), d = d(e), b.flags |= 1, Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = Ci(d, b.pendingProps), e = Ci(d.type, e), $i(a, b, d, e, c);
        case 15:
            return bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), ij(a, b), b.tag = 1, Zf(d) ? (a = !0, cg(b)) : a = !1, ch(b, c), Gi(b, d, e), Ii(b, d, e, c), jj(null, b, d, !0, a, c);
        case 19:
            return xj(a, b, c);
        case 22:
            return dj(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Fk(a, b) {
    return ac(a, b);
}
function $k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function Bg(a, b, c, d) {
    return new $k(a, b, c, d);
}
function aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Zk(a) {
    if ("function" === typeof a) return aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return Tg(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a;
        case Ea:
            return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Tg(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function pj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function Qg(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function Sg(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function bl(a, b, c, d, e, f, g, h, k) {
    a = new al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    kh(f);
    return a;
}
function cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function dl(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Zf(c)) return bg(a, c, b);
    }
    return b;
}
function el(a, b, c, d, e, f, g, h, k) {
    a = bl(c, d, !0, a, e, f, g, h, k);
    a.context = dl(null);
    c = a.current;
    d = R();
    e = yi(c);
    f = mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    nh(c, f, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Dk(a, d);
    return a;
}
function fl(a, b, c, d) {
    var e = b.current, f = R(), g = yi(e);
    c = dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = nh(e, b, g);
    null !== a && (gi(a, e, g, f), oh(a, e, g));
    return g;
}
function gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function il(a, b) {
    hl(a, b);
    (a = a.alternate) && hl(a, b);
}
function jl() {
    return null;
}
var kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function ll(a) {
    this._internalRoot = a;
}
ml.prototype.render = ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    fl(a, b, null, null);
};
ml.prototype.unmount = ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Rk(function() {
            fl(null, a, null, null);
        });
        b[uf] = null;
    }
};
function ml(a) {
    this._internalRoot = a;
}
ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
        Qc.splice(c, 0, a);
        0 === c && Vc(a);
    }
};
function nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function pl() {}
function ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = gl(g);
                f.call(a);
            };
        }
        var g = el(b, d, a, 0, null, !1, !1, "", pl);
        a._reactRootContainer = g;
        a[uf] = g.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = gl(k);
            h.call(a);
        };
    }
    var k = bl(a, 0, !1, null, null, !1, !1, "", pl);
    a._reactRootContainer = k;
    a[uf] = k.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Rk(function() {
        fl(b, k, c, d);
    });
    return k;
}
function rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = gl(g);
                h.call(a);
            };
        }
        fl(b, g, a, e);
    } else g = ql(c, b, a, e, d);
    return gl(g);
}
Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = tc(b.pendingLanes);
                0 !== c && (Cc(b, c | 1), Dk(b, B()), 0 === (K & 6) && (Gj = B() + 500, jg()));
            }
            break;
        case 13:
            Rk(function() {
                var b = ih(a, 1);
                if (null !== b) {
                    var c = R();
                    gi(b, a, 1, c);
                }
            }), il(a, 1);
    }
};
Fc = function(a) {
    if (13 === a.tag) {
        var b = ih(a, 134217728);
        if (null !== b) {
            var c = R();
            gi(b, a, 134217728, c);
        }
        il(a, 134217728);
    }
};
Gc = function(a) {
    if (13 === a.tag) {
        var b = yi(a), c = ih(a, b);
        if (null !== c) {
            var d = R();
            gi(c, a, b, d);
        }
        il(a, b);
    }
};
Hc = function() {
    return C;
};
Ic = function(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Qk;
Hb = Rk;
var sl = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Qk
    ]
}, tl = {
    findFiberByHostInstance: Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var ul = {
    bundleType: tl.bundleType,
    version: tl.version,
    rendererPackageName: tl.rendererPackageName,
    rendererConfig: tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: tl.findFiberByHostInstance || jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!vl.isDisabled && vl.supportsFiber) try {
        kc = vl.inject(ul), lc = vl;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!nl(b)) throw Error(p(200));
    return cl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!nl(a)) throw Error(p(299));
    var c = !1, d = "", e = kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = bl(a, 1, !1, null, null, c, !1, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ll(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Rk(a);
};
exports.hydrate = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!nl(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[uf] = b.current;
    sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new ml(b);
};
exports.render = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!ol(a)) throw Error(p(40));
    return a._reactRootContainer ? (Rk(function() {
        rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[uf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Qk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!ol(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return rl(a, b, c, !1, d);
};
exports.version = "18.3.1-next-f1338f8080-20240426";

},{"5393afc8c463ef07":"7d7jl","ece50e903283a22f":"dj4jZ"}],"dj4jZ":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"huJ1Z"}],"huJ1Z":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function() {
        U.postMessage(null);
    };
} else S = function() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"hhXgL":[function(require,module,exports,__globalThis) {
/**
 * React Router DOM v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _reactRouter.AbortedDeferredError));
parcelHelpers.export(exports, "Await", ()=>(0, _reactRouter.Await));
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _reactRouter.MemoryRouter));
parcelHelpers.export(exports, "Navigate", ()=>(0, _reactRouter.Navigate));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _reactRouter.NavigationType));
parcelHelpers.export(exports, "Outlet", ()=>(0, _reactRouter.Outlet));
parcelHelpers.export(exports, "Route", ()=>(0, _reactRouter.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _reactRouter.Router));
parcelHelpers.export(exports, "Routes", ()=>(0, _reactRouter.Routes));
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>(0, _reactRouter.UNSAFE_DataRouterContext));
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>(0, _reactRouter.UNSAFE_DataRouterStateContext));
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>(0, _reactRouter.UNSAFE_LocationContext));
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>(0, _reactRouter.UNSAFE_NavigationContext));
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>(0, _reactRouter.UNSAFE_RouteContext));
parcelHelpers.export(exports, "UNSAFE_useRouteId", ()=>(0, _reactRouter.UNSAFE_useRouteId));
parcelHelpers.export(exports, "createMemoryRouter", ()=>(0, _reactRouter.createMemoryRouter));
parcelHelpers.export(exports, "createPath", ()=>(0, _reactRouter.createPath));
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>(0, _reactRouter.createRoutesFromChildren));
parcelHelpers.export(exports, "createRoutesFromElements", ()=>(0, _reactRouter.createRoutesFromElements));
parcelHelpers.export(exports, "defer", ()=>(0, _reactRouter.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _reactRouter.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _reactRouter.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _reactRouter.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _reactRouter.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _reactRouter.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _reactRouter.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _reactRouter.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _reactRouter.redirectDocument));
parcelHelpers.export(exports, "renderMatches", ()=>(0, _reactRouter.renderMatches));
parcelHelpers.export(exports, "replace", ()=>(0, _reactRouter.replace));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _reactRouter.resolvePath));
parcelHelpers.export(exports, "useActionData", ()=>(0, _reactRouter.useActionData));
parcelHelpers.export(exports, "useAsyncError", ()=>(0, _reactRouter.useAsyncError));
parcelHelpers.export(exports, "useAsyncValue", ()=>(0, _reactRouter.useAsyncValue));
parcelHelpers.export(exports, "useBlocker", ()=>(0, _reactRouter.useBlocker));
parcelHelpers.export(exports, "useHref", ()=>(0, _reactRouter.useHref));
parcelHelpers.export(exports, "useInRouterContext", ()=>(0, _reactRouter.useInRouterContext));
parcelHelpers.export(exports, "useLoaderData", ()=>(0, _reactRouter.useLoaderData));
parcelHelpers.export(exports, "useLocation", ()=>(0, _reactRouter.useLocation));
parcelHelpers.export(exports, "useMatch", ()=>(0, _reactRouter.useMatch));
parcelHelpers.export(exports, "useMatches", ()=>(0, _reactRouter.useMatches));
parcelHelpers.export(exports, "useNavigate", ()=>(0, _reactRouter.useNavigate));
parcelHelpers.export(exports, "useNavigation", ()=>(0, _reactRouter.useNavigation));
parcelHelpers.export(exports, "useNavigationType", ()=>(0, _reactRouter.useNavigationType));
parcelHelpers.export(exports, "useOutlet", ()=>(0, _reactRouter.useOutlet));
parcelHelpers.export(exports, "useOutletContext", ()=>(0, _reactRouter.useOutletContext));
parcelHelpers.export(exports, "useParams", ()=>(0, _reactRouter.useParams));
parcelHelpers.export(exports, "useResolvedPath", ()=>(0, _reactRouter.useResolvedPath));
parcelHelpers.export(exports, "useRevalidator", ()=>(0, _reactRouter.useRevalidator));
parcelHelpers.export(exports, "useRouteError", ()=>(0, _reactRouter.useRouteError));
parcelHelpers.export(exports, "useRouteLoaderData", ()=>(0, _reactRouter.useRouteLoaderData));
parcelHelpers.export(exports, "useRoutes", ()=>(0, _reactRouter.useRoutes));
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", ()=>(0, _router.UNSAFE_ErrorResponseImpl));
//#endregion
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "ScrollRestoration", ()=>ScrollRestoration);
parcelHelpers.export(exports, "UNSAFE_FetchersContext", ()=>FetchersContext);
parcelHelpers.export(exports, "UNSAFE_ViewTransitionContext", ()=>ViewTransitionContext);
parcelHelpers.export(exports, "UNSAFE_useScrollRestoration", ()=>useScrollRestoration);
parcelHelpers.export(exports, "createBrowserRouter", ()=>createBrowserRouter);
parcelHelpers.export(exports, "createHashRouter", ()=>createHashRouter);
parcelHelpers.export(exports, "createSearchParams", ()=>createSearchParams);
parcelHelpers.export(exports, "unstable_HistoryRouter", ()=>HistoryRouter);
parcelHelpers.export(exports, "unstable_usePrompt", ()=>usePrompt);
parcelHelpers.export(exports, "useBeforeUnload", ()=>useBeforeUnload);
parcelHelpers.export(exports, "useFetcher", ()=>useFetcher);
parcelHelpers.export(exports, "useFetchers", ()=>useFetchers);
parcelHelpers.export(exports, "useFormAction", ()=>useFormAction);
parcelHelpers.export(exports, "useLinkClickHandler", ()=>useLinkClickHandler);
parcelHelpers.export(exports, "useSearchParams", ()=>useSearchParams);
parcelHelpers.export(exports, "useSubmit", ()=>useSubmit);
parcelHelpers.export(exports, "useViewTransitionState", ()=>useViewTransitionState);
var _react = require("react");
var _reactDom = require("react-dom");
var _reactRouter = require("react-router");
var _router = require("@remix-run/router");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const defaultMethod = "get";
const defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function isButtonElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function createSearchParams(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = createSearchParams(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
    if (_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        _formDataSupportsSubmitter = false;
    } catch (e) {
        _formDataSupportsSubmitter = true;
    }
    return _formDataSupportsSubmitter;
}
const supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function getFormEncType(encType) {
    if (encType != null && !supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if (isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(target);
    } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("formenctype")) || getFormEncType(form.getAttribute("enctype")) || defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!isFormDataSubmitterSupported()) {
            let { name, type, value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if (isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = defaultMethod;
        action = null;
        encType = defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action,
        method: method.toLowerCase(),
        encType,
        formData,
        body
    };
}
const _excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], _excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], _excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function createBrowserRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function createHashRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = _extends({}, state, {
        errors: deserializeErrors(state.errors)
    });
    return state;
}
function deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, _router.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const ViewTransitionContext = /*#__PURE__*/ _react.createContext({
    isTransitioning: false
});
const FetchersContext = /*#__PURE__*/ _react.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const START_TRANSITION = "startTransition";
const startTransitionImpl = _react[START_TRANSITION];
const FLUSH_SYNC = "flushSync";
const flushSyncImpl = _reactDom[FLUSH_SYNC];
const USE_ID = "useId";
const useIdImpl = _react[USE_ID];
function startTransitionSafe(cb) {
    if (startTransitionImpl) startTransitionImpl(cb);
    else cb();
}
function flushSyncSafe(cb) {
    if (flushSyncImpl) flushSyncImpl(cb);
    else cb();
}
class Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    let { fallbackElement, router, future } = _ref;
    let [state, setStateImpl] = _react.useState(router.state);
    let [pendingState, setPendingState] = _react.useState();
    let [vtContext, setVtContext] = _react.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = _react.useState();
    let [transition, setTransition] = _react.useState();
    let [interruption, setInterruption] = _react.useState();
    let fetcherData = _react.useRef(new Map());
    let { v7_startTransition } = future || {};
    let optInStartTransition = _react.useCallback((cb)=>{
        if (v7_startTransition) startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = _react.useCallback((newState, _ref2)=>{
        let { deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    _react.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    _react.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    _react.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    _react.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    _react.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = _react.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(FetchersContext.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ _react.createElement(ViewTransitionContext.Provider, {
        value: vtContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const MemoizedDataRoutes = /*#__PURE__*/ _react.memo(DataRoutes);
function DataRoutes(_ref3) {
    let { routes, future, state } = _ref3;
    return (0, _reactRouter.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function BrowserRouter(_ref4) {
    let { basename, children, future, window: window1 } = _ref4;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function HashRouter(_ref5) {
    let { basename, children, future, window: window1 } = _ref5;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function HistoryRouter(_ref6) {
    let { basename, children, future, history } = _ref6;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const Link = /*#__PURE__*/ _react.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick, relative, reloadDocument, replace, state, target, to, preventScrollReset, viewTransition } = _ref7, rest = _objectWithoutPropertiesLoose(_ref7, _excluded);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if (isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, _router.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, _reactRouter.useHref)(to, {
        relative
    });
    let internalOnClick = useLinkClickHandler(to, {
        replace,
        state,
        target,
        preventScrollReset,
        relative,
        viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    _react.createElement("a", _extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const NavLink = /*#__PURE__*/ _react.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive = false, className: classNameProp = "", end = false, style: styleProp, to, viewTransition, children } = _ref8, rest = _objectWithoutPropertiesLoose(_ref8, _excluded2);
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, _reactRouter.useLocation)();
    let routerState = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    let { navigator, basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useViewTransitionState(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, _router.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive,
        isPending,
        isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ _react.createElement(Link, _extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const Form = /*#__PURE__*/ _react.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey, navigate, reloadDocument, replace, state, method = defaultMethod, action, onSubmit, relative, preventScrollReset, viewTransition } = _ref9, props = _objectWithoutPropertiesLoose(_ref9, _excluded3);
    let submit = useSubmit();
    let formAction = useFormAction(action, {
        relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey,
            method: submitMethod,
            navigate,
            replace,
            state,
            relative,
            preventScrollReset,
            viewTransition
        });
    };
    return /*#__PURE__*/ _react.createElement("form", _extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function ScrollRestoration(_ref0) {
    let { getKey, storageKey } = _ref0;
    useScrollRestoration({
        getKey,
        storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})(DataRouterHook || (DataRouterHook = {}));
var DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})(DataRouterStateHook || (DataRouterStateHook = {}));
// Internal hooks
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext((0, _reactRouter.UNSAFE_DataRouterContext));
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function useLinkClickHandler(to, _temp) {
    let { target, replace: replaceProp, state, preventScrollReset, relative, viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, _reactRouter.useNavigate)();
    let location = (0, _reactRouter.useLocation)();
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative
    });
    return _react.useCallback((event)=>{
        if (shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, _reactRouter.createPath)(location) === (0, _reactRouter.createPath)(path);
            navigate(to, {
                replace,
                state,
                preventScrollReset,
                relative,
                viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function useSearchParams(defaultInit) {
    let defaultSearchParamsRef = _react.useRef(createSearchParams(defaultInit));
    let hasSetSearchParamsRef = _react.useRef(false);
    let location = (0, _reactRouter.useLocation)();
    let searchParams = _react.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, _reactRouter.useNavigate)();
    let setSearchParams = _react.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = createSearchParams(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let fetcherId = 0;
let getUniqueFetcherId = ()=>"__" + String(++fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function useSubmit() {
    let { router } = useDataRouterContext(DataRouterHook.UseSubmit);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let currentRouteId = (0, _reactRouter.UNSAFE_useRouteId)();
    return _react.useCallback(function(target, options) {
        if (options === void 0) options = {};
        validateClientSideSubmission();
        let { action, method, encType, formData, body } = getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData,
                body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData,
            body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function useFormAction(action, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let routeContext = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    !routeContext && (0, _router.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = _extends({}, (0, _reactRouter.useResolvedPath)(action ? action : ".", {
        relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, _reactRouter.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, _reactRouter.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function useFetcher(_temp3) {
    var _route$matches;
    let { key } = _temp3 === void 0 ? {} : _temp3;
    let { router } = useDataRouterContext(DataRouterHook.UseFetcher);
    let state = useDataRouterState(DataRouterStateHook.UseFetcher);
    let fetcherData = _react.useContext(FetchersContext);
    let route = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, _router.UNSAFE_invariant)(false);
    !route && (0, _router.UNSAFE_invariant)(false);
    !(routeId != null) && (0, _router.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = useIdImpl ? useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = _react.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey(getUniqueFetcherId());
    // Registration/cleanup
    _react.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = _react.useCallback((href, opts)=>{
        !routeId && (0, _router.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = useSubmit();
    let submit = _react.useCallback((target, opts)=>{
        submitImpl(target, _extends({}, opts, {
            navigate: false,
            fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = _react.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
            return /*#__PURE__*/ _react.createElement(Form, _extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, _router.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = _react.useMemo(()=>_extends({
            Form: FetcherForm,
            submit,
            load
        }, fetcher, {
            data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function useFetchers() {
    let state = useDataRouterState(DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref1)=>{
        let [key, fetcher] = _ref1;
        return _extends({}, fetcher, {
            key
        });
    });
}
const SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function useScrollRestoration(_temp4) {
    let { getKey, storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router } = useDataRouterContext(DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition, preventScrollReset } = useDataRouterState(DataRouterStateHook.UseScrollRestoration);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let location = (0, _reactRouter.useLocation)();
    let matches = (0, _reactRouter.useMatches)();
    let navigation = (0, _reactRouter.useNavigation)();
    // Trigger manual scroll restoration while we're active
    _react.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    usePageHide(_react.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify(savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey(_extends({}, location, {
                    pathname: (0, _router.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration(savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function useBeforeUnload(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function usePageHide(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function usePrompt(_ref10) {
    let { when, message } = _ref10;
    let blocker = (0, _reactRouter.useBlocker)(when);
    _react.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    _react.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function useViewTransitionState(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = _react.useContext(ViewTransitionContext);
    !(vtContext != null) && (0, _router.UNSAFE_invariant)(false);
    let { basename } = useDataRouterContext(DataRouterHook.useViewTransitionState);
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, _router.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, _router.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, _router.matchPath)(path.pathname, nextPath) != null || (0, _router.matchPath)(path.pathname, currentPath) != null;
}

},{"react":"7d7jl","react-dom":"6ZjMP","react-router":[["createPath","2256I"],["Outlet","bYbo7"],["Router","bYbo7"],["UNSAFE_DataRouterContext","bYbo7"],["UNSAFE_DataRouterStateContext","bYbo7"],["UNSAFE_logV6DeprecationWarnings","bYbo7"],["UNSAFE_mapRouteProperties","bYbo7"],["UNSAFE_NavigationContext","bYbo7"],["UNSAFE_RouteContext","bYbo7"],["UNSAFE_useRouteId","bYbo7"],["UNSAFE_useRoutesImpl","bYbo7"],["useBlocker","bYbo7"],["useHref","bYbo7"],["useLocation","bYbo7"],["useMatches","bYbo7"],["useNavigate","bYbo7"],["useNavigation","bYbo7"],["useResolvedPath","bYbo7"],["useRouteError","bYbo7"]],"@remix-run/router":"2256I","@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"2256I":[function(require,module,exports,__globalThis) {
/**
 * @remix-run/router v1.23.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
//#endregion
parcelHelpers.export(exports, "AbortedDeferredError", ()=>AbortedDeferredError);
parcelHelpers.export(exports, "Action", ()=>Action);
parcelHelpers.export(exports, "IDLE_BLOCKER", ()=>IDLE_BLOCKER);
parcelHelpers.export(exports, "IDLE_FETCHER", ()=>IDLE_FETCHER);
parcelHelpers.export(exports, "IDLE_NAVIGATION", ()=>IDLE_NAVIGATION);
parcelHelpers.export(exports, "UNSAFE_DEFERRED_SYMBOL", ()=>UNSAFE_DEFERRED_SYMBOL);
parcelHelpers.export(exports, "UNSAFE_DeferredData", ()=>DeferredData);
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", ()=>ErrorResponseImpl);
parcelHelpers.export(exports, "UNSAFE_convertRouteMatchToUiMatch", ()=>convertRouteMatchToUiMatch);
parcelHelpers.export(exports, "UNSAFE_convertRoutesToDataRoutes", ()=>convertRoutesToDataRoutes);
parcelHelpers.export(exports, "UNSAFE_decodePath", ()=>decodePath);
parcelHelpers.export(exports, "UNSAFE_getResolveToMatches", ()=>getResolveToMatches);
parcelHelpers.export(exports, "UNSAFE_invariant", ()=>invariant);
parcelHelpers.export(exports, "UNSAFE_warning", ()=>warning);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "createPath", ()=>createPath);
parcelHelpers.export(exports, "createRouter", ()=>createRouter);
parcelHelpers.export(exports, "createStaticHandler", ()=>createStaticHandler);
parcelHelpers.export(exports, "data", ()=>data);
parcelHelpers.export(exports, "defer", ()=>defer);
parcelHelpers.export(exports, "generatePath", ()=>generatePath);
parcelHelpers.export(exports, "getStaticContextFromError", ()=>getStaticContextFromError);
parcelHelpers.export(exports, "getToPathname", ()=>getToPathname);
parcelHelpers.export(exports, "isDataWithResponseInit", ()=>isDataWithResponseInit);
parcelHelpers.export(exports, "isDeferredData", ()=>isDeferredData);
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>isRouteErrorResponse);
parcelHelpers.export(exports, "joinPaths", ()=>joinPaths);
parcelHelpers.export(exports, "json", ()=>json);
parcelHelpers.export(exports, "matchPath", ()=>matchPath);
parcelHelpers.export(exports, "matchRoutes", ()=>matchRoutes);
parcelHelpers.export(exports, "normalizePathname", ()=>normalizePathname);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "redirect", ()=>redirect);
parcelHelpers.export(exports, "redirectDocument", ()=>redirectDocument);
parcelHelpers.export(exports, "replace", ()=>replace);
parcelHelpers.export(exports, "resolvePath", ()=>resolvePath);
parcelHelpers.export(exports, "resolveTo", ()=>resolveTo);
parcelHelpers.export(exports, "stripBasename", ()=>stripBasename);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var Action;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
const PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function createMemoryHistory(options) {
    if (options === void 0) options = {};
    let { initialEntries = [
        "/"
    ], initialIndex, v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = Action.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = Action.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = Action.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = Action.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action,
                location: nextLocation,
                delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function createBrowserHistory(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname, search, hash } = window1.location;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function createHashHistory(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname = "/", search = "", hash = "" } = parsePath(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = _extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to, {
        state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function createPath(_ref) {
    let { pathname = "/", search = "", hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function parsePath(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = Action.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState(_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = Action.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action,
            location: history.location,
            delta
        });
    }
    function push(to, state) {
        action = Action.Push;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = Action.Replace;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : createPath(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        invariant(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push,
        replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})(ResultType || (ResultType = {}));
const immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function convertRoutesToDataRoutes(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if (isIndexRoute(route)) {
            let indexRoute = _extends({}, route, mapRouteProperties(route), {
                id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = _extends({}, route, mapRouteProperties(route), {
                id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function matchRoutes(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    let pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    let matches = null;
    let decoded = decodePath(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)// Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    matches = matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    let { route, pathname, params } = match;
    return {
        id: route.id,
        pathname,
        params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route
        };
        if (meta.relativePath.startsWith("/")) {
            invariant(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path,
            score: computeScore(path, route.index),
            routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const paramRe = /^:[\w-]+$/;
const dynamicSegmentValue = 3;
const indexRouteValue = 2;
const emptySegmentValue = 1;
const staticSegmentValue = 10;
const splatPenalty = -2;
const isSplat = (s)=>s === "*";
function computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter((s)=>!isSplat(s)).reduce((score, segment)=>score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue), initialScore);
}
function compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function generatePath(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            invariant(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName, isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params,
        pathname: matchedPathname,
        pathnameBase,
        pattern
    };
}
function compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        warning(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function resolvePath(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search = "", hash = "" } = typeof to === "string" ? parsePath(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = resolvePathname(toPathname.substring(1), "/");
        else pathname = resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function getResolveToMatches(matches, v7_relativeSplatPath) {
    let pathMatches = getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = _extends({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = resolvePath(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? parsePath(to).pathname : to.pathname;
}
const removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
/**
 * @private
 */ const joinPaths = (paths)=>removeDoubleSlashes(paths.join("/"));
/**
 * @private
 */ const normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const json = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), _extends({}, responseInit, {
        headers
    }));
};
class DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function data(data, init) {
    return new DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class AbortedDeferredError extends Error {
}
class DeferredData {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof AbortedDeferredError) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        invariant(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        invariant(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new AbortedDeferredError("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function unwrapTrackedPromise(value) {
    if (!isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const defer = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new DeferredData(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const redirect = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, _extends({}, responseInit, {
        headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const redirectDocument = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const replace = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class ErrorResponseImpl {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const validMutationMethods = new Set(validMutationMethodsArr);
const validRequestMethodsArr = [
    "get",
    ...validMutationMethodsArr
];
const validRequestMethods = new Set(validRequestMethodsArr);
const redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const IDLE_NAVIGATION = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const IDLE_FETCHER = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const IDLE_BLOCKER = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function createRouter(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = _extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches, route } = getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = Action.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location, delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation(Action.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = _extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, IDLE_BLOCKER));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === Action.Pop) ;
        else if (pendingAction === Action.Push) init.history.push(location, location.state);
        else if (pendingAction === Action.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === Action.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState(_extends({}, newState, {
            actionData,
            loaderData,
            historyAction: pendingAction,
            location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset,
            blockers
        }), {
            viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = Action.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path, submission, error } = normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = _extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = Action.Push;
        if (userReplace === true) historyAction = Action.Replace;
        else if (userReplace === false) ;
        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = Action.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation,
            nextLocation,
            historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, IDLE_BLOCKER);
                    updateState({
                        blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : matchRoutes(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches
            }, {
                flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error, notFoundMatches, route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            findNearestBoundary(matches).route.id,
            {
                type: ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if (isErrorResult(result) && isRouteErrorResponse(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited, matches: updatedMatches, loaderData, errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, _extends({
            matches: updatedMatches || matches
        }, getActionDataForCommit(pendingActionResult), {
            loaderData,
            errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = getSubmittingNavigation(location, submission);
        updateState({
            navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches, error, route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: ResultType.error,
                            error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: ResultType.error,
            error: getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if (isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission,
                replace
            });
            return {
                shortCircuited: true
            };
        }
        if (isDeferredResult(result)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = Action.Push;
            return {
                matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState(_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData
                } : {}), {
                    flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error, notFoundMatches, route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, _extends({
                matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = _extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return _extends({
            matches,
            loaderData,
            errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = matchRoutes(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync
            });
            return;
        }
        let { path, submission, error } = normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync
            });
            return;
        }
        let match = getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId,
            path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
            flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                updateFetcherState(key, getDoneFetcher(undefined));
                return;
            }
        } else {
            if (isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if (isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if (isDeferredResult(actionResult)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
        invariant(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset
        });
        redirect = findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            invariant(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches,
                loaderData,
                errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors,
                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if (isDeferredResult(result)) result = await resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if (isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if (isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        invariant(!isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission, fetcherSubmission, preventScrollReset, replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        invariant(location, "Expected a Location header on the redirect Response");
        location = normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if (ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                stripBasename(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? Action.Replace : Action.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod, formAction, formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if (redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: _extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation,
                // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if (isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: ResultType.redirect,
                response: normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: ResultType.error,
                    error: getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults,
            fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation, nextLocation, historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation,
            nextLocation,
            historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = getInternalRouterError(404, {
            pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches, route } = getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route,
            error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = matchRoutes(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize,
        subscribe,
        enableScrollRestoration,
        navigate,
        fetch,
        revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose,
        getBlocker,
        deleteBlocker,
        patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const UNSAFE_DEFERRED_SYMBOL = Symbol("deferred");
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = defaultMapRouteProperties;
    // Config driven behavior flags
    let future = _extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext, skipLoaderErrorBubbling, dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "HEAD") {
            let error = getInternalRouterError(405, {
                method
            });
            let { matches: methodNotAllowedMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if (isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return _extends({
            location,
            basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId, requestContext, dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
            method
        });
        else if (!matches) throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : getTargetMatch(matches, location);
        if (routeId && !match) throw getInternalRouterError(403, {
            pathname: location.pathname,
            routeId
        });
        else if (!match) // This should never hit I don't think?
        throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if (isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[UNSAFE_DEFERRED_SYMBOL] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if (isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return isResponse(result) ? result : _extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if (isDataStrategyResult(e) && isResponse(e.result)) {
                if (e.type === ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if (isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if (isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isDeferredResult(result)) {
            let error = getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if (isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return _extends({}, context, {
                statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: _extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return _extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && isErrorResult(pendingActionResult[1]) ? getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return _extends({}, context, {
            matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await callDataStrategyImpl(dataStrategy || defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if (isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if (isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes,
        query,
        queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function getStaticContextFromError(routes, context, error) {
    let newContext = _extends({}, context, {
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches, v7_relativeSplatPath), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !isSubmissionNavigation(opts)) return {
        path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path,
                submission: {
                    formMethod,
                    formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path,
                    submission: {
                        formMethod,
                        formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod,
        formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData,
        json: undefined,
        text: undefined
    };
    if (isMutationMethod(submission.formMethod)) return {
        path,
        submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = parsePath(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: createPath(parsedPath),
        submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if (isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return shouldRevalidateLoader(match, _extends({
            currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult,
            actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = matchRoutes(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = shouldRevalidateLoader(fetcherMatch, _extends({
            currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult,
            actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        invariant(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>isSameRoute(newRoute, existingRoute)));
    let newRoutes = convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    invariant(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        warning(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, _extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function defaultDataStrategy(_ref4) {
    let { matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: ResultType.data,
                result: undefined
            });
        };
        return _extends({}, match, {
            shouldLoad,
            resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request,
        params: matches[0].params,
        fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw getInternalRouterError(405, {
                        method: request.method,
                        pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw getInternalRouterError(404, {
                pathname
            });
        } else result = await runHandler(handler);
        invariant(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result, type } = dataStrategyResult;
    if (isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: ResultType.error,
                error: e
            };
        }
        if (type === ResultType.error) return {
            type: ResultType.error,
            error: new ErrorResponseImpl(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: ResultType.data,
            data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === ResultType.error) {
        if (isDataWithResponseInit(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: ResultType.error,
                error: new ErrorResponseImpl(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: isRouteErrorResponse(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: ResultType.error,
            error: result,
            statusCode: isRouteErrorResponse(result) ? result.status : undefined
        };
    }
    if (isDeferredData(result)) {
        var _result$init5, _result$init6;
        return {
            type: ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if (isDataWithResponseInit(result)) {
        var _result$init7, _result$init8;
        return {
            type: ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if (ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL(stripHashFromPath(location)).toString();
    let init = {
        signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        let { formMethod, formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if (isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData,
        errors,
        statusCode: statusCode || 200,
        loaderHeaders
    };
}
function processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData, errors } = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key, match, controller } = rf;
        let result = fetcherResults[key];
        invariant(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if (isErrorResult(result)) {
            let boundaryMatch = findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = _extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        invariant(false, "Unhandled fetcher revalidation redirect");
        else if (isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        invariant(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData,
        errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = _extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route
            }
        ],
        route
    };
}
function getInternalRouterError(status, _temp5) {
    let { pathname, routeId, method, type, message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if (isRedirectResult(result)) return {
            key,
            result
        };
    }
}
function stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath(_extends({}, parsedPath, {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === ResultType.data || result.type === ResultType.error);
}
function isRedirectDataStrategyResultResult(result) {
    return isResponse(result.result) && redirectStatusCodes.has(result.result.status);
}
function isDeferredResult(result) {
    return result.type === ResultType.deferred;
}
function isErrorResult(result) {
    return result.type === ResultType.error;
}
function isRedirectResult(result) {
    return (result && result.type) === ResultType.redirect;
}
function isDataWithResponseInit(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function isDeferredData(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function isRedirectResponse(result) {
    if (!isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toLowerCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toLowerCase());
}
async function resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if (isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key, routeId, controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if (isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            invariant(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: ResultType.error,
            error: e
        };
    }
    return {
        type: ResultType.data,
        data: result.deferredData.data
    };
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function getTargetMatch(matches, location) {
    let search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    let { formMethod, formAction, formEncType, text, formData, json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod,
        formAction,
        formEncType,
        formData: undefined,
        json: undefined,
        text
    };
    else if (formData != null) return {
        formMethod,
        formAction,
        formEncType,
        formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod,
        formAction,
        formEncType,
        formData: undefined,
        json,
        text: undefined
    };
}
function getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data
        };
        return fetcher;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"bYbo7":[function(require,module,exports,__globalThis) {
/**
 * React Router v6.30.6
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _router.AbortedDeferredError));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _router.Action));
parcelHelpers.export(exports, "createPath", ()=>(0, _router.createPath));
parcelHelpers.export(exports, "defer", ()=>(0, _router.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _router.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _router.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _router.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _router.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _router.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _router.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _router.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _router.redirectDocument));
parcelHelpers.export(exports, "replace", ()=>(0, _router.replace));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _router.resolvePath));
parcelHelpers.export(exports, "Await", ()=>Await);
parcelHelpers.export(exports, "MemoryRouter", ()=>MemoryRouter);
parcelHelpers.export(exports, "Navigate", ()=>Navigate);
parcelHelpers.export(exports, "Outlet", ()=>Outlet);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "Routes", ()=>Routes);
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>DataRouterContext);
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>DataRouterStateContext);
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>LocationContext);
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>NavigationContext);
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>RouteContext);
parcelHelpers.export(exports, "UNSAFE_logV6DeprecationWarnings", ()=>logV6DeprecationWarnings);
parcelHelpers.export(exports, "UNSAFE_mapRouteProperties", ()=>mapRouteProperties);
parcelHelpers.export(exports, "UNSAFE_useRouteId", ()=>useRouteId);
parcelHelpers.export(exports, "UNSAFE_useRoutesImpl", ()=>useRoutesImpl);
parcelHelpers.export(exports, "createMemoryRouter", ()=>createMemoryRouter);
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "createRoutesFromElements", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "renderMatches", ()=>renderMatches);
parcelHelpers.export(exports, "useActionData", ()=>useActionData);
parcelHelpers.export(exports, "useAsyncError", ()=>useAsyncError);
parcelHelpers.export(exports, "useAsyncValue", ()=>useAsyncValue);
parcelHelpers.export(exports, "useBlocker", ()=>useBlocker);
parcelHelpers.export(exports, "useHref", ()=>useHref);
parcelHelpers.export(exports, "useInRouterContext", ()=>useInRouterContext);
parcelHelpers.export(exports, "useLoaderData", ()=>useLoaderData);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useMatch", ()=>useMatch);
parcelHelpers.export(exports, "useMatches", ()=>useMatches);
parcelHelpers.export(exports, "useNavigate", ()=>useNavigate);
parcelHelpers.export(exports, "useNavigation", ()=>useNavigation);
parcelHelpers.export(exports, "useNavigationType", ()=>useNavigationType);
parcelHelpers.export(exports, "useOutlet", ()=>useOutlet);
parcelHelpers.export(exports, "useOutletContext", ()=>useOutletContext);
parcelHelpers.export(exports, "useParams", ()=>useParams);
parcelHelpers.export(exports, "useResolvedPath", ()=>useResolvedPath);
parcelHelpers.export(exports, "useRevalidator", ()=>useRevalidator);
parcelHelpers.export(exports, "useRouteError", ()=>useRouteError);
parcelHelpers.export(exports, "useRouteLoaderData", ()=>useRouteLoaderData);
parcelHelpers.export(exports, "useRoutes", ()=>useRoutes);
var _react = require("react");
var _router = require("@remix-run/router");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const DataRouterContext = /*#__PURE__*/ _react.createContext(null);
const DataRouterStateContext = /*#__PURE__*/ _react.createContext(null);
const AwaitContext = /*#__PURE__*/ _react.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const NavigationContext = /*#__PURE__*/ _react.createContext(null);
const LocationContext = /*#__PURE__*/ _react.createContext(null);
const RouteContext = /*#__PURE__*/ _react.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const RouteErrorContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function useHref(to, _temp) {
    let { relative } = _temp === void 0 ? {} : _temp;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { basename, navigator } = _react.useContext(NavigationContext);
    let { hash, pathname, search } = useResolvedPath(to, {
        relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search,
        hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function useInRouterContext() {
    return _react.useContext(LocationContext) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function useLocation() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    return _react.useContext(LocationContext).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function useNavigationType() {
    return _react.useContext(LocationContext).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function useMatch(pattern) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { pathname } = useLocation();
    return _react.useMemo(()=>(0, _router.matchPath)(pattern, (0, _router.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function useIsomorphicLayoutEffect(cb) {
    let isStatic = _react.useContext(NavigationContext).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    _react.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function useNavigate() {
    let { isDataRoute } = _react.useContext(RouteContext);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let dataRouterContext = _react.useContext(DataRouterContext);
    let { basename, future, navigator } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const OutletContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function useOutletContext() {
    return _react.useContext(OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function useOutlet(context) {
    let outlet = _react.useContext(RouteContext).outlet;
    if (outlet) return /*#__PURE__*/ _react.createElement(OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function useParams() {
    let { matches } = _react.useContext(RouteContext);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function useResolvedPath(to, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { future } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return _react.useMemo(()=>(0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function useRoutes(routes, locationArg) {
    return useRoutesImpl(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function useRoutesImpl(routes, locationArg, dataRouterState, future) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { navigator } = _react.useContext(NavigationContext);
    let { matches: parentMatches } = _react.useContext(RouteContext);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = useLocation();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, _router.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, _router.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, _router.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = _renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        value: {
            location: _extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, _router.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function DefaultErrorComponent() {
    let error = useRouteError();
    let message = (0, _router.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ _react.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ _react.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const defaultErrorElement = /*#__PURE__*/ _react.createElement(DefaultErrorComponent, null);
class RenderErrorBoundary extends _react.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ _react.createElement(RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function RenderedRoute(_ref) {
    let { routeContext, match, children } = _ref;
    let dataRouterContext = _react.useContext(DataRouterContext);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
        value: routeContext
    }, children);
}
function _renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, _router.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData, errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ _react.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ _react.createElement(RenderedRoute, {
                match: match,
                routeContext: {
                    outlet,
                    matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ _react.createElement(RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}(DataRouterHook || {});
var DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}(DataRouterStateHook || {});
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext(DataRouterContext);
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext(DataRouterStateContext);
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
function useRouteContext(hookName) {
    let route = _react.useContext(RouteContext);
    !route && (0, _router.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function useCurrentRouteId(hookName) {
    let route = useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, _router.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function useRouteId() {
    return useCurrentRouteId(DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function useNavigation() {
    let state = useDataRouterState(DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function useRevalidator() {
    let dataRouterContext = useDataRouterContext(DataRouterHook.UseRevalidator);
    let state = useDataRouterState(DataRouterStateHook.UseRevalidator);
    return _react.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function useMatches() {
    let { matches, loaderData } = useDataRouterState(DataRouterStateHook.UseMatches);
    return _react.useMemo(()=>matches.map((m)=>(0, _router.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function useLoaderData() {
    let state = useDataRouterState(DataRouterStateHook.UseLoaderData);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function useRouteLoaderData(routeId) {
    let state = useDataRouterState(DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function useActionData() {
    let state = useDataRouterState(DataRouterStateHook.UseActionData);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function useRouteError() {
    var _state$errors;
    let error = _react.useContext(RouteErrorContext);
    let state = useDataRouterState(DataRouterStateHook.UseRouteError);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function useAsyncValue() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function useAsyncError() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._error;
}
let blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function useBlocker(shouldBlock) {
    let { router, basename } = useDataRouterContext(DataRouterHook.UseBlocker);
    let state = useDataRouterState(DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = _react.useState("");
    let blockerFunction = _react.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation, nextLocation, historyAction } = arg;
        return shouldBlock({
            currentLocation: _extends({}, currentLocation, {
                pathname: (0, _router.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: _extends({}, nextLocation, {
                pathname: (0, _router.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    _react.useEffect(()=>{
        let key = String(++blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    _react.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, _router.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function useNavigateStable() {
    let { router } = useDataRouterContext(DataRouterHook.UseNavigateStable);
    let id = useCurrentRouteId(DataRouterStateHook.UseNavigateStable);
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, _extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const alreadyWarned$1 = {};
function warningOnce(key, cond, message) {
    if (!cond && !alreadyWarned$1[key]) alreadyWarned$1[key] = true;
}
const alreadyWarned = {};
function warnOnce(key, message) {}
const logDeprecation = (flag, msg, link)=>warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function logV6DeprecationWarnings(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const START_TRANSITION = "startTransition";
const startTransitionImpl = _react[START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    let { fallbackElement, router, future } = _ref;
    let [state, setStateImpl] = _react.useState(router.state);
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        if (v7_startTransition && startTransitionImpl) startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    _react.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    _react.useEffect(()=>logV6DeprecationWarnings(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function DataRoutes(_ref2) {
    let { routes, future, state } = _ref2;
    return useRoutesImpl(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function MemoryRouter(_ref3) {
    let { basename, children, initialEntries, initialIndex, future } = _ref3;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createMemoryHistory)({
        initialEntries,
        initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>logV6DeprecationWarnings(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function Navigate(_ref4) {
    let { to, replace, state, relative } = _ref4;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { future, static: isStatic } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let navigate = useNavigate();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, _router.resolveTo)(to, (0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    _react.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace,
            state,
            relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function Outlet(props) {
    return useOutlet(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function Route(_props) {
    (0, _router.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function Router(_ref5) {
    let { basename: basenameProp = "/", children = null, location: locationProp, navigationType = (0, _router.Action).Pop, navigator, static: staticProp = false, future } = _ref5;
    !!useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = _react.useMemo(()=>({
            basename,
            navigator,
            static: staticProp,
            future: _extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, _router.parsePath)(locationProp);
    let { pathname = "/", search = "", hash = "", state = null, key = "default" } = locationProp;
    let locationContext = _react.useMemo(()=>{
        let trailingPathname = (0, _router.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search,
                hash,
                state,
                key
            },
            navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ _react.createElement(NavigationContext.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function Routes(_ref6) {
    let { children, location } = _ref6;
    return useRoutes(createRoutesFromChildren(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function Await(_ref7) {
    let { children, errorElement, resolve } = _ref7;
    return /*#__PURE__*/ _react.createElement(AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ _react.createElement(ResolveAwait, null, children));
}
var AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}(AwaitRenderStatus || {});
const neverSettledPromise = new Promise(()=>{});
class AwaitErrorBoundary extends _react.Component {
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children, errorElement, resolve } = this.props;
        let promise = null;
        let status = AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? AwaitRenderStatus.error : "_data" in promise ? AwaitRenderStatus.success : AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === AwaitRenderStatus.error && promise._error instanceof (0, _router.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw neverSettledPromise;
        if (status === AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function ResolveAwait(_ref8) {
    let { children } = _ref8;
    let data = useAsyncValue();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function createRoutesFromChildren(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    _react.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ _react.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === _react.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, createRoutesFromChildren(element.props.children, treePath));
            return;
        }
        !(element.type === Route) && (0, _router.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, _router.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = createRoutesFromChildren(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function renderMatches(matches) {
    return _renderMatches(matches);
}
function mapRouteProperties(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ _react.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ _react.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ _react.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function createMemoryRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes,
        mapRouteProperties,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

},{"react":"7d7jl","@remix-run/router":"2256I","@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"eQKMx":[function(require,module,exports,__globalThis) {
// src/components/Header.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _headerCss = require("./Header.css");
var _reactRouterDom = require("react-router-dom");
var _i18N = require("../../utils/i18n");
var _translations = require("../../utils/translations");
var _languageContext = require("../../utils/LanguageContext");
var _languageSelector = require("../LanguageSelector/LanguageSelector");
var _languageSelectorDefault = parcelHelpers.interopDefault(_languageSelector);
var _logoMarkSvg = require("url:../../../assets/logo-mark.svg");
var _logoMarkSvgDefault = parcelHelpers.interopDefault(_logoMarkSvg);
const Header = ({ scrolled: scrolled = false })=>{
    const { currentLang } = (0, _languageContext.useLanguage)();
    const { t } = (0, _translations.useTranslations)();
    const location = (0, _reactRouterDom.useLocation)();
    const pathLang = (0, _i18N.getLangFromPath)(location.pathname);
    const paths = (0, _i18N.getRoutePaths)(pathLang);
    const [menuOpen, setMenuOpen] = (0, _react.useState)(false);
    const [isScrolledLocal, setIsScrolledLocal] = (0, _react.useState)(false);
    const [isCondensing, setIsCondensing] = (0, _react.useState)(false);
    const navRef = (0, _react.useRef)(null);
    const toggleRef = (0, _react.useRef)(null);
    const firstLinkRef = (0, _react.useRef)(null);
    const isScrolledRef = (0, _react.useRef)(false);
    const isCondensingRef = (0, _react.useRef)(false);
    const condenseTimerRef = (0, _react.useRef)(null);
    const wasMenuOpenRef = (0, _react.useRef)(false);
    const isScrolled = scrolled || isScrolledLocal;
    const navLinks = [
        {
            to: paths.services,
            label: t('header', 'navigation.services', 'services')
        },
        {
            to: paths.lab,
            label: t('header', 'navigation.lab', 'lab')
        },
        {
            to: paths.gallery,
            label: t('header', 'navigation.gallery', 'gallery')
        },
        {
            to: paths.about,
            label: t('header', 'navigation.about', 'about')
        },
        {
            to: paths.contact,
            label: t('header', 'navigation.contact', 'contact')
        }
    ];
    // Get header tagline from translations
    const tagline = t('header', 'tagline', 'independent / creative / technology');
    const closeMenu = ()=>{
        setMenuOpen(false);
    };
    (0, _react.useEffect)(()=>{
        if (!menuOpen) return undefined;
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") {
                setMenuOpen(false);
                return;
            }
            if (event.key === "Tab") {
                var _navRef_current;
                const focusables = [
                    toggleRef.current,
                    ...Array.from(((_navRef_current = navRef.current) === null || _navRef_current === void 0 ? void 0 : _navRef_current.querySelectorAll("a, button")) || [])
                ].filter(Boolean);
                if (!focusables.length) return;
                const first = focusables[0];
                const last = focusables[focusables.length - 1];
                if (event.shiftKey && document.activeElement === first) {
                    event.preventDefault();
                    last.focus();
                } else if (!event.shiftKey && document.activeElement === last) {
                    event.preventDefault();
                    first.focus();
                }
            }
        };
        const handlePointer = (event)=>{
            const nav = navRef.current;
            const toggle = toggleRef.current;
            if (!nav || !toggle) return;
            if (nav.contains(event.target) || toggle.contains(event.target)) return;
            setMenuOpen(false);
        };
        window.addEventListener("keydown", handleKeyDown);
        window.addEventListener("pointerdown", handlePointer);
        return ()=>{
            window.removeEventListener("keydown", handleKeyDown);
            window.removeEventListener("pointerdown", handlePointer);
        };
    }, [
        menuOpen
    ]);
    (0, _react.useEffect)(()=>{
        if (!menuOpen) return undefined;
        const originalOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return ()=>{
            document.body.style.overflow = originalOverflow;
        };
    }, [
        menuOpen
    ]);
    (0, _react.useEffect)(()=>{
        var _toggleRef_current;
        if (menuOpen) window.requestAnimationFrame(()=>{
            var _firstLinkRef_current;
            (_firstLinkRef_current = firstLinkRef.current) === null || _firstLinkRef_current === void 0 ? void 0 : _firstLinkRef_current.focus();
        });
        else if (wasMenuOpenRef.current) (_toggleRef_current = toggleRef.current) === null || _toggleRef_current === void 0 ? void 0 : _toggleRef_current.focus();
        wasMenuOpenRef.current = menuOpen;
    }, [
        menuOpen
    ]);
    (0, _react.useEffect)(()=>{
        if (!menuOpen) return undefined;
        const targets = Array.from(document.querySelectorAll("main.app, .footer"));
        targets.forEach((el)=>{
            el.inert = true;
        });
        return ()=>{
            targets.forEach((el)=>{
                el.inert = false;
            });
        };
    }, [
        menuOpen
    ]);
    (0, _react.useEffect)(()=>{
        const handleResize = ()=>{
            if (window.innerWidth > 1024 && menuOpen) setMenuOpen(false);
        };
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, [
        menuOpen
    ]);
    (0, _react.useEffect)(()=>{
        isScrolledRef.current = isScrolledLocal;
    }, [
        isScrolledLocal
    ]);
    (0, _react.useEffect)(()=>{
        isCondensingRef.current = isCondensing;
    }, [
        isCondensing
    ]);
    (0, _react.useEffect)(()=>{
        const getScrollTop = ()=>window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
        const thresholdDown = 60;
        const thresholdUp = 36;
        const stopCondensing = ()=>{
            if (condenseTimerRef.current) {
                window.clearTimeout(condenseTimerRef.current);
                condenseTimerRef.current = null;
            }
            if (isCondensingRef.current) {
                isCondensingRef.current = false;
                setIsCondensing(false);
            }
        };
        const setScrolledImmediate = (nextValue)=>{
            if (isScrolledRef.current === nextValue) return;
            isScrolledRef.current = nextValue;
            setIsScrolledLocal(nextValue);
        };
        const startCondensing = ()=>{
            if (isScrolledRef.current || isCondensingRef.current) return;
            isCondensingRef.current = true;
            setIsCondensing(true);
            if (condenseTimerRef.current) window.clearTimeout(condenseTimerRef.current);
            condenseTimerRef.current = window.setTimeout(()=>{
                isScrolledRef.current = true;
                setIsScrolledLocal(true);
                isCondensingRef.current = false;
                setIsCondensing(false);
                condenseTimerRef.current = null;
            }, 220);
        };
        const updateScrolled = ()=>{
            const scrollTop = getScrollTop();
            const isDesktop = window.innerWidth > 1024;
            const currentlyScrolled = isScrolledRef.current;
            const shouldBeScrolled = currentlyScrolled ? scrollTop > thresholdUp : scrollTop > thresholdDown;
            if (isDesktop) {
                if (shouldBeScrolled) {
                    if (!currentlyScrolled) startCondensing();
                } else {
                    stopCondensing();
                    setScrolledImmediate(false);
                }
                return;
            }
            stopCondensing();
            setScrolledImmediate(shouldBeScrolled);
        };
        updateScrolled();
        window.addEventListener("scroll", updateScrolled, {
            passive: true
        });
        window.addEventListener("resize", updateScrolled);
        return ()=>{
            stopCondensing();
            window.removeEventListener("scroll", updateScrolled);
            window.removeEventListener("resize", updateScrolled);
        };
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
        className: "header",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `header-main${isScrolled ? " is-scrolled" : ""}${isCondensing ? " is-condensing" : ""}`,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "brand-wrap",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                            to: paths.home,
                            className: "brand",
                            "aria-label": "thewhizkind home",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    className: "brand-logo",
                                    src: (0, _logoMarkSvgDefault.default),
                                    alt: ""
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "brand-wordmark",
                                    children: "thewhizkind"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("nav", {
                        className: `nav-menu${menuOpen ? " is-open" : ""} ${menuOpen ? "" : "hidden"} lg:flex`,
                        "aria-label": "Primary",
                        id: "primary-navigation",
                        ref: navRef,
                        role: menuOpen ? "dialog" : undefined,
                        "aria-modal": menuOpen ? "true" : undefined,
                        children: [
                            navLinks.map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
                                    to: item.to,
                                    className: ({ isActive })=>`nav-link-item${isActive ? " active" : ""}`,
                                    "data-index": `0${index + 1}`,
                                    onClick: closeMenu,
                                    ref: index === 0 ? firstLinkRef : undefined,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: item.label
                                    })
                                }, item.to)),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "nav-menu-foot",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: "thewhizkind \u2014 index"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                        to: paths.principles,
                                        onClick: closeMenu,
                                        children: t('footer', 'footerLinks.principles', 'principles')
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "nav-language-selector",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _languageSelectorDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "nav-language-selector-mobile",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _languageSelectorDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: `nav-toggle${menuOpen ? " is-open" : ""} lg:hidden`,
                        "aria-label": menuOpen ? t('header', 'menu.close', 'Close menu') : t('header', 'menu.open', 'Open menu'),
                        "aria-expanded": menuOpen,
                        "aria-controls": "primary-navigation",
                        onClick: ()=>setMenuOpen((open)=>!open),
                        ref: toggleRef,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: "nav-toggle-lines",
                            "aria-hidden": "true",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "nav-toggle-line"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "nav-toggle-line"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "nav-toggle-line"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `nav-overlay${menuOpen ? " is-open" : ""}`,
                "aria-hidden": "true",
                onClick: closeMenu
            })
        ]
    });
};
exports.default = Header;

},{"react/jsx-runtime":"a7gVT","react":"7d7jl","./Header.css":"dkfL0","react-router-dom":"hhXgL","../../utils/i18n":"4Kl7i","../../utils/translations":"kdPrY","../../utils/LanguageContext":"5u50e","../LanguageSelector/LanguageSelector":"6txYo","url:../../../assets/logo-mark.svg":"ebLXg","@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"dkfL0":[function() {},{}],"4Kl7i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LANGUAGES", ()=>LANGUAGES);
parcelHelpers.export(exports, "DEFAULT_LANG", ()=>DEFAULT_LANG);
parcelHelpers.export(exports, "ROUTE_SLUGS", ()=>ROUTE_SLUGS);
parcelHelpers.export(exports, "getBrowserLang", ()=>getBrowserLang);
parcelHelpers.export(exports, "getLangFromPath", ()=>getLangFromPath);
parcelHelpers.export(exports, "getRoutePaths", ()=>getRoutePaths);
parcelHelpers.export(exports, "stripLangFromPath", ()=>stripLangFromPath);
parcelHelpers.export(exports, "switchLangPath", ()=>switchLangPath);
parcelHelpers.export(exports, "matchRouteKey", ()=>matchRouteKey);
parcelHelpers.export(exports, "getAllRouteKeys", ()=>getAllRouteKeys);
parcelHelpers.export(exports, "useLang", ()=>useLang);
parcelHelpers.export(exports, "getInitialLang", ()=>getInitialLang);
parcelHelpers.export(exports, "getLangFromPathWithFallback", ()=>getLangFromPathWithFallback);
var _reactRouterDom = require("react-router-dom");
const LANGUAGES = [
    "en",
    "de"
];
const DEFAULT_LANG = "en";
const ROUTE_SLUGS = {
    home: {
        en: "",
        de: ""
    },
    gallery: {
        en: "gallery",
        de: "gallery"
    },
    lab: {
        en: "lab",
        de: "lab"
    },
    services: {
        en: "services",
        de: "services"
    },
    about: {
        en: "about",
        de: "about"
    },
    contact: {
        en: "contact",
        de: "contact"
    },
    principles: {
        en: "principles",
        de: "principles"
    },
    store: {
        en: "store",
        de: "store"
    },
    nyx: {
        en: "nyx",
        de: "nyx"
    },
    invoiceMaker: {
        en: "invoice-maker",
        de: "invoice-maker"
    },
    privacy: {
        en: "privacy-policy",
        de: "privacy-policy"
    },
    disclaimer: {
        en: "legal-disclaimer",
        de: "legal-disclaimer"
    },
    accessibility: {
        en: "accessibility",
        de: "accessibility"
    }
};
const getBrowserLang = ()=>{
    if (typeof window !== 'undefined') {
        const browserLang = window.navigator.language || window.navigator.userLanguage || '';
        const lang = browserLang.split('-')[0].toLowerCase();
        // Check if browser language is supported
        if (LANGUAGES.includes(lang)) return lang;
        // Fallback: if browser language starts with supported language (e.g., 'de-DE' -> 'de')
        const baseLang = browserLang.split('-')[0].toLowerCase();
        if (LANGUAGES.includes(baseLang)) return baseLang;
    }
    return DEFAULT_LANG;
};
const getLangFromPath = (pathname = '')=>{
    if (typeof window === 'undefined') return DEFAULT_LANG;
    const path = pathname || window.location.pathname;
    const segments = path.split('/').filter(Boolean);
    if (segments.length > 0 && LANGUAGES.includes(segments[0])) return segments[0];
    return DEFAULT_LANG;
};
const getRoutePaths = (lang = DEFAULT_LANG)=>({
        home: lang === DEFAULT_LANG ? '/' : `/${lang}`,
        gallery: lang === DEFAULT_LANG ? `/${ROUTE_SLUGS.gallery[lang]}` : `/${lang}/${ROUTE_SLUGS.gallery[lang]}`,
        lab: lang === DEFAULT_LANG ? `/${ROUTE_SLUGS.lab[lang]}` : `/${lang}/${ROUTE_SLUGS.lab[lang]}`,
        services: lang === DEFAULT_LANG ? `/${ROUTE_SLUGS.services[lang]}` : `/${lang}/${ROUTE_SLUGS.services[lang]}`,
        about: lang === DEFAULT_LANG ? `/${ROUTE_SLUGS.about[lang]}` : `/${lang}/${ROUTE_SLUGS.about[lang]}`,
        contact: lang === DEFAULT_LANG ? `/${ROUTE_SLUGS.contact[lang]}` : `/${lang}/${ROUTE_SLUGS.contact[lang]}`,
        principles: lang === DEFAULT_LANG ? `/${ROUTE_SLUGS.principles[lang]}` : `/${lang}/${ROUTE_SLUGS.principles[lang]}`,
        store: lang === DEFAULT_LANG ? `/${ROUTE_SLUGS.store[lang]}` : `/${lang}/${ROUTE_SLUGS.store[lang]}`,
        nyx: lang === DEFAULT_LANG ? `/${ROUTE_SLUGS.nyx[lang]}` : `/${lang}/${ROUTE_SLUGS.nyx[lang]}`,
        invoiceMaker: lang === DEFAULT_LANG ? `/${ROUTE_SLUGS.invoiceMaker[lang]}` : `/${lang}/${ROUTE_SLUGS.invoiceMaker[lang]}`,
        privacy: lang === DEFAULT_LANG ? `/${ROUTE_SLUGS.privacy[lang]}` : `/${lang}/${ROUTE_SLUGS.privacy[lang]}`,
        disclaimer: lang === DEFAULT_LANG ? `/${ROUTE_SLUGS.disclaimer[lang]}` : `/${lang}/${ROUTE_SLUGS.disclaimer[lang]}`,
        accessibility: lang === DEFAULT_LANG ? `/${ROUTE_SLUGS.accessibility[lang]}` : `/${lang}/${ROUTE_SLUGS.accessibility[lang]}`
    });
const stripLangFromPath = (pathname)=>{
    const segments = pathname.split('/').filter(Boolean);
    const lang = segments[0];
    if (LANGUAGES.includes(lang)) return '/' + segments.slice(1).join('/');
    return pathname;
};
const switchLangPath = (pathname, targetLang = DEFAULT_LANG)=>{
    const segments = pathname.split('/').filter(Boolean);
    const currentLang = segments[0];
    // If current path has a language prefix, replace it
    if (LANGUAGES.includes(currentLang)) {
        const remainingPath = '/' + segments.slice(1).join('/');
        return targetLang === DEFAULT_LANG ? remainingPath : `/${targetLang}${remainingPath}`;
    }
    // If no language prefix, add it (except for default language)
    if (targetLang === DEFAULT_LANG) return pathname;
    return `/${targetLang}${pathname}`;
};
const matchRouteKey = (lang, pathname)=>{
    const normalized = pathname.replace(/\/+$/, "") || "/";
    const paths = getRoutePaths(lang);
    const entries = Object.entries(paths);
    for (const [key, value] of entries){
        if (normalized === value) return key;
    }
    return null;
};
const getAllRouteKeys = ()=>Object.keys(ROUTE_SLUGS);
const useLang = ()=>{
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const currentLang = getLangFromPath(location.pathname);
    const setLang = (lang)=>{
        // Store preference in localStorage
        try {
            window.localStorage.setItem('twk_lang', lang);
        } catch (e) {
            console.warn('Could not save language preference to localStorage:', e);
        }
        // Navigate to the same path with new language
        const newPath = switchLangPath(location.pathname, lang);
        navigate(newPath, {
            replace: true
        });
    };
    const getStoredLang = ()=>{
        try {
            return window.localStorage.getItem('twk_lang') || null;
        } catch (e) {
            return null;
        }
    };
    return {
        currentLang,
        setLang,
        getStoredLang,
        browserLang: getBrowserLang(),
        availableLangs: LANGUAGES
    };
};
const getInitialLang = ()=>{
    // Try localStorage first
    try {
        const stored = window.localStorage.getItem('twk_lang');
        if (stored && LANGUAGES.includes(stored)) return stored;
    } catch (e) {
    // localStorage not available
    }
    // Fallback to browser language
    const browserLang = getBrowserLang();
    if (LANGUAGES.includes(browserLang)) return browserLang;
    // Fallback to default
    return DEFAULT_LANG;
};
const getLangFromPathWithFallback = (pathname)=>{
    const langFromPath = getLangFromPath(pathname);
    const initialLang = getInitialLang();
    // If path has valid language, use it
    if (LANGUAGES.includes(langFromPath)) return langFromPath;
    // Otherwise use stored or browser preference
    return initialLang;
};

},{"react-router-dom":"hhXgL","@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"kdPrY":[function(require,module,exports,__globalThis) {
/**
 * Translation utility functions
 * This provides a simple interface for accessing translations throughout the app
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTranslation", ()=>getTranslation);
parcelHelpers.export(exports, "useTranslations", ()=>useTranslations);
parcelHelpers.export(exports, "translate", ()=>translate);
parcelHelpers.export(exports, "getAllTranslations", ()=>getAllTranslations);
// Export all translation namespaces for direct import if needed
parcelHelpers.export(exports, "commonTranslations", ()=>(0, _commonDefault.default));
parcelHelpers.export(exports, "headerTranslations", ()=>(0, _headerDefault.default));
parcelHelpers.export(exports, "footerTranslations", ()=>(0, _footerDefault.default));
parcelHelpers.export(exports, "homeTranslations", ()=>(0, _homeDefault.default));
parcelHelpers.export(exports, "aboutTranslations", ()=>(0, _aboutDefault.default));
parcelHelpers.export(exports, "contactTranslations", ()=>(0, _contactDefault.default));
parcelHelpers.export(exports, "serviceTranslations", ()=>(0, _serviceDefault.default));
parcelHelpers.export(exports, "labTranslations", ()=>(0, _labDefault.default));
parcelHelpers.export(exports, "principlesTranslations", ()=>(0, _principlesDefault.default));
parcelHelpers.export(exports, "privacyTranslations", ()=>(0, _privacyDefault.default));
parcelHelpers.export(exports, "disclaimerTranslations", ()=>(0, _disclaimerDefault.default));
parcelHelpers.export(exports, "accessibilityTranslations", ()=>(0, _accessibilityDefault.default));
parcelHelpers.export(exports, "galleryTranslations", ()=>(0, _galleryDefault.default));
parcelHelpers.export(exports, "acrossChaptersMapTranslations", ()=>(0, _acrossChaptersMapDefault.default));
var _react = require("react");
var _languageContext = require("./LanguageContext");
var _languageContextDefault = parcelHelpers.interopDefault(_languageContext);
// Import all translation modules
var _common = require("../translations/common");
var _commonDefault = parcelHelpers.interopDefault(_common);
var _header = require("../translations/header");
var _headerDefault = parcelHelpers.interopDefault(_header);
var _footer = require("../translations/footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
var _home = require("../translations/home");
var _homeDefault = parcelHelpers.interopDefault(_home);
var _about = require("../translations/about");
var _aboutDefault = parcelHelpers.interopDefault(_about);
var _contact = require("../translations/contact");
var _contactDefault = parcelHelpers.interopDefault(_contact);
var _service = require("../translations/service");
var _serviceDefault = parcelHelpers.interopDefault(_service);
var _lab = require("../translations/lab");
var _labDefault = parcelHelpers.interopDefault(_lab);
var _principles = require("../translations/principles");
var _principlesDefault = parcelHelpers.interopDefault(_principles);
var _privacy = require("../translations/privacy");
var _privacyDefault = parcelHelpers.interopDefault(_privacy);
var _disclaimer = require("../translations/disclaimer");
var _disclaimerDefault = parcelHelpers.interopDefault(_disclaimer);
var _accessibility = require("../translations/accessibility");
var _accessibilityDefault = parcelHelpers.interopDefault(_accessibility);
var _gallery = require("../translations/gallery");
var _galleryDefault = parcelHelpers.interopDefault(_gallery);
var _acrossChaptersMap = require("../translations/acrossChaptersMap");
var _acrossChaptersMapDefault = parcelHelpers.interopDefault(_acrossChaptersMap);
// All available translation namespaces
const TRANSLATIONS = {
    common: (0, _commonDefault.default),
    header: (0, _headerDefault.default),
    footer: (0, _footerDefault.default),
    home: (0, _homeDefault.default),
    about: (0, _aboutDefault.default),
    contact: (0, _contactDefault.default),
    service: (0, _serviceDefault.default),
    lab: (0, _labDefault.default),
    principles: (0, _principlesDefault.default),
    privacy: (0, _privacyDefault.default),
    disclaimer: (0, _disclaimerDefault.default),
    accessibility: (0, _accessibilityDefault.default),
    gallery: (0, _galleryDefault.default),
    acrossChaptersMap: (0, _acrossChaptersMapDefault.default)
};
const getTranslation = (lang, namespace, key, fallback = key)=>{
    try {
        const translations = TRANSLATIONS[namespace];
        if (!translations) {
            console.warn(`Translation namespace '${namespace}' not found`);
            return fallback;
        }
        const langTranslations = translations[lang];
        if (!langTranslations) {
            console.warn(`Language '${lang}' not found in namespace '${namespace}'`);
            return fallback;
        }
        // Handle nested keys (e.g., 'hero.title')
        const keys = key.split('.');
        let value = langTranslations;
        for (const k of keys)if (value && typeof value === 'object' && value[k] !== undefined) value = value[k];
        else {
            // Fallback to English if available
            const enTranslations = translations.en;
            if (enTranslations) {
                let enValue = enTranslations;
                for (const ek of keys){
                    if (enValue && typeof enValue === 'object' && enValue[ek] !== undefined) enValue = enValue[ek];
                    else return fallback;
                }
                return enValue;
            }
            return fallback;
        }
        return value !== undefined ? value : fallback;
    } catch (error) {
        console.warn(`Error getting translation for ${namespace}.${key}:`, error);
        return fallback;
    }
};
const useTranslations = ()=>{
    const { currentLang } = (0, _react.useContext)((0, _languageContextDefault.default));
    /**
   * Get translation for a specific namespace and key
   * @param {string} namespace - Translation namespace (e.g., 'home', 'common')
   * @param {string} key - Translation key (can be nested with dots, e.g., 'hero.title')
   * @param {any} fallback - Fallback value if translation not found
   * @returns {any} Translated value or fallback
   */ const t = (namespace, key, fallback = key)=>{
        return getTranslation(currentLang, namespace, key, fallback);
    };
    /**
   * Get a namespace-specific translation function
   * Useful when a component primarily uses translations from one namespace
   * @param {string} namespace - The default namespace to use
   * @returns {Object} Object with t function scoped to the namespace
   */ const withNamespace = (namespace)=>{
        return {
            /**
       * Get translation from the pre-set namespace
       * @param {string} key - Translation key
       * @param {any} fallback - Fallback value if translation not found
       * @returns {any} Translated value or fallback
       */ t: (key, fallback = key)=>getTranslation(currentLang, namespace, key, fallback),
            currentLang
        };
    };
    return {
        t,
        currentLang,
        withNamespace
    };
};
const translate = (namespace, key, lang = 'en')=>{
    return getTranslation(lang, namespace, key, key);
};
const getAllTranslations = (namespace, lang = 'en')=>{
    const translations = TRANSLATIONS[namespace];
    return (translations === null || translations === void 0 ? void 0 : translations[lang]) || (translations === null || translations === void 0 ? void 0 : translations.en) || {};
};

},{"react":"7d7jl","./LanguageContext":"5u50e","../translations/common":"9ciyE","../translations/header":"4FFw6","../translations/footer":"fdmd7","../translations/home":"5WSxH","../translations/about":"bD1AP","../translations/contact":"bGgwE","../translations/service":"fXIqn","../translations/lab":"3VOhJ","../translations/principles":"dzBzm","../translations/privacy":"ecbGd","../translations/disclaimer":"759ss","../translations/accessibility":"b8SLX","../translations/gallery":"lUwsf","../translations/acrossChaptersMap":"lC98R","@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"5u50e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LanguageProvider", ()=>LanguageProvider);
parcelHelpers.export(exports, "useLanguage", ()=>useLanguage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _i18N = require("./i18n");
const LanguageContext = /*#__PURE__*/ (0, _react.createContext)(null);
// Get language preference from localStorage
const getStoredLang = ()=>{
    try {
        return window.localStorage.getItem('twk_lang') || null;
    } catch (e) {
        return null;
    }
};
// Save language preference to localStorage
const saveStoredLang = (lang)=>{
    try {
        window.localStorage.setItem('twk_lang', lang);
    } catch (e) {
        console.warn('Could not save language preference:', e);
    }
};
const LanguageProvider = ({ children })=>{
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const hasRedirectedRef = (0, _react.useRef)(false);
    // Get initial language from URL, localStorage, browser, or default
    const initialLang = (0, _i18N.getLangFromPathWithFallback)(location.pathname);
    const [currentLang, setCurrentLang] = (0, _react.useState)(initialLang);
    // Redirect to preferred language path if on home page and preferred language is not default
    (0, _react.useEffect)(()=>{
        if (hasRedirectedRef.current) return;
        const langFromPath = (0, _i18N.getLangFromPath)(location.pathname);
        const preferredLang = (0, _i18N.getLangFromPathWithFallback)(location.pathname);
        // Only redirect from home page ("/") to preferred language home page
        if (location.pathname === "/" && preferredLang !== (0, _i18N.DEFAULT_LANG)) {
            hasRedirectedRef.current = true;
            const newPath = (0, _i18N.switchLangPath)(location.pathname, preferredLang);
            navigate(newPath, {
                replace: true
            });
        }
    }, [
        location.pathname,
        navigate
    ]);
    // Update language when path changes
    (0, _react.useEffect)(()=>{
        const langFromPath = (0, _i18N.getLangFromPath)(location.pathname);
        if ((0, _i18N.LANGUAGES).includes(langFromPath)) setCurrentLang(langFromPath);
        else {
            // Fallback to stored or browser preference
            const storedLang = getStoredLang();
            if (storedLang && (0, _i18N.LANGUAGES).includes(storedLang)) setCurrentLang(storedLang);
        }
    }, [
        location.pathname
    ]);
    // Keep <html lang> in sync so screen readers and search engines get the right language.
    (0, _react.useEffect)(()=>{
        document.documentElement.lang = currentLang;
    }, [
        currentLang
    ]);
    const changeLanguage = (lang)=>{
        if (!(0, _i18N.LANGUAGES).includes(lang)) {
            console.warn(`Language ${lang} is not supported`);
            return;
        }
        // Save preference
        saveStoredLang(lang);
        // Navigate to same page with translated route
        const newLanguagePath = (0, _i18N.switchLangPath)(location.pathname, lang);
        navigate(newLanguagePath, {
            replace: true
        });
    };
    const getCurrentPaths = ()=>{
        // Import getRoutePaths dynamically to avoid circular dependency
        const { getRoutePaths } = require("8fde383efeda5784");
        return getRoutePaths(currentLang);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(LanguageContext.Provider, {
        value: {
            currentLang,
            changeLanguage,
            availableLangs: (0, _i18N.LANGUAGES),
            defaultLang: (0, _i18N.DEFAULT_LANG),
            getCurrentPaths
        },
        children: children
    });
};
const useLanguage = ()=>{
    const context = (0, _react.useContext)(LanguageContext);
    if (!context) throw new Error('useLanguage must be used within a LanguageProvider');
    return context;
};
exports.default = LanguageContext;

},{"react/jsx-runtime":"a7gVT","react":"7d7jl","react-router-dom":"hhXgL","./i18n":"4Kl7i","8fde383efeda5784":"4Kl7i","@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"9ciyE":[function(require,module,exports,__globalThis) {
// Common translations used across multiple components
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const commonTranslations = {
    en: {
        capabilities: "core capabilities",
        cookies: {
            label: "cookie consent",
            eyebrow: "cookies",
            text: "we'd like to use google analytics to understand how this site is used. it only runs if you accept. more in our",
            link: "privacy policy",
            decline: "decline",
            accept: "accept"
        },
        siteTitle: "thewhizkind",
        siteDescription: "thewhizkind is an independent creative and technology team based in Frankfurt am Main, working across design, web development, AI, automation and business.",
        siteTagline: "Design, Technology & Business",
        locations: "frankfurt am main",
        locationsFull: "Frankfurt am Main, Germany",
        year: "2026",
        defaultMeta: "Design, Technology & Business",
        pageMeta: {
            title: {
                home: "Design, Technology & Business | Frankfurt",
                services: "Services \u2014 Design, Technology & Business",
                lab: "The Lab \u2014 AI, Automation & Digital Tools",
                gallery: "Gallery \u2014 Selected Visual Work",
                about: "Design, Technology & Business in Frankfurt",
                contact: "Contact \u2014 Start a Project",
                principles: "Our Principles",
                privacy: "Privacy Policy",
                disclaimer: "Legal Disclaimer",
                accessibility: "Accessibility"
            },
            template: {
                about: "About {site} \u2013 {title}"
            }
        },
        copyright: "\xa9 2026 thewhizkind",
        signature: "{<powered by thewhizkind>}",
        systemOnline: "System online",
        creativeTechnology: "creative_technology",
        nodes: "frankfurt am main",
        build: "ideas.with_attention()",
        learnMore: "learn more",
        seeMore: "see more",
        back: "back",
        continue: "continue",
        submit: "submit",
        send: "send",
        sending: "sending",
        sent: "sent",
        error: "error",
        required: "required",
        optional: "optional",
        or: "or",
        and: "and",
        with: "with",
        for: "for",
        of: "of",
        to: "to",
        from: "from",
        language: "Language",
        chooseLanguage: "Choose your language",
        explore: "explore",
        visit: "visit"
    },
    de: {
        capabilities: "kernkompetenzen",
        cookies: {
            label: "cookie-einwilligung",
            eyebrow: "cookies",
            text: "wir w\xfcrden gerne google analytics nutzen, um zu verstehen, wie diese website genutzt wird. es l\xe4uft nur, wenn du zustimmst. mehr dazu in unserer",
            link: "datenschutzerkl\xe4rung",
            decline: "ablehnen",
            accept: "zustimmen"
        },
        siteTitle: "thewhizkind",
        siteDescription: "thewhizkind ist ein unabh\xe4ngiges Kreativ- und Technologieteam mit Sitz in Frankfurt am Main, das im Bereich Design, Webentwicklung, KI, Automatisierung und Business t\xe4tig ist.",
        siteTagline: "Design, Technologie & Business",
        locations: "frankfurt am main",
        locationsFull: "Frankfurt am Main, Deutschland",
        year: "2026",
        defaultMeta: "Design, Technologie & Business",
        pageMeta: {
            title: {
                home: "Design, Technologie & Business | Frankfurt",
                services: "Dienstleistungen \u2014 Design, Technologie & Business",
                lab: "Die Werkstatt \u2014 AI, Automatisierung & Digitale Werkzeuge",
                gallery: "Galerie \u2014 Ausgew\xe4hlte Grafikprojekte",
                about: "Design, Technologie & Business in Frankfurt",
                contact: "Kontakt \u2014 Ein Projekt beginnen",
                principles: "Unsere Prinzipien",
                privacy: "Datenschutzerkl\xe4rung / Privatsph\xe4re",
                disclaimer: "Impressum / Haftungsausschluss",
                accessibility: "Barrierefreiheit"
            },
            template: {
                about: "\xdcber {site} \u2013 {title}"
            }
        },
        copyright: "\xa9 2026 thewhizkind",
        signature: "{<powered by thewhizkind>}",
        systemOnline: "system online",
        creativeTechnology: "creative_technology",
        nodes: "frankfurt am main",
        build: "ideas.mit_aufmerksamkeit()",
        learnMore: "mehr erfahren",
        seeMore: "mehr sehen",
        back: "zur\xfcck",
        continue: "weiter",
        submit: "absenden",
        send: "senden",
        sending: "wird gesendet",
        sent: "gesendet",
        error: "fehler",
        required: "erforderlich",
        optional: "optional",
        or: "oder",
        and: "und",
        with: "mit",
        for: "f\xfcr",
        of: "von",
        to: "an",
        from: "von",
        language: "sprache",
        chooseLanguage: "w\xe4hle deine sprache",
        explore: "erkunden",
        visit: "besuchen"
    }
};
exports.default = commonTranslations;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"4FFw6":[function(require,module,exports,__globalThis) {
// Header translations
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const headerTranslations = {
    en: {
        tagline: "independent / creative / technology",
        menu: {
            open: "Open menu",
            close: "Close menu"
        },
        navigation: {
            services: "services",
            lab: "lab",
            gallery: "gallery",
            about: "about",
            contact: "contact"
        }
    },
    de: {
        tagline: "unabh\xe4ngig / kreativ / technologie",
        menu: {
            open: "men\xfc \xf6ffnen",
            close: "men\xfc schlie\xdfen"
        },
        navigation: {
            services: "dienstleistungen",
            lab: "werkstatt",
            gallery: "galerie",
            about: "\xfcber uns",
            contact: "kontakt"
        }
    }
};
exports.default = headerTranslations;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"fdmd7":[function(require,module,exports,__globalThis) {
// Footer translations
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const footerTranslations = {
    en: {
        footerPartners: "along the way / selected collaborators / some remain confidential.",
        brandTagline: "independent / creative / technology",
        navigate: "01 / navigate",
        capabilities: "02 / capabilities",
        connect: "03 / connect",
        legal: {
            disclaimer: "impressum / disclaimer",
            privacy: "datenschutzerkl\xe4rung / privacy policy",
            accessibility: "accessibility"
        },
        social: {
            instagram: "Instagram",
            linkedin: "LinkedIn",
            discord: "Discord",
            github: "GitHub"
        },
        socialAriaLabels: {
            instagram: "thewhizkind on Instagram (opens in new tab)",
            linkedin: "Prayrit Singh on LinkedIn (opens in new tab)",
            discord: "Prayrit Singh on Discord (opens in new tab)",
            github: "Prayrit Singh on GitHub (opens in new tab)"
        },
        footerLinks: {
            /*01 / navigate*/ services: "services",
            lab: "lab",
            gallery: "gallery",
            about: "about",
            contact: "contact",
            principles: "principles",
            /*02 / capabilities*/ brandAndIdentity: "branding & identity",
            webDevelopment: "web development",
            graphicDesign: "graphic design",
            aiAndAutomation: "ai & automation",
            communication: "communication",
            digitalisation: "digitalisation",
            creativeDevelopment: "creative development",
            processOptimisation: "process optimisation"
        }
    },
    de: {
        footerPartners: "am arbeitsweg / ausgew\xe4hlte partner / manche bleiben vertraulich.",
        brandTagline: "unabh\xe4ngig / kreativ / technikaffin",
        navigate: "01 / navigation",
        capabilities: "02 / f\xe4higkeiten",
        connect: "03 / verbinden",
        legal: {
            disclaimer: "impressum / haftungsausschluss",
            privacy: "datenschutzerkl\xe4rung / privatsph\xe4re",
            accessibility: "barrierefreiheit"
        },
        social: {
            instagram: "Instagram",
            linkedin: "LinkedIn",
            discord: "Discord",
            github: "GitHub"
        },
        socialAriaLabels: {
            instagram: "thewhizkind auf Instagram (wird in neuem tab ge\xf6ffnet)",
            linkedin: "Prayrit Singh auf LinkedIn (wird in neuem tab ge\xf6ffnet)",
            discord: "Prayrit Singh auf Discord (wird in neuem tab ge\xf6ffnet)",
            github: "Prayrit Singh auf GitHub (wird in neuem tab ge\xf6ffnet)"
        },
        footerLinks: {
            /*01 / navigate*/ services: "dienstleistungen",
            lab: "werkstatt",
            gallery: "galerie",
            about: "\xfcber uns",
            contact: "kontakt",
            principles: "prinzipien",
            /*02 / capabilities*/ brandAndIdentity: "markenbildung & corporate identity",
            webDevelopment: "webentwicklung",
            graphicDesign: "grafikdesign",
            aiAndAutomation: "ki & automatisierung",
            communication: "kommunikation",
            digitalisation: "digitalisierung",
            creativeDevelopment: "kreative entwicklung",
            processOptimisation: "prozessoptimierung"
        }
    }
};
exports.default = footerTranslations;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"5WSxH":[function(require,module,exports,__globalThis) {
// Home page translations
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const homeTranslations = {
    en: {
        hero: {
            strip: {
                establish: "know no caution \xb7 est.",
                year: "2023",
                principlesLink: "what we believe"
            },
            title: "ideas worth noticing",
            script: "design / technology / business",
            locations: "frankfurt am main",
            disciplines: [
                "ai",
                "digitalisation",
                "process optimisation",
                "web development",
                "automation",
                "graphic design",
                "branding"
            ],
            actions: {
                seeServices: "see what we do",
                startProject: "start a project"
            },
            system: {
                mode: "creative technology",
                build: "ideas with attention()"
            }
        },
        capabilities: {
            kicker: "what we bring together",
            exploreLink: "explore our services",
            axis: {
                thinking: "thinking",
                making: "making"
            },
            title: [
                "ideas, design, and technology",
                "\u2014working as one."
            ],
            lede: "thewhizkind is an independent creative and technology team based in frankfurt am main, with roots in new delhi \u2014 working across design, web development, ai and automation, digital tools, digitalisation and business.",
            list: [
                "finance",
                "web development",
                "graphic design",
                "ai & automation",
                "communication",
                "digitalisation",
                "creative development",
                "process optimisation",
                "branding & identity"
            ]
        },
        workPortal: {
            kicker: "Gallery / 2023\u2014ongoing",
            title: "see the / visual side.",
            description: "identity \xb7 campaigns \xb7 editorial \xb7 graphic design"
        },
        founder: {
            kicker: "who's behind this",
            title: "hi, i'm prayrit.",
            bio: "i co-founded thewhizkind because the interesting problems rarely fit neatly into one box. sometimes they need design. sometimes code. sometimes numbers. usually, a bit of everything. based in frankfurt, with roots in new delhi, i stay closely involved in the things we make.",
            meta: [
                "prayrit singh / co-founder",
                "m.sc. accounting, finance & controlling",
                "design / technology / ai / automation / finance"
            ],
            moreLink: "more about me"
        },
        contactCta: {
            kicker: "have something in mind?",
            title: [
                "let's make something",
                "worth noticing."
            ],
            link: "start a conversation"
        },
        contactStrip: [
            "open to big plans",
            "unexpected thoughts welcome",
            "let's create"
        ]
    },
    de: {
        hero: {
            strip: {
                establish: "know no caution \xb7 gegr.",
                year: "2023",
                principlesLink: "woran wir glauben"
            },
            title: "ideen, die beachtung verdienen",
            script: "design / technologie / business",
            locations: "frankfurt am main",
            disciplines: [
                "ki",
                "digitalisierung",
                "prozessoptimierung",
                "webentwicklung",
                "automatisierung",
                "grafikdesign",
                "branding"
            ],
            actions: {
                seeServices: "unsere dienstleistungen entdecken",
                startProject: "projekt starten"
            },
            system: {
                mode: "schaffens_kraft",
                build: "ideen mit_ausrufezeichen()"
            }
        },
        capabilities: {
            kicker: "durch uns vereint",
            exploreLink: "unsere dienstleistungen entdecken",
            axis: {
                thinking: "denken",
                making: "machen"
            },
            title: [
                "ideen, design und technologie",
                "\u2014 die zusammen funktionieren."
            ],
            lede: "thewhizkind ist ein unabh\xe4ngiges kreatives und technikaffines team mit sitz in frankfurt am main, verwurzelt in neu-delhi \u2014 t\xe4tig in den bereichen design, webentwicklung, ki und automatisierung, digitale anwendungen, digitalisierung und business.",
            list: [
                "finanzen",
                "webentwicklung",
                "grafikdesign",
                "ki & automatisierung",
                "kommunikation",
                "digitalisierung",
                "kreative entwicklung",
                "prozessoptimierung",
                "markenbildung & corporate identity"
            ]
        },
        workPortal: {
            kicker: "galerie / 2023\u2014laufend",
            title: "das gestalten wir.",
            description: "corporate identity \xb7 kampagnen \xb7 redaktion \xb7 grafikdesign"
        },
        founder: {
            kicker: "wer dahintersteckt",
            title: "hallo, ich hei\xdfe prayrit.",
            bio: "ich habe thewhizkind mitgegr\xfcndet, weil interessante problemstellungen selten nur mit einer disziplin begriffen werden k\xf6nnen. manchmal braucht es design. manchmal code. manchmal zahlen. meistens ein bisschen von allem. mit sitz in frankfurt und beheimatet in neu-delhi bleibe ich eng in die dinge eingebunden, die wir erschaffen.",
            meta: [
                "prayrit singh / mitgr\xfcnder",
                "m.sc. rechnungswesen, finanzen & controlling",
                "design / technologie / ki / automatisierung / finanzen"
            ],
            moreLink: "mehr \xfcber mich"
        },
        contactCta: {
            kicker: "etwas im sinn?",
            title: [
                "lass uns etwas erschaffen,",
                "das anerkennung gewinnt."
            ],
            link: "konversation beginnen"
        },
        contactStrip: [
            "offen f\xfcr gro\xdfe pl\xe4ne",
            "unerwartete gedanken willkommen",
            "lass uns etwas schaffen"
        ]
    }
};
exports.default = homeTranslations;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"bD1AP":[function(require,module,exports,__globalThis) {
// About page translations
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const aboutTranslations = {
    en: {
        hero: {
            eyebrow: "about / thewhizkind",
            title: "know no caution",
            summary: "thewhizkind is an independent creative and technology team based in Frankfurt am Main, with roots in New Delhi. We bring together design, technology and business to make things that are thoughtful, useful and worth noticing.",
            principlesLink: "our principles"
        },
        cards: {
            whatWeMake: {
                title: "what we make",
                content: "<strong>ideas made real.</strong> brands, websites, graphic design, digital experiences, ai, automation \u2014 and whatever the idea needs. see our <link-services>full range of services</link-services> or browse <link-gallery>selected visual work</link-gallery>."
            },
            howWeWork: {
                title: "how we work",
                content: "<strong>curious by default.</strong> we ask questions, experiment, make, break, rethink, and make things better."
            },
            motto: {
                title: "our motto",
                content: "<strong>know no caution.</strong> not recklessness. just the curiosity to try, learn, question, and see what happens."
            }
        },
        divider: "Since 2023",
        founder: {
            media: {
                portraitCaption: "portrait / frankfurt"
            },
            facts: {
                languages: "languages",
                languagesValue: "de \xb7 en \xb7 hi",
                education: "education",
                educationValue: "m.sc. accounting, finance & controlling",
                based: "based",
                basedValue: "frankfurt am main",
                pronouns: "pronouns",
                pronounsValue: "he/him/er/ihn"
            },
            copy: {
                label: "leading the collective",
                name: "Prayrit Singh",
                role: "co-founder \xb7 27 \xb7 frankfurt am main",
                email: "prayrit@thewhizkind.com",
                profile: [
                    "leads thewhizkind",
                    "makes things",
                    "breaks things",
                    "makes them better",
                    "creative direction",
                    "technology",
                    "ideas",
                    "new delhi born",
                    "frankfurt based",
                    "between cultures",
                    "finance",
                    "curiosity",
                    "always learning",
                    "probably thinking about something",
                    "asks too many questions",
                    "night owl",
                    "runs sometimes",
                    "takes pictures",
                    "looks at the stars",
                    "jedi in training",
                    "may the force be with you"
                ]
            }
        },
        footnote: {
            since: "Since 2023",
            practiceAreas: [
                "Design",
                "Technology",
                "Storytelling"
            ]
        }
    },
    de: {
        hero: {
            eyebrow: "\xfcber uns / thewhizkind",
            title: "know no caution",
            summary: "thewhizkind ist ein unabh\xe4ngiges kreativ- und technologieteam mit sitz in frankfurt am main und wurzeln in neu-delhi. wir verbinden design, technologie und business, um dinge zu schaffen, die durchdacht, n\xfctzlich und beachtenswert sind.",
            principlesLink: "unsere prinzipien"
        },
        cards: {
            whatWeMake: {
                title: "was wir erschaffen",
                content: "<strong>ideen verwirklichen.</strong> marken, websites, grafikdesign, digitale formate, ki, automatisierung \u2014 und was aus der idee sonst noch hervorgeht. sieh dir unser <link-services>gesamtes leistungsspektrum</link-services> an oder st\xf6bere in unseren realisierten <link-gallery>grafikprojekten</link-gallery>."
            },
            howWeWork: {
                title: "wie wir arbeiten",
                content: "<strong>von natur aus neugierig.</strong> wir stellen fragen, experimentieren, gestalten, probieren aus, \xfcberdenken und verbessern dinge."
            },
            motto: {
                title: "unser motto",
                content: "<strong>know no caution.</strong> nicht r\xfccksichtslos. nur die neugier treibt uns, dinge auszuprobieren, zu erlernen, zu hinterfragen und zu sehen, was passiert."
            }
        },
        divider: "seit 2023",
        founder: {
            media: {
                portraitCaption: "portr\xe4t / frankfurt"
            },
            facts: {
                languages: "sprachen",
                languagesValue: "de \xb7 en \xb7 hi",
                education: "ausbildung",
                educationValue: "m.sc. rechnungswesen, finanzen & controlling",
                based: "standort",
                basedValue: "frankfurt am main",
                pronouns: "pronomen",
                pronounsValue: "er/ihn"
            },
            copy: {
                label: "leiter des kollektivs",
                name: "Prayrit Singh",
                role: "mitgr\xfcnder \xb7 27 \xb7 frankfurt am main",
                email: "prayrit@thewhizkind.com",
                profile: [
                    "leitet thewhizkind",
                    "gestaltet dinge",
                    "wirft dinge \xfcber den haufen",
                    "verbessert sie",
                    "kreative leitung",
                    "technologie",
                    "ideen",
                    "in neu-delhi geboren",
                    "in frankfurt ans\xe4ssig",
                    "zwischen den kulturen",
                    "finanzen",
                    "neugier",
                    "lernt immer dazu",
                    "denkt wahrscheinlich \xfcber etwas nach",
                    "stellt zu viele fragen",
                    "nachteule",
                    "l\xe4uft ab und zu",
                    "macht fotos",
                    "schaut in die sterne",
                    "jedi in der ausbildung",
                    "m\xf6ge die macht mit dir sein"
                ]
            }
        },
        footnote: {
            since: "seit 2023",
            practiceAreas: [
                "design",
                "technologie",
                "storytelling"
            ]
        }
    }
};
exports.default = aboutTranslations;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"bGgwE":[function(require,module,exports,__globalThis) {
// Contact page translations
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const contactTranslations = {
    en: {
        hero: {
            kicker: "contact / start something",
            title: "want to work together?",
            intro: "have an idea? big, small, strange, unfinished \u2014 we're listening. let's make something together."
        },
        contactStrip: [
            "01 \u2014 idea",
            "02 \u2014 conversation",
            "03 \u2014 make"
        ],
        card: {
            sendMessage: "send us a message",
            email: "prayrit@thewhizkind.com",
            findUs: "find us here",
            socials: {
                instagram: "instagram",
                linkedin: "linkedin"
            }
        },
        form: {
            title: "contact form",
            kicker: "say hello",
            sections: {
                whoAreYou: {
                    index: "01",
                    question: "who are you?",
                    name: {
                        label: "your name",
                        placeholder: "e.g. Alex M\xfcller"
                    },
                    email: {
                        label: "your email",
                        placeholder: "e.g. alex@example.com"
                    }
                },
                whatAreWeMaking: {
                    index: "02",
                    question: "what are we making?",
                    hint: "optional",
                    projectTypes: [
                        "web",
                        "ai",
                        "automation",
                        "digitalisation",
                        "branding",
                        "graphic design",
                        "something else"
                    ],
                    otherPlaceholder: "go on, tell us"
                },
                tellUsAboutIt: {
                    index: "03",
                    question: "tell us about it.",
                    hint: "optional",
                    placeholder: "an idea, a problem, a half-finished thought\u2026"
                },
                addSomething: {
                    index: "04",
                    question: "add something.",
                    hint: "optional",
                    uploadText: "brief / image / sketch / pdf / whatever helps",
                    fileTooBig: "that file's too big \u2014 please keep attachments under 10MB."
                }
            },
            submit: {
                button: "send it",
                sending: "sending",
                sent: "sent",
                success: "got it \u2014 we'll get back to you soon.",
                error: "something went wrong sending your message \u2014 please try emailing us directly."
            },
            honeypot: "website"
        }
    },
    de: {
        hero: {
            kicker: "kontakt / etwas beginnen",
            title: "willst du mit uns zusammenarbeiten?",
            intro: "hast du eine idee? gro\xdf, klein, ungew\xf6hnlich, unfertig \u2014 wir h\xf6ren zu. lass uns gemeinsam etwas erschaffen."
        },
        contactStrip: [
            "01 \u2014 idee",
            "02 \u2014 gespr\xe4ch",
            "03 \u2014 umsetzen"
        ],
        card: {
            sendMessage: "schreib uns",
            email: "prayrit@thewhizkind.com",
            findUs: "hier findest du uns",
            socials: {
                instagram: "Instagram",
                linkedin: "LinkedIn"
            }
        },
        form: {
            title: "kontaktformular",
            kicker: "hallo sagen",
            sections: {
                whoAreYou: {
                    index: "01",
                    question: "wer bist du?",
                    name: {
                        label: "dein name",
                        placeholder: "z.B. Alex M\xfcller"
                    },
                    email: {
                        label: "deine e-mail",
                        placeholder: "z.B. alex@beispiel.de"
                    }
                },
                whatAreWeMaking: {
                    index: "02",
                    question: "was k\xf6nnen wir tun?",
                    hint: "optional",
                    projectTypes: [
                        "webentwicklung",
                        "ki",
                        "automatisierung",
                        "digitalisierung",
                        "markenentwicklung",
                        "grafikdesign",
                        "etwas anderes"
                    ],
                    otherPlaceholder: "erz\xe4hl uns mehr"
                },
                tellUsAboutIt: {
                    index: "03",
                    question: "erz\xe4hl uns davon.",
                    hint: "optional",
                    placeholder: "eine idee, ein problem, ein halbfertiger gedanke\u2026"
                },
                addSomething: {
                    index: "04",
                    question: "f\xfcge etwas hinzu.",
                    hint: "optional",
                    uploadText: "brief / bild / skizze / pdf / was auch immer hilft",
                    fileTooBig: "diese datei ist zu gro\xdf \u2014 bitte halte die gr\xf6\xdfe von anh\xe4ngen unter 10MB."
                }
            },
            submit: {
                button: "absenden",
                sending: "wird gesendet",
                sent: "gesendet",
                success: "erhalten \u2014 wir melden uns bald bei dir.",
                error: "beim senden deiner nachricht ist ein fehler aufgetreten \u2014 bitte versuch, uns direkt per e-mail zu kontaktieren."
            },
            honeypot: "website"
        }
    }
};
exports.default = contactTranslations;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"fXIqn":[function(require,module,exports,__globalThis) {
// Service page translations
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const serviceTranslations = {
    en: {
        hero: {
            kicker: "services / thewhizkind",
            title: "our <span>services</span>",
            intro: {
                lead: "ideas, design, technology and business \u2014 working as one.",
                text: "sometimes that's a website. sometimes an identity. sometimes it's an automation, a digital tool or a process that simply shouldn't be manual anymore."
            }
        },
        index: {
            label: "Service categories"
        },
        groups: {
            automation: {
                title: "ai, automation & tools",
                slug: "ai-automation-tools",
                formattedTitle: [
                    "ai,",
                    "automation",
                    "& tools"
                ],
                intro: "less time spent on repetitive work. more room for the work that needs a person.",
                services: {
                    aiAutomation: [
                        "ai & automation",
                        "workflows that reduce manual tasks, connect information and make everyday work a little easier."
                    ],
                    privateLocalAi: [
                        "private & local ai",
                        "ai built around your own data and infrastructure \u2014 so sensitive information doesn't have to leave your environment."
                    ],
                    processOptimisation: [
                        "process optimisation",
                        "finding unnecessary steps before deciding what should be simplified, connected or automated."
                    ],
                    customTools: [
                        "custom tools",
                        "sometimes the right tool does not exist. so we build it."
                    ]
                },
                inlineLink: "see what we're experimenting with"
            },
            webDigital: {
                title: "web & digital",
                slug: "web-digital",
                intro: "digital experiences designed and developed as one \u2014 around what people actually need to do.",
                services: {
                    webDevelopment: [
                        "web development",
                        "responsive, accessible and fast websites \u2014 thoughtfully designed, carefully built."
                    ],
                    digitalisation: [
                        "digitalisation",
                        "turning manual, fragmented or outdated ways of working into practical digital processes."
                    ]
                }
            },
            finance: {
                title: "finance & business",
                slug: "finance-business",
                intro: "bringing structure to the business side of good ideas.",
                services: {
                    finance: [
                        "finance",
                        "bringing financial thinking into digital projects and making complex data easier to work with."
                    ],
                    creativeDevelopment: [
                        "creative development",
                        "turning early ideas into useful, viable projects with a clearer direction."
                    ]
                }
            },
            brandDesign: {
                title: "brand & design",
                slug: "brand-design",
                intro: "identities and communication systems that make an idea clear, recognisable and useful.",
                services: {
                    brandingIdentity: [
                        "branding & identity",
                        "from the first idea to a visual system around it \u2014 identities, typography, colour and guidelines built to stay recognisable."
                    ],
                    graphicDesign: [
                        "graphic design",
                        "campaigns, publications, presentations, posters and digital content \u2014 designed to communicate clearly and look like they belong together."
                    ],
                    communication: [
                        "communication",
                        "making information clearer and easier to understand across channels and audiences."
                    ]
                },
                inlineLink: "see selected visual work"
            }
        },
        liveOnTheWeb: {
            title: "live on the web"
        },
        process: {
            title: "how we work",
            sectionTitle: "no fixed recipe",
            steps: [
                [
                    "01",
                    "understand",
                    "what's actually the problem?"
                ],
                [
                    "02",
                    "think",
                    "what would make it better?"
                ],
                [
                    "03",
                    "make",
                    "design it. build it. test it."
                ],
                [
                    "04",
                    "improve",
                    "because version one rarely needs to be version forever."
                ]
            ]
        },
        clients: {
            kicker: "who we work with",
            title: "different sizes.<br />same curiosity.",
            scale: "startups / organisations / cultural institutions / education / businesses / independent projects",
            paths: [
                "some come with a detailed brief.",
                "some come with a problem.",
                "some come with there has to be a better way to do this.",
                "some just come with a hallo."
            ],
            emphasis: "all good places to start."
        },
        faq: {
            title: "good questions",
            sectionTitle: "before we <span>begin</span>",
            questions: [
                [
                    "do you only work on projects in frankfurt?",
                    "no. we are based in frankfurt am main, with roots in new delhi, and work with people and organisations across borders and time zones."
                ],
                [
                    "can you handle design and development together?",
                    "yes. bringing both together is often the best way to keep an idea coherent from its first sketch to the finished experience."
                ],
                [
                    "do you work with existing websites and systems?",
                    "yes. we can improve, extend or rethink what is already there when starting again would not make sense."
                ],
                [
                    "can you automate an existing manual process?",
                    "usually, yes. we first understand the process, remove what is unnecessary and then automate the parts where technology genuinely helps."
                ],
                [
                    "can we come to you without knowing exactly what we need?",
                    "absolutely. a clear problem is enough. sometimes even knowing that something should work better is a good place to begin."
                ]
            ]
        },
        cta: {
            kicker: "a good place to start",
            title: "what could<br />work better?",
            text: "bring us the idea, the problem, or the thing you've been meaning to make better.",
            action: "start a project"
        }
    },
    de: {
        hero: {
            kicker: "dienstleistungen / thewhizkind",
            title: "unsere <span>dienst\u00ADleistungen</span>",
            intro: {
                lead: "ideen, design, technologie und business \u2014 im zusammenspiel.",
                text: "das kann eine webseite sein. manchmal geht es um corporate identity. ein andermal steht die automatisierung im zentrum, ein digitales werkzeug oder ein prozess, der einfach nicht mehr manuell erledigt werden sollte."
            }
        },
        index: {
            label: "leistungskategorien"
        },
        groups: {
            automation: {
                title: "ki, automatisierung & werkzeuge",
                slug: "ki-automatisierung-werkzeuge",
                formattedTitle: [
                    "ki,",
                    "automatisierung",
                    "& werkzeuge"
                ],
                intro: "weniger zeit f\xfcr repetitive arbeiten. mehr raum f\xfcr die aufgaben, die eines menschen bed\xfcrfen.",
                services: {
                    aiAutomation: [
                        "ki & automatisierung",
                        "abl\xe4ufe, die manuelle arbeiten sinnvoller gestalten, informationen vernetzen und die t\xe4gliche arbeit ein wenig einfacher machen."
                    ],
                    privateLocalAi: [
                        "private & lokale ki",
                        "ki, die um deine eigenen daten und infrastruktur herum aufgebaut ist \u2014 damit vertrauliche informationen gesch\xfctzt bleiben."
                    ],
                    processOptimisation: [
                        "prozessoptimierung",
                        "unn\xf6tige schritte ausmachen und entscheiden, was vereinfacht, vernetzt oder automatisiert werden sollte."
                    ],
                    customTools: [
                        "individuelle werkzeuge",
                        "existiert das richtige werkzeug nicht, bauen wir es einfach."
                    ]
                },
                inlineLink: "schau nach, womit wir experimentieren"
            },
            webDigital: {
                title: "web & digital",
                slug: "web-digital",
                intro: "digitale erfahrungen, die ganzheitlich entworfen und entwickelt werden \u2014 basierend darauf, was tats\xe4chlich getan werden muss.",
                services: {
                    webDevelopment: [
                        "webentwicklung",
                        "responsive, barrierefreie und schnelle websites \u2014 durchdacht gestaltet, sorgf\xe4ltig umgesetzt."
                    ],
                    digitalisation: [
                        "digitalisierung",
                        "manuelle, umst\xe4ndliche oder veraltete arbeitsweisen in praktische digitale prozesse verwandeln."
                    ]
                }
            },
            finance: {
                title: "finanzen & business",
                slug: "finanzen-gesch\xe4ft",
                intro: "struktur in die gesch\xe4ftsseite guter ideen bringen.",
                services: {
                    finance: [
                        "finanzen",
                        "finanzielle aspekte in digitale projekte ber\xfccksichtigen und komplexe daten einfacher nutzbar machen."
                    ],
                    creativeDevelopment: [
                        "kreativentwicklung",
                        "erste ideen in n\xfctzliche, realisierbare projekte mit klarer ausrichtung umsetzen."
                    ]
                }
            },
            brandDesign: {
                title: "marken & design",
                slug: "marken-design",
                intro: "corporate design und b\xfcrokommunikation, die eine idee klar, erkennbar und nutzbar machen.",
                services: {
                    brandingIdentity: [
                        "branding & identit\xe4t",
                        "von der ersten idee zu einem visualisierungssystem \u2014 wiedererkennbare corporate identity, typografie, farben und richtlinien."
                    ],
                    graphicDesign: [
                        "grafikdesign",
                        "kampagnen, publikationen, pr\xe4sentationen, poster und digitale inhalte \u2014 gestaltet, um klar und einheitlich zu kommunizieren."
                    ],
                    communication: [
                        "kommunikation",
                        "informationen \xfcber verschiedene kan\xe4le und zielgruppen hinweg klarer und einfacher verst\xe4ndlich machen"
                    ]
                },
                inlineLink: "schau dir ausgew\xe4hlte grafikprojekte an"
            }
        },
        liveOnTheWeb: {
            title: "live im web"
        },
        process: {
            title: "wie wir arbeiten",
            sectionTitle: "kein festes rezept",
            steps: [
                [
                    "01",
                    "verstehen",
                    "was ist eigentlich das problem?"
                ],
                [
                    "02",
                    "nachdenken",
                    "was w\xfcrde es besser machen?"
                ],
                [
                    "03",
                    "umsetzen",
                    "es entwerfen. es bauen. es testen."
                ],
                [
                    "04",
                    "verbessern",
                    "denn version eins hei\xdft nicht das ende."
                ]
            ]
        },
        clients: {
            kicker: "mit wem wir arbeiten",
            title: "unterschied\xadliche gr\xf6\xdfen.<br />gleiche neugier.",
            scale: "startups / organisationen / kultureinrichtungen / bildungswesen / unternehmen / unabh\xe4ngige projekte",
            paths: [
                "einige kommen mit detaillierten vorstellungen.",
                "einige kommen mit einem problem.",
                'einige kommen mit zweifeln "es muss eine bessere l\xf6sung geben".',
                "einige stellen sich einfach vor."
            ],
            emphasis: "alles gute ausgangspunkte."
        },
        faq: {
            title: "gute fragen",
            sectionTitle: "bevor wir <span>beginnen</span>",
            questions: [
                [
                    "arbeitet ihr nur an projekten in frankfurt?",
                    "nein. wir haben unseren standort in frankfurt am main, urspr\xfcnglich in neu-delhi, und arbeiten mit verschiedenen menschen und organisationen \xfcber grenzen und zeitzonen hinweg."
                ],
                [
                    "k\xf6nnt ihr design und entwicklung zusammen anbieten?",
                    "ja. beides zusammenzubringen ist oft der beste weg, um eine idee von der ersten skizze bis zum fertigen ergebnis koh\xe4rent zu halten."
                ],
                [
                    "arbeitet ihr mit bestehenden websites und systemen?",
                    "ja. wir k\xf6nnen verbessern, erweitern oder \xfcberdenken, was bereits existiert, wenn eine neugestaltung keinen sinn machen w\xfcrde."
                ],
                [
                    "k\xf6nnt ihr einen bestehenden manuellen prozess automatisieren?",
                    "in der regel ja. wir erfassen zun\xe4chst den prozess, entfernen, was unn\xf6tig ist, und automatisieren dann die bereiche, in denen technologie wirklich zielf\xfchrend ist."
                ],
                [
                    "k\xf6nnen wir zu euch kommen, ohne genau zu wissen, was wir brauchen?",
                    "absolut. ein klares problem reicht aus. manchmal ist sogar das wissen, dass etwas besser funktionieren sollte, ein guter startpunkt."
                ]
            ]
        },
        cta: {
            kicker: "ein guter startpunkt",
            title: "was k\xf6nnte<br />besser funktionieren?",
            text: "bring uns die idee, das problem oder die sache, die du schon immer verbessern wolltest.",
            action: "projekt starten"
        }
    }
};
exports.default = serviceTranslations;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"3VOhJ":[function(require,module,exports,__globalThis) {
// Lab page translations
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const labTranslations = {
    en: {
        hero: {
            eyebrow: "lab / thewhizkind",
            title: "the <span>lab</span>",
            intro: [
                "things we've built with people, teams & organisations.",
                "some solve very specific problems. some automate things that shouldn't be done by hand. some started simply because we wondered, could this work?",
                "some are public. some aren't.",
                "some we play with. some our partners actually work with."
            ]
        },
        transition: "experiments / tools / systems / 01\u2014\u221E",
        invite: {
            text: "curious about one? get in touch and we'll give you something to play with.",
            link: [
                "these experiments sit alongside our",
                "services."
            ]
        },
        index: {
            label: "things we've made.",
            mark: "+"
        },
        tools: {
            argus: {
                name: "argus",
                category: "internal tool / data / automation",
                status: "active",
                oneLiner: "built around a specific workflow, turning real-world data into something easier to understand, manage and act on.",
                detail: "every month someone was reconciling a claim spreadsheet against a stack of debit-note documents by hand \u2014 matching numbers, chasing mismatches, hunting for what didn't add up. argus reads the documents, matches them against the register line by line, and hands the same file back with every row checked. built to watch one real, messy workflow closely enough to trust it.",
                tags: [
                    "React",
                    "Node.js",
                    "PostgreSQL",
                    "Claude AI",
                    "Document Extraction"
                ]
            },
            proba: {
                name: "proba",
                category: "education / assessment / dashboard",
                status: "active",
                oneLiner: "a platform to take tests on, with every response landing straight into a live, interactive dashboard.",
                detail: "a timed, structured test in the browser \u2014 sections graded automatically where the answer is clear-cut, flagged for a human where it isn't. every submission writes straight into a dashboard built for scanning, filtering and scoring, so whoever's grading sees results as they come in instead of a stack of paper afterwards.",
                tags: [
                    "React",
                    "Vite",
                    "Dashboards",
                    "Auto-Scoring"
                ]
            },
            fero: {
                name: "fero",
                category: "crm / finance / operations",
                status: "active",
                oneLiner: "a crm and finance tool built as one platform \u2014 finances, employees, contracts and sales, together.",
                detail: "the parts of running a small company that usually live in five different tools and none of them talk to each other. invoicing and cash flow next to contracts, next to the people on payroll, next to the sales pipeline \u2014 one place, one source of truth. built the way we build most things: around what a small team actually needs, not what a big one might.",
                tags: [
                    "CRM",
                    "Finance",
                    "Contracts",
                    "HR",
                    "Sales"
                ]
            },
            atlas: {
                name: "atlas",
                category: "internal tool / lead generation / automation",
                status: "active",
                oneLiner: "an internal system for finding what might be worth our attention.",
                detail: "atlas was built around a simple problem: there are more opportunities out there than anyone has time to look for. it does some of that looking for us, bringing the interesting ones closer and leaving the rest behind.",
                tags: [
                    "Node.js",
                    "PostgreSQL",
                    "Claude AI",
                    "Automation",
                    "Lead Generation"
                ]
            },
            vex: {
                name: "vex",
                category: "ai / personalised",
                status: "active",
                oneLiner: "our own ai, shaped around whoever's actually using it.",
                detail: "most ai tools hand everyone the same assistant. vex is built to be trained on a person's or a company's own data, so it knows the context instead of guessing at it \u2014 personalised to the way someone actually works. the part of the lab we're most excited about right now.",
                tags: [
                    "AI",
                    "Personalisation"
                ]
            },
            nyx: {
                name: "nyx",
                category: "ai / tone & voice",
                status: "active",
                oneLiner: "one sentence in. five wildly different personalities out.",
                detail: "nyx is a small experiment in how easily personality can be manufactured through words. the same thought can sound confident, profound, chaotic, poetic or painfully polished \u2014 without changing what actually happened. it's exaggerated on purpose. a slightly ridiculous look at how differently we present ourselves depending on who we want to be.",
                tags: [
                    "AI",
                    "Writing",
                    "Personality",
                    "Satire"
                ],
                href: "https://nyx.thewhizkind.com/"
            },
            sophos: {
                name: "sophos",
                category: "ai / learning platform",
                status: "work in progress",
                oneLiner: "a learning platform for teachers. a learning companion for students.",
                detail: "teachers can build courses, share materials, create assignments and bring learning into one place. for students, sophos goes a step further \u2014 using ai to understand what they're learning, support them when they're stuck and adapt to how they learn. online, in the classroom, or somewhere in between. sophos is still a work in progress \u2014 we're building, testing and learning as we go.",
                tags: [
                    "Early Stage",
                    "AI",
                    "Education"
                ]
            }
        },
        statuses: {
            active: "active",
            workInProgress: "work in progress"
        },
        cta: {
            title: "want to try one?",
            text: "we don't link these publicly \u2014 reach out and we'll give you something to play with."
        }
    },
    de: {
        hero: {
            eyebrow: "werkstatt / thewhizkind",
            title: "die <span>werkstatt</span>",
            intro: [
                "dinge, die wir mit menschen, teams und organisationen aufgebaut haben.",
                "einige l\xf6sen sehr spezifische probleme. einige automatisieren dinge, die nicht von hand erledigt werden sollten. einige entstanden einfach, weil wir uns gefragt haben: k\xf6nnte das funktionieren?",
                "einige sind \xf6ffentlich zug\xe4nglich. einige nicht.",
                "mit einigen spielen wir. mit einigen arbeiten unsere partner tats\xe4chlich."
            ]
        },
        transition: "experimente / werkzeuge / systeme / 01\u2014\u221E",
        invite: {
            text: "neugierig auf eines? kontaktiere uns und wir geben dir etwas zum ausprobieren.",
            link: [
                "diese experimente erg\xe4nzen unsere",
                "dienstleistungen."
            ]
        },
        index: {
            label: "dinge, die wir geschaffen haben.",
            mark: "+"
        },
        tools: {
            argus: {
                name: "argus",
                category: "internes werkzeug / daten / automatisierung",
                status: "aktiv",
                oneLiner: "um einen spezifischen arbeitsablauf herum aufgebaut, der echtwelt-daten in etwas leichter verst\xe4ndliches, verwaltbares und durchf\xfchrbares verwandelt.",
                detail: "jeden monat musste jemand eine tabelle mit geldlichen forderungen manuell mit einem stapel von lastschrift-dokumenten abgleichen \u2013 zahlen zuordnen, unstimmigkeiten verfolgen, nach fehlendem suchen. argus liest die dokumente, gleicht sie zeile f\xfcr zeile mit dem eintragsregister ab und gibt die gleiche datei zur\xfcck, bei der jede zeile gepr\xfcft ist. zugeschnitten auf einen echten, ungeordneten arbeitsablauf, w\xe4hrend die kontrolle bei den menschen bleibt, die damit arbeiten.",
                tags: [
                    "react",
                    "node.js",
                    "postgresql",
                    "claude ai",
                    "dokumentenextraktion"
                ]
            },
            proba: {
                name: "proba",
                category: "bildung / bewertung / dashboard",
                status: "aktiv",
                oneLiner: "eine plattform, auf der tests absolviert werden k\xf6nnen, bei der jede antwort direkt in ein modernes, interaktives dashboard flie\xdft.",
                detail: "ein zeitlich begrenzter, fachlicher test im browser \u2014 abschnitte werden automatisch benotet, wo die antwort eindeutig ist, und f\xfcr einen menschen markiert, wo dies nicht der fall ist. jede einreichung wird direkt in ein dashboard geschrieben, das sich scannen, filtern und bewerten l\xe4sst. die person, die bewertet, kann ergebnisse simultan einsehen, w\xe4hrend die teilnehmenden aufgaben eingeben. die korrektur des stapels danach bleibt erspart.",
                tags: [
                    "react",
                    "vite",
                    "dashboards",
                    "auto-bewertung"
                ]
            },
            fero: {
                name: "fero",
                category: "crm / finanzen / betriebswirtschaft",
                status: "aktiv",
                oneLiner: "ein crm- und finanz-werkzeug, das als eine plattform aufgebaut ist \u2014 finanzen, personal, vertr\xe4ge und vertrieb, in einem.",
                detail: "enth\xe4lt die gesch\xe4ftsbereiche eines kleinen unternehmens, die normalerweise in f\xfcnf verschiedenen anwendungen co-existieren und nicht vernetzt sind. rechnungsstellung und cashflow neben vertr\xe4gen, neben dem team auf der gehaltsliste, neben der vertriebspipeline \u2014 alles an einem ort, aus einer einzigen quelle. entwickelt so, wie wir die meisten dinge entwickeln: ausgerichtet auf das, was ein kleines team tats\xe4chlich braucht, und nicht auf das, was ein gro\xdfes team vielleicht braucht.",
                tags: [
                    "crm",
                    "finanzen",
                    "vertr\xe4ge",
                    "personalwesen",
                    "vertrieb"
                ]
            },
            atlas: {
                name: "atlas",
                category: "internes werkzeug / lead-generierung / automatisierung",
                status: "aktiv",
                oneLiner: "ein internes system, um herauszufinden, was unsere aufmerksamkeit verdienen k\xf6nnte.",
                detail: "atlas wurde rund um ein einfaches problem herum entwickelt: es gibt mehr m\xf6glichkeiten da drau\xdfen, als irgendjemand zeit hat, danach zu suchen. es \xfcbernimmt einen teil dieser suche f\xfcr uns, r\xfcckt die interessanten n\xe4her heran und l\xe4sst den rest zur\xfcck.",
                tags: [
                    "node.js",
                    "postgresql",
                    "claude ai",
                    "automatisierung",
                    "lead-generierung"
                ]
            },
            vex: {
                name: "vex",
                category: "ki / personalisiert",
                status: "aktiv",
                oneLiner: "unsere eigene ki, die sich an dich anpasst.",
                detail: "die meisten ki-werkzeuge geben jedem denselben assistenten. vex ist darauf ausgelegt, auf den eigenen daten einer person oder eines unternehmens trainiert zu werden, sodass sie den kontext kennt, statt ihn erraten zu m\xfcssen \u2014 und so personalisiert ist, wie jemand tats\xe4chlich arbeitet. der teil der werkstatt, der uns derzeit am herzen liegt.",
                tags: [
                    "ki",
                    "personalisierung"
                ]
            },
            nyx: {
                name: "nyx",
                category: "ki / ton & stimme",
                status: "aktiv",
                oneLiner: "ein satz rein. f\xfcnf s\xe4tze mit v\xf6llig unterschiedlichen pers\xf6nlichkeiten raus.",
                detail: "nyx ist ein kleines experiment dar\xfcber, wie einfach pers\xf6nlichkeit durch worte vorget\xe4uscht werden kann. derselbe gedanke kann selbstbewusst, tiefgr\xfcndig, chaotisch, poetisch oder schmerzhaft poliert klingen \u2014 ohne reale vorkommnisse zu ver\xe4ndern. hier wird absichtlich \xfcbertrieben. ein humorvoller blick auf unsere bereitschaft, uns f\xfcr einen gew\xfcnschten zweck zu verstellen.",
                tags: [
                    "ki",
                    "schreiben",
                    "pers\xf6nlichkeit",
                    "satire"
                ],
                href: "https://nyx.thewhizkind.com/"
            },
            sophos: {
                name: "sophos",
                category: "ki / lernplattform",
                status: "in arbeit",
                oneLiner: "eine lernplattform f\xfcr lehrkr\xe4fte. eine lernbegleitung f\xfcr sch\xfclerinnen und sch\xfcler.",
                detail: "lehrkr\xe4fte k\xf6nnen kurse erstellen, materialien teilen, aufgaben erstellen und das lernen an einem ort stattfinden lassen. f\xfcr sch\xfclerinnen und sch\xfcler geht sophos einen schritt weiter \u2014 ki kommt zum einsatz, um zu verstehen, was sie lernen, sie zu unterst\xfctzen, wenn sie feststecken, und sich an ihre lernweise anzupassen. online, im klassenzimmer oder irgendwo dazwischen. sophos ist zum gegenw\xe4rtigen zeitpunkt noch in arbeit \u2014 wir bauen, testen und lernen dabei.",
                tags: [
                    "fr\xfchstadium",
                    "ki",
                    "bildung"
                ]
            }
        },
        statuses: {
            active: "aktiv",
            workInProgress: "in arbeit"
        },
        cta: {
            title: "m\xf6chtest du eines ausprobieren?",
            text: "wir verlinken diese nicht \xf6ffentlich \u2014 kontaktiere uns und wir geben dir etwas zum ausprobieren."
        }
    }
};
exports.default = labTranslations;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"dzBzm":[function(require,module,exports,__globalThis) {
// Principles page translations
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const principlesTranslations = {
    en: {
        hero: {
            pill: "principles / thewhizkind",
            title: "a few things we believe in",
            subtitle: [
                "We don't have a 97-page corporate handbook.",
                "What we do have are a few ideas about people, creativity, technology and how we'd like to exist in the world. They shape what we make, who we work with and the decisions we make along the way."
            ]
        },
        principles: [
            {
                title: "Humanity",
                body: [
                    "We live on a small rock travelling through space, orbiting a giant ball of plasma, in a universe we barely understand.",
                    "And, as far as we know, this is the only place where consciousness has looked around and wondered what any of it means.",
                    "That's kind of absurd.",
                    "And kind of incredible.",
                    "So we value people. Their stories, cultures, differences, ideas, weirdness, time, and the tiny fraction of cosmic history we happen to share.",
                    "Work matters. Design matters. Technology matters.",
                    "But none of it matters very much without people.",
                    {
                        strong: "People first. Always."
                    }
                ]
            },
            {
                title: "Different is good",
                body: [
                    "The world would be painfully boring if everyone thought, looked, spoke and created in the same way.",
                    "We value different cultures, backgrounds, identities, perspectives and ways of thinking. Not because diversity looks good on a company page, but because we genuinely believe different people make ideas better.",
                    "You don't have to fit a particular mould to belong here.",
                    "There isn't one."
                ]
            },
            {
                title: "Kindness isn't unprofessional",
                body: [
                    "We take our work seriously.",
                    "We don't think that means we have to take ourselves too seriously.",
                    "Behind every project, deadline, email, meeting and invoice is a human being with a life outside work.",
                    "People have good days. Bad days. Families. Birthdays. Holidays. Problems. 3 a.m. ideas. And occasionally emails they completely forget to reply to.",
                    "Professionalism doesn't have to mean being cold.",
                    "We'd rather work with patience, honesty, empathy and a little humour."
                ]
            },
            {
                title: "Make it accessible",
                body: [
                    "Good design shouldn't create unnecessary barriers.",
                    "We try to make the websites, tools and experiences we create understandable and usable by as many people as reasonably possible.",
                    "We won't always get everything right.",
                    "When we don't, we'd rather learn and improve than pretend we did."
                ]
            },
            {
                title: "Stay curious",
                body: [
                    "Some things are worth exploring simply because someone asked:",
                    {
                        strong: "'What if we tried this?'"
                    },
                    "We like experiments, strange ideas, new technologies and projects whose usefulness isn't immediately obvious.",
                    "Not every experiment needs a business model.",
                    "Not every idea needs a five-year roadmap.",
                    "Sometimes the only good reason to try something is: fuck it, let's see what happens."
                ]
            },
            {
                title: "Humans + AI",
                body: [
                    "We like AI.",
                    "Quite a lot, actually.",
                    "But we don't think technology makes people less important.",
                    "We use AI to explore, experiment, automate boring things and occasionally make things that would have been ridiculous to attempt just a few years ago.",
                    "But judgement, responsibility, empathy, taste and creativity remain human.",
                    "Technology should give people more possibilities, not make people feel disposable."
                ]
            },
            {
                title: "The internet should be fun",
                body: [
                    "Somewhere along the way, a lot of the internet started looking the same.",
                    [
                        "Same layouts. Same gradients. Same perfectly optimised buttons asking you to ",
                        {
                            strong: "get started"
                        },
                        "."
                    ],
                    "We think there should still be room for experiments, personality, weird little tools, unnecessary animations and things that exist simply because someone thought they'd be fun to make.",
                    "Not everything needs to convert. Sometimes you can make something just because it's cool.",
                    "Some things can just make the internet a slightly more interesting place."
                ]
            },
            {
                title: "No unnecessary bullshit",
                body: [
                    "We like simple language, honest conversations and knowing what we're actually trying to accomplish.",
                    "Complicated words don't automatically make ideas smarter.",
                    "More meetings don't automatically make projects better.",
                    "And adding 'AI-powered next-generation ecosystem' to something doesn't necessarily make it one.",
                    "If something can be simpler, we'd rather make it simpler."
                ]
            },
            {
                title: "Relationships over transactions",
                body: [
                    "Of course, we're a business.",
                    "There are projects, contracts, invoices and budgets.",
                    "But we'd rather not reduce every relationship to a transaction.",
                    "We like getting to know the people behind the work. Some collaborations last a few weeks. Some last years. Some turn into friendships. Some are simply a good conversation.",
                    "That's okay.",
                    "Good work is better when there's trust on both sides."
                ]
            },
            {
                title: "More than money",
                body: [
                    "At some point, a lot of what we call success gets reduced to a number sitting in a bank account.",
                    "It's a useful number. We'd be lying if we said it didn't matter.",
                    "We just don't think it should decide everything.",
                    "Some things are worth doing because they mean something. Some because they help someone. Some because they're interesting, strange or challenging. And some simply because we'd like them to exist in the world.",
                    "A bigger number is nice.",
                    "A better story is nicer."
                ]
            },
            {
                title: "Be good to each other",
                body: [
                    "We're here for an absurdly short amount of time.",
                    "On one tiny planet.",
                    "In an unimaginably large universe.",
                    "We might as well make interesting things, help each other when we can, stay curious, disagree without being horrible about it and leave things a little better than we found them.",
                    {
                        strong: "Make good things. Work with good people. Be a good human."
                    },
                    "That's pretty much it."
                ]
            }
        ]
    },
    de: {
        hero: {
            pill: "prinzipien / thewhizkind",
            title: "einige dinge, an die wir glauben",
            subtitle: [
                "wir haben kein 97-seitiges unternehmenshandbuch.",
                "was wir haben, sind einige ideen \xfcber menschen, kreativit\xe4t, technologien und wie wir in der welt existieren m\xf6chten. sie pr\xe4gen, was wir erschaffen, mit wem wir arbeiten und die entscheidungen, die wir unterwegs treffen."
            ]
        },
        principles: [
            {
                title: "menschlichkeit",
                body: [
                    "wir leben auf einem kleinen felsen, der durch den weltraum reist, der eine riesige plasmaskugel umkreist, in einem universum, das wir kaum verstehen.",
                    "und soweit wir wissen, ist dies der einzige ort, an dem sich bewusstsein hervorgetan, umgesehen und gefragt hat, was das alles bedeutet.",
                    "das klingt irgendwie absurd.",
                    "und irgendwie unglaublich.",
                    "daher sch\xe4tzen wir menschen. ihre geschichten, kulturen, unterschiede, ideen, eigenheiten, zeit und den winzigen bruchteil der kosmischen geschichte, den wir zuf\xe4llig teilen.",
                    "arbeit ist wichtig. design ist wichtig. technologie ist wichtig.",
                    "aber nichts davon ist ohne menschen besonders relevant.",
                    {
                        strong: "menschen zuerst. immer."
                    }
                ]
            },
            {
                title: "verschiedenheit ist gut",
                body: [
                    "die welt w\xe4re unertr\xe4glich langweilig, wenn alle gleich d\xe4chten, auss\xe4hen, spr\xe4chen und die gleichen dinge kreierten.",
                    "wir sch\xe4tzen verschiedene kulturen, hintergr\xfcnde, identit\xe4ten, perspektiven und denkweisen. nicht, weil vielfalt auf einer unternehmensseite gut aussieht, sondern weil wir wirklich glauben, dass unterschiedliche menschen ideen besser machen.",
                    "du musst nicht in ein bestimmtes schema passen, um hierher zu geh\xf6ren.",
                    "es gibt keins."
                ]
            },
            {
                title: "freundlichkeit ist nicht unprofessionell",
                body: [
                    "wir nehmen unsere arbeit ernst.",
                    "wir denken nicht, dass das bedeutet, dass wir uns selbst zu ernst nehmen sollten.",
                    "hinter jedem projekt, jeder deadline, jeder e-mail, jedem meeting und jeder rechnung steht ein mensch mit einem leben abseits der arbeit.",
                    "menschen haben gute tage. schlechte tage. familien. geburtstage. feiertage. probleme. ideen um 3 uhr morgens. und gelegentlich e-mails, die sie komplett zu beantworten vers\xe4umen.",
                    "professionalit\xe4t bedeutet nicht, kalt zu sein.",
                    "wir arbeiten lieber mit geduld, ehrlichkeit, einf\xfchlungsverm\xf6gen und einer prise humor."
                ]
            },
            {
                title: "mach es barrierefrei",
                body: [
                    "gutes design sollte keine unn\xf6tigen barrieren schaffen.",
                    "wir versuchen, die websites, werkzeuge und digitalen inhalte, die wir erbauen, in einem vern\xfcnftigen rahmen f\xfcr so viele menschen wie m\xf6glich verst\xe4ndlich und nutzbar zu machen.",
                    "wir werden nicht immer alles richtig machen.",
                    "wenn wir es mal nicht tun, ziehen wir es vor, aus den fehlern zu lernen und uns zu verbessern, statt so zu tun, als h\xe4tten wir alles problemlos geschafft."
                ]
            },
            {
                title: "bleib neugierig",
                body: [
                    "einige dinge sind es bereits deshalb wert erkundet zu werden, weil jemand gefragt hat:",
                    {
                        strong: "'was w\xe4re, wenn wir das versuchen?'"
                    },
                    "wir m\xf6gen experimente, seltsam anmutende ideen, neue technologien und projekte, deren n\xfctzlichkeit nicht sofort offensichtlich ist.",
                    "nicht jedes experiment braucht ein gesch\xe4ftsmodell.",
                    "nicht jede idee braucht einen f\xfcnf-jahres-plan.",
                    "manchmal ist der einzige gute grund, etwas auszuprobieren: schei\xdf drauf, lass uns sehen, was daraus wird."
                ]
            },
            {
                title: "menschen + ki",
                body: [
                    "wir m\xf6gen ki.",
                    "tats\xe4chlich sehr.",
                    "aber wir denken nicht, dass technologie menschen weniger wichtig macht.",
                    "wir nutzen ki, um zu erkunden, zu experimentieren, langweilige dinge zu automatisieren und gelegentlich dinge zu erschaffen, deren umsetzung vor einigen jahren noch absurd gewesen w\xe4re.",
                    "aber urteilsverm\xf6gen, verantwortung, einf\xfchlungsverm\xf6gen, geschmack und kreativit\xe4t bleiben menschlich.",
                    "technologie sollte menschen mehr m\xf6glichkeiten er\xf6ffnen, nicht dazu genutzt werden, dass sich menschen \xfcberfl\xfcssig f\xfchlen."
                ]
            },
            {
                title: "das internet sollte spa\xdf machen",
                body: [
                    "irgendwann begann ein gro\xdfer teil des internets, gleich auszusehen.",
                    [
                        "gleiche layouts. gleiche farbverl\xe4ufe. gleiche perfekt optimierte buttons, die dich auffordern, ",
                        {
                            strong: "loszulegen"
                        },
                        "."
                    ],
                    "wir denken, dass es immer noch platz f\xfcr experimente, pers\xf6nlichkeit, eigent\xfcmliche kleine werkzeuge, unn\xf6tige animationen und dinge geben sollte, einfach weil jemand lust darauf hatte sie zu bauen und die dabei lustig zu erstellen w\xe4ren.",
                    "nicht alles muss sich perfekt einf\xfcgen. manchmal kann man etwas einfach deshalb schaffen, weil es cool ist.",
                    "einige dinge k\xf6nnen das internet einfach zu einem etwas interessanteren ort machen."
                ]
            },
            {
                title: "kein unn\xf6tiger unsinn",
                body: [
                    "wir m\xf6gen einfache sprache, ehrliche gespr\xe4che und sind auf der suche danach, was wir tats\xe4chlich erreichen wollen.",
                    "komplizierte worte machen ideen nicht automatisch kl\xfcger.",
                    "mehr meetings machen projekte nicht automatisch besser.",
                    "und das hinzuf\xfcgen des labels 'ki-gesteuertes next-generation-\xf6kosystem' macht etwas nicht unbedingt zu einem.",
                    "wenn etwas einfacher sein kann, w\xfcrden wir es lieber einfacher machen."
                ]
            },
            {
                title: "beziehungen vor transaktionen",
                body: [
                    "nat\xfcrlich sind wir ein unternehmen.",
                    "es gibt projekte, vertr\xe4ge, rechnungen und budgets.",
                    "aber wir m\xf6chten nicht jede beziehung auf eine transaktion reduzieren.",
                    "wir m\xf6gen es, die menschen hinter der arbeit kennenzulernen. einige kooperationen dauern ein paar wochen. einige dauern jahre. einige entwickeln sich zu freundschaften. einige bestehen einfach aus einem guten und erhellenden gespr\xe4ch.",
                    "das ist in ordnung.",
                    "gute arbeit ist besser, wenn auf beiden seiten vertrauen herrscht."
                ]
            },
            {
                title: "mehr als geld",
                body: [
                    "irgendwann wird ein gro\xdfer teil dessen, was wir erfolg nennen, auf eine zahl auf einem bankkonto reduziert.",
                    "es ist eine n\xfctzliche zahl. wir w\xfcrden l\xfcgen, wenn wir das leugnen w\xfcrden.",
                    "wir denken nur nicht, dass sie alles entscheiden sollte.",
                    "einige dinge sind es wert, getan zu werden, weil sie etwas bedeuten. einige, weil sie jemandem helfen. einige, weil sie interessant, kurios oder herausfordernd sind. und einige einfach, weil wir m\xf6chten, dass sie in die welt hinausgebracht werden.",
                    "eine gr\xf6\xdfere zahl ist sch\xf6n.",
                    "eine sch\xf6ne geschichte ist sch\xf6ner."
                ]
            },
            {
                title: "seid gut zueinander",
                body: [
                    "wir sind f\xfcr eine absurd kurze zeit.",
                    "hier auf einem winzigen planeten.",
                    "in einem unvorstellbar gro\xdfen universum.",
                    "wir k\xf6nnten genauso gut interessante dinge schaffen, einander helfen, wo wir k\xf6nnen, neugierig bleiben, anders denken, ohne dabei grausam zueinander zu sein, und die dinge ein bisschen besser hinterlassen, als wir sie vorgefunden haben.",
                    {
                        strong: "gute dinge schaffen. mit guten menschen arbeiten. ein guter mensch sein."
                    },
                    "das ist im grunde alles."
                ]
            }
        ]
    }
};
exports.default = principlesTranslations;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"ecbGd":[function(require,module,exports,__globalThis) {
// Privacy page translations
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const privacyTranslations = {
    en: {
        hero: {
            pill: "Privacy Policy",
            title: "Privacy Policy",
            subtitle: "Protecting your personal data is a matter of particular importance to us. We treat your personal data confidentially and in accordance with the applicable data protection regulations as well as this privacy policy."
        },
        sections: {
            dataProtection: {
                title: "Data Protection",
                items: {
                    controller: {
                        label: "1. Controller",
                        content: [
                            {
                                strong: "thewhizkind"
                            },
                            "Prayrit Singh",
                            "Email: <email>prayrit@thewhizkind.com</email>"
                        ]
                    },
                    dataCollection: {
                        label: "2. Data Collection on This Website",
                        content: [
                            "Some of your data is collected when you provide it to us \u2014 for example, by sending us an email. Other data is automatically collected by our IT systems when you visit the website (e.g., browser type, operating system, or the time of page access)."
                        ]
                    },
                    hosting: {
                        label: "3. Hosting",
                        content: [
                            "This website is hosted by Hostinger International Ltd, 61 Lordou Vironos Street, 6023 Larnaca, Cyprus.",
                            "Hostinger processes your data only to the extent necessary to fulfill its service obligations and follows our instructions in accordance with a data processing agreement (Article 28 GDPR)."
                        ]
                    },
                    vercel: {
                        label: "4. Vercel",
                        content: [
                            "For building and deploying this website, as well as for our contact form, we use Vercel Inc., 340 S Lemon Ave #4133, Walnut, CA 91789, USA.",
                            "Whenever changes to the source code are pushed to GitHub, Vercel automatically builds and deploys the website. In addition, Vercel processes the data submitted through the contact form via serverless functions and forwards it to our email address. Technical data such as your IP address may be processed in this context.",
                            "The transfer of data to the USA is based on the EU Standard Contractual Clauses (Article 46(2)(c) GDPR). For further information, please see Vercel's privacy policy: <link>https://vercel.com/legal/privacy-policy</link>"
                        ]
                    },
                    github: {
                        label: "5. GitHub",
                        content: [
                            "The source code of this website is managed via GitHub Inc., 88 Colin P Kelly Jr St, San Francisco, CA 94107, USA. Pushing to the repository triggers the automatic deployment process described in Section 4 via the GitHub\u2013Vercel integration.",
                            "GitHub is used exclusively for version control and deployment of the website. No personal data of website visitors is processed in this context.",
                            "For further information, please see GitHub's privacy statement: <link>https://docs.github.com/site-policy/privacy-policies/github-privacy-statement</link>"
                        ]
                    },
                    sslEncryption: {
                        label: "6. SSL or TLS Encryption",
                        content: [
                            "For security reasons, this site uses SSL or TLS encryption. You can recognize an encrypted connection by the fact that the browser's address bar begins with 'https://'."
                        ]
                    },
                    analytics: {
                        label: "7. Analytics and Cookies",
                        content: [
                            "We use Google Analytics, a web analytics service provided by Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland.",
                            "Google Analytics allows us to analyse how our website is used and to improve our services. This may include information such as page views, user interactions, and technical data, for example browser type and device details.",
                            "This data is processed only after you have given your consent through the cookie banner.",
                            "The legal basis for this processing is your consent, in accordance with Article 6(1)(a) GDPR.",
                            "You may withdraw your consent at any time by adjusting your browser settings or clearing your local storage.",
                            "For further information, please see Google's privacy policy: <link>https://policies.google.com/privacy</link>"
                        ]
                    },
                    scope: {
                        label: "8. Scope of Application",
                        content: [
                            "This privacy policy applies to websites, web applications and digital services for which thewhizkind is the controller, unless a separate privacy policy applies.",
                            "It does not automatically apply to websites, applications or services created, maintained or technically supported by thewhizkind for other people or organisations. The respective operator is responsible for providing the applicable privacy information where they act as the controller."
                        ]
                    },
                    work: {
                        label: "9. Work on Websites, Applications and Digital Services",
                        content: [
                            "As part of our work, thewhizkind designs, develops, maintains and supports websites, web applications, digital tools, automations and other digital services for people and organisations we work with.",
                            "In the course of this work, we may technically have access to personal data processed through these systems, for example when providing development, maintenance, troubleshooting, hosting-related support or technical administration.",
                            "Where thewhizkind processes personal data on behalf of another person or organisation, that person or organisation generally remains the controller for the respective processing and thewhizkind acts as a processor within the meaning of Article 28 GDPR, where applicable.",
                            "Such processing is limited to what is necessary to provide the agreed services and is carried out in accordance with the instructions of the respective controller.",
                            "We do not use personal data accessed through these systems for our own independent purposes.",
                            "Depending on the project, additional service providers and technical infrastructure may be involved. The applicable data protection arrangements are determined according to the individual project."
                        ]
                    },
                    contact: {
                        label: "10. Contact",
                        content: [
                            "If you contact us via email, the information you provide, including your contact details, will be stored for the purpose of processing your inquiry and in case of follow-up questions. We do not share this data without your consent."
                        ]
                    }
                }
            }
        }
    },
    de: {
        hero: {
            pill: "Datenschutzerkl\xe4rung",
            title: "Datenschutz\xaderkl\xe4rung",
            subtitle: "Der Schutz deiner pers\xf6nlichen Daten ist uns ein besonderes Anliegen. Wir behandeln deine personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerkl\xe4rung."
        },
        sections: {
            dataProtection: {
                title: "Datenschutz",
                items: {
                    controller: {
                        label: "1. Verantwortlicher",
                        content: [
                            {
                                strong: "thewhizkind"
                            },
                            "Prayrit Singh",
                            "E-Mail: <email>prayrit@thewhizkind.com</email>"
                        ]
                    },
                    dataCollection: {
                        label: "2. Datenerfassung auf dieser Website",
                        content: [
                            "Deine Daten werden zum einen dadurch erhoben, dass du uns diese mitteilst \u2014 z. B. durch das Versenden einer E-Mail an uns. Andere Daten werden automatisch beim Besuch der Website durch IT-Systeme erfasst (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs)."
                        ]
                    },
                    hosting: {
                        label: "3. Hosting",
                        content: [
                            "Diese Website wird gehostet bei Hostinger International Ltd, 61 Lordou Vironos Street, 6023 Larnaca, Zypern.",
                            "Hostinger verarbeitet deine Daten nur soweit erforderlich zur Erf\xfcllung seiner Leistungspflichten und folgt unseren Weisungen im Rahmen eines Auftragsverarbeitungsvertrags (Art. 28 DSGVO)."
                        ]
                    },
                    vercel: {
                        label: "4. Vercel",
                        content: [
                            "F\xfcr den Build- und Bereitstellungsprozess (Deployment) dieser Website sowie f\xfcr unser Kontaktformular nutzen wir Vercel Inc., 340 S Lemon Ave #4133, Walnut, CA 91789, USA.",
                            "Sobald \xc4nderungen am Quellcode auf GitHub ver\xf6ffentlicht werden, baut und ver\xf6ffentlicht Vercel die Website automatisch. Zus\xe4tzlich verarbeitet Vercel die \xfcber das Kontaktformular eingegebenen Daten mittels serverloser Funktionen (Serverless Functions) und leitet diese an unsere E-Mail-Adresse weiter. Dabei k\xf6nnen technische Daten wie deine IP-Adresse verarbeitet werden.",
                            "Die Daten\xfcbertragung in die USA erfolgt auf Grundlage der EU-Standardvertragsklauseln (Art. 46 Abs. 2 lit. c DSGVO). Weitere Informationen findest du in der Datenschutzerkl\xe4rung von Vercel: <link>https://vercel.com/legal/privacy-policy</link>"
                        ]
                    },
                    github: {
                        label: "5. GitHub",
                        content: [
                            "Der Quellcode dieser Website wird \xfcber GitHub Inc., 88 Colin P Kelly Jr St, San Francisco, CA 94107, USA, verwaltet. Ein Push auf das Repository l\xf6st \xfcber die GitHub-Vercel-Integration den im Abschnitt 4 beschriebenen automatischen Deployment-Vorgang aus.",
                            "GitHub wird ausschlie\xdflich zur Versionsverwaltung und zur Bereitstellung (Deployment) der Website genutzt. Dabei werden keine personenbezogenen Daten von Besucherinnen und Besuchern der Website verarbeitet.",
                            "Weitere Informationen findest du in der Datenschutzerkl\xe4rung von GitHub: <link>https://docs.github.com/site-policy/privacy-policies/github-privacy-statement</link>"
                        ]
                    },
                    sslEncryption: {
                        label: "6. SSL- bzw. TLS-Verschl\xfcsselung",
                        content: [
                            "Diese Seite nutzt aus Sicherheitsgr\xfcnden eine SSL- bzw. TLS-Verschl\xfcsselung. Eine verschl\xfcsselte Verbindung erkennst du daran, dass die Adresszeile des Browsers mit 'https://' beginnt."
                        ]
                    },
                    analytics: {
                        label: "7. Analyse & Cookies",
                        content: [
                            "Wir nutzen Google Analytics, einen Webanalysedienst der Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland.",
                            "Google Analytics hilft uns dabei, die Nutzung unserer Website auszuwerten und unser Angebot zu verbessern. Dabei werden unter anderem Seitenaufrufe, Interaktionen auf der Website sowie technische Informationen wie Browsertyp und Ger\xe4tedaten erfasst.",
                            "Die Verarbeitung dieser Daten erfolgt ausschlie\xdflich nach deiner Einwilligung \xfcber das Cookie-Banner.",
                            "Rechtsgrundlage ist deine Einwilligung gem\xe4\xdf Art. 6 Abs. 1 lit. a DSGVO.",
                            "Du kannst deine Einwilligung jederzeit widerrufen, indem du deine Browsereinstellungen \xe4nderst oder den lokalen Speicher deines Ger\xe4ts l\xf6schst.",
                            "Weitere Informationen findest du in der Datenschutzerkl\xe4rung von Google: <link>https://policies.google.com/privacy</link>"
                        ]
                    },
                    scope: {
                        label: "8. Geltungsbereich",
                        content: [
                            "Diese Datenschutzerkl\xe4rung gilt f\xfcr Webseiten, Webanwendungen und digitale Dienste, f\xfcr die thewhizkind Verantwortlicher ist, sofern keine gesonderte Datenschutzerkl\xe4rung gilt.",
                            "Sie gilt nicht automatisch f\xfcr Webseiten, Anwendungen oder Dienste, die von thewhizkind f\xfcr andere Personen oder Organisationen erstellt, gepflegt oder technisch betreut werden. Der jeweilige Betreiber ist f\xfcr die Bereitstellung der geltenden Datenschutzinformationen verantwortlich, soweit er als Verantwortlicher handelt."
                        ]
                    },
                    work: {
                        label: "9. Arbeiten an Webseiten, Anwendungen und digitalen Diensten",
                        content: [
                            "Im Rahmen unserer T\xe4tigkeit konzipiert, entwickelt, pflegt und betreut thewhizkind Webseiten, Webanwendungen, digitale Werkzeuge, Automatisierungen und andere digitale Dienste f\xfcr Personen und Organisationen, mit denen wir zusammenarbeiten.",
                            "Im Zuge dieser T\xe4tigkeit k\xf6nnen wir technisch auf personenbezogene Daten zugreifen, die \xfcber diese Systeme verarbeitet werden, beispielsweise bei der Entwicklung, Wartung, Fehlerbehebung, Unterst\xfctzung im Zusammenhang mit Hosting oder technischen Administration.",
                            "Soweit thewhizkind personenbezogene Daten im Auftrag einer anderen Person oder Organisation verarbeitet, bleibt diese Person oder Organisation grunds\xe4tzlich Verantwortlicher f\xfcr die jeweilige Verarbeitung, und thewhizkind handelt, soweit anwendbar, als Auftragsverarbeiter im Sinne von Artikel 28 DSGVO.",
                            "Eine solche Verarbeitung ist auf das f\xfcr die Erbringung der vereinbarten Leistungen erforderliche Ma\xdf beschr\xe4nkt und erfolgt gem\xe4\xdf den Weisungen des jeweiligen Verantwortlichen.",
                            "Wir verwenden personenbezogene Daten, auf die wir \xfcber diese Systeme zugreifen, nicht f\xfcr eigene, unabh\xe4ngige Zwecke.",
                            "Je nach Projekt k\xf6nnen weitere Dienstleister und technische Infrastrukturen beteiligt sein. Die geltenden Datenschutzregelungen werden entsprechend dem jeweiligen Projekt festgelegt."
                        ]
                    },
                    contact: {
                        label: "10. Kontaktaufnahme",
                        content: [
                            "Wenn du uns per E-Mail kontaktierst, werden deine Angaben inklusive der von dir angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und f\xfcr den Fall von Anschlussfragen gespeichert. Diese Daten geben wir nicht ohne deine Einwilligung weiter."
                        ]
                    }
                }
            }
        }
    }
};
exports.default = privacyTranslations;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"759ss":[function(require,module,exports,__globalThis) {
// Disclaimer page translations
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const disclaimerTranslations = {
    en: {
        hero: {
            pill: "Disclaimer",
            title: "Information",
            subtitle: "Legal information and contact details."
        },
        sections: {
            title: "Information",
            company: {
                name: "thewhizkind",
                person: "Prayrit Singh"
            },
            contact: {
                label: "Contact",
                items: [
                    {
                        label: "E-Mail",
                        value: "prayrit@thewhizkind.com",
                        type: "email"
                    },
                    {
                        label: "Website",
                        value: "www.thewhizkind.com",
                        type: "url"
                    },
                    {
                        label: "Business address (Germany)",
                        value: "Gumbertstra\xdfe 150 EG Rechts, 40229 D\xfcsseldorf"
                    },
                    {
                        label: "Business address (India)",
                        value: "20, Block H-1/A, Sector 63, Noida 201301, Uttar Pradesh, India"
                    }
                ]
            },
            vat: {
                label: "VAT Identification Number in accordance with \xa727a of the German VAT Act",
                value: "018 870 02282"
            },
            gst: {
                label: "GST Identification Number (India)",
                value: "GSTIN: 09LBAPS6420C1ZM"
            },
            accessibility: {
                label: "Accessibility",
                content: [
                    "We aim to make thewhizkind accessible to as many people as possible and use the <strong>Web Content Accessibility Guidelines (WCAG) 2.2 Level AA</strong> as our accessibility target.",
                    "Accessibility is continuously reviewed and improved as the website develops. Despite our efforts, individual barriers may remain.",
                    "For more information about accessibility, available preferences or to report a barrier, please visit our <link-accessibility>accessibility page</link-accessibility> or contact us at <email>prayrit@thewhizkind.com</email>."
                ]
            },
            responsible: {
                label: "Responsible for content",
                value: "Prayrit Singh"
            }
        }
    },
    de: {
        hero: {
            pill: "Impressum",
            title: "Angaben & Information",
            subtitle: "Rechtliche Hinweise und Kontaktinformationen."
        },
        sections: {
            title: "Angaben",
            company: {
                name: "thewhizkind",
                person: "Prayrit Singh"
            },
            contact: {
                label: "Kontakt",
                items: [
                    {
                        label: "E-Mail",
                        value: "prayrit@thewhizkind.com",
                        type: "email"
                    },
                    {
                        label: "Website",
                        value: "www.thewhizkind.com",
                        type: "url"
                    },
                    {
                        label: "Gesch\xe4ftsanschrift (Deutschland)",
                        value: "Gumbertstra\xdfe 150 EG Rechts, 40229 D\xfcsseldorf"
                    },
                    {
                        label: "Gesch\xe4ftsanschrift (Indien)",
                        value: "20, Block H-1/A, Sector 63, Noida 201301, Uttar Pradesh, India"
                    }
                ]
            },
            vat: {
                label: "Umsatzsteuer-Identifikationsnummer gem\xe4\xdf \xa727a UStG",
                value: "018 870 02282"
            },
            gst: {
                label: "GST-Identifikationsnummer (Indien)",
                value: "GSTIN: 09LBAPS6420C1ZM"
            },
            accessibility: {
                label: "Barrierefreiheit",
                content: [
                    "Wir m\xf6chten thewhizkind f\xfcr m\xf6glichst viele Menschen zug\xe4nglich machen und orientieren uns dabei an den <strong>Web Content Accessibility Guidelines (WCAG) 2.2, Konformit\xe4tsstufe AA</strong>.",
                    "Die Barrierefreiheit wird w\xe4hrend der Weiterentwicklung der Website fortlaufend \xfcberpr\xfcft und verbessert. Trotz unserer Bem\xfchungen k\xf6nnen einzelne Barrieren bestehen bleiben.",
                    "Weitere Informationen zur Barrierefreiheit und zu den verf\xfcgbaren Einstellungen sowie die M\xf6glichkeit, eine Barriere zu melden, findest du auf unserer <link-accessibility>Seite zur Barrierefreiheit</link-accessibility> oder kontaktiere uns unter <email>prayrit@thewhizkind.com</email>."
                ]
            },
            responsible: {
                label: "Verantwortlich f\xfcr den Inhalt",
                value: "Prayrit Singh"
            }
        }
    }
};
exports.default = disclaimerTranslations;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"b8SLX":[function(require,module,exports,__globalThis) {
// Accessibility page translations
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const accessibilityTranslations = {
    en: {
        hero: {
            kicker: "accessibility / thewhizkind",
            title: "accessibility",
            subtitle: "access isn't an extra."
        },
        sections: {
            builtIn: {
                index: "01",
                title: "built in, not switched on.",
                content: [
                    "the web is meant to be used by people: different people, using different devices, different ways of navigating and different ways of experiencing what's on a screen.",
                    "we believe accessibility is part of good design, not something added after the design is finished.",
                    "that's why thewhizkind is being built with <strong>WCAG 2.2 Level AA</strong> as its accessibility target. accessibility considerations are part of the structure, navigation, interactions, colour contrast, motion and content of the website itself.",
                    "the default experience is designed to support keyboard navigation, screen readers, visible focus states, sufficient colour contrast, scalable content, semantic structure and reduced-motion preferences.",
                    "the accessibility controls you see on the website don't make thewhizkind accessible. they're there because different people have different preferences.",
                    {
                        emphasis: "accessibility starts before those controls do."
                    }
                ]
            },
            preferences: {
                index: "02",
                title: "one web. different ways to use it.",
                content: [
                    "on top of the accessible baseline, you can adapt parts of the experience to suit you. accessibility preferences are always available in the bottom-right corner of the website.",
                    "changes take effect immediately. your choices are stored locally in your browser and can be changed or reset at any time. accessibility preferences aren't sent to us."
                ],
                preferences: [
                    {
                        title: "larger text",
                        description: "increases text size across the website."
                    },
                    {
                        title: "higher contrast",
                        description: "increases visual contrast beyond the standard presentation."
                    },
                    {
                        title: "reduce motion",
                        description: "reduces non-essential movement and animation."
                    },
                    {
                        title: "underline links",
                        description: "makes text links easier to distinguish from surrounding content."
                    }
                ]
            },
            contact: {
                index: "03",
                title: "we're still learning.",
                content: [
                    "accessibility isn't a box we consider checked.",
                    "websites change. standards evolve. automated tests can only tell us so much about how something actually feels to use.",
                    "we'll continue reviewing and improving thewhizkind as it develops.",
                    "if you encounter a barrier, whether something is difficult to navigate, read, understand or operate, we'd like to hear about it."
                ],
                email: "prayrit@thewhizkind.com",
                emphasis: "if we can make it better, we will."
            }
        }
    },
    de: {
        hero: {
            kicker: "barrierefreiheit / thewhizkind",
            title: "barrierefreiheit",
            subtitle: "zug\xe4nglichkeit ist kein extra."
        },
        sections: {
            builtIn: {
                index: "01",
                title: "eingebaut, nicht eingeschaltet.",
                content: [
                    "das web soll von menschen genutzt werden: unterschiedliche menschen, die unterschiedliche ger\xe4te nutzen, unterschiedliche wege der navigation und unterschiedliche arten, das, was auf dem bildschirm zu sehen ist, zu erleben.",
                    "wir glauben, dass barrierefreiheit ein teil von gutem design ist, nicht etwas, das nachtr\xe4glich hinzugef\xfcgt wird.",
                    "deshalb wird thewhizkind mit <strong>WCAG 2.2 Level AA</strong> als barrierefreiheits-ziel entwickelt. barrierefreiheits-\xfcberlegungen sind teil der struktur, navigation, interaktionen, farbkontraste, bewegung und inhalte der website selbst.",
                    "das standard-erlebnis ist so gestaltet, dass es tastatur-navigation, screenreader, sichtbare fokus-zust\xe4nde, ausreichenden farbkontrast, skalierbare inhalte, semantische struktur und pr\xe4ferenzen f\xfcr reduzierte bewegung unterst\xfctzt.",
                    "die barrierefreiheits-steuerungen, die du auf der website siehst, machen thewhizkind nicht barrierefrei. sie sind da, weil verschiedene menschen unterschiedliche pr\xe4ferenzen haben.",
                    {
                        emphasis: "barrierefreiheit beginnt vor diesen steuerungen."
                    }
                ]
            },
            preferences: {
                index: "02",
                title: "ein web. verschiedene nutzungsm\xf6glichkeiten.",
                content: [
                    "zus\xe4tzlich zur barrierefreien basis kannst du teile des erlebnisses an deine bed\xfcrfnisse anpassen. barrierefreiheits-pr\xe4ferenzen sind immer im untersten rechten eck der website verf\xfcgbar.",
                    "\xe4nderungen treten sofort in kraft. deine auswahl wird lokal in deinem browser gespeichert und kann jederzeit ge\xe4ndert oder zur\xfcckgesetzt werden. barrierefreiheits-pr\xe4ferenzen werden nicht an uns gesendet."
                ],
                preferences: [
                    {
                        title: "gr\xf6\xdferer text",
                        description: "erh\xf6ht die textgr\xf6\xdfe auf der gesamten website."
                    },
                    {
                        title: "h\xf6herer kontrast",
                        description: "erh\xf6ht den visuellen kontrast \xfcber die standard-pr\xe4sentation hinaus."
                    },
                    {
                        title: "bewegung reduzieren",
                        description: "reduziert unn\xf6tige bewegung und animationen."
                    },
                    {
                        title: "links unterstreichen",
                        description: "macht textlinks leichter vom umgebenden inhalt zu unterscheiden."
                    }
                ]
            },
            contact: {
                index: "03",
                title: "wir lernen noch.",
                content: [
                    "barrierefreiheit ist f\xfcr uns kein abgehaktes k\xe4stchen.",
                    "websites ver\xe4ndern sich. standards entwickeln sich weiter. automatisierte tests k\xf6nnen uns nur begrenzt verraten, wie sich etwas bei der tats\xe4chlichen nutzung anf\xfchlt.",
                    "wir werden thewhizkind weiterhin \xfcberpr\xfcfen und verbessern, w\xe4hrend es sich entwickelt.",
                    "wenn du auf eine barriere st\xf6\xdft, sei es bei der navigation, beim lesen, verstehen oder bedienen, m\xf6chten wir davon erfahren."
                ],
                email: "prayrit@thewhizkind.com",
                emphasis: "wenn wir es besser machen k\xf6nnen, werden wir es tun."
            }
        }
    }
};
exports.default = accessibilityTranslations;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"lUwsf":[function(require,module,exports,__globalThis) {
// Gallery page translations
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const galleryTranslations = {
    en: {
        hero: {
            title: "thewhizkind gallery",
            eyebrow: "gallery / thewhizkind \u2014 archive 2023\u2014ongoing. some collaborations remain confidential.",
            title1: "selected",
            title2: "visual work.",
            subtitle: "about this gallery",
            description: "a selection of our more visual work \u2014 identities, campaigns, publications and digital experiences. just one part of what we do.",
            kicker: "branding / identity / graphic design / campaigns / editorial / visual communication"
        },
        cta: {
            label: "start a conversation",
            title: "let's make the next thing",
            subtitle: "worth noticing.",
            linkWebsite: "Visit the official website"
        },
        project: {
            view: "View Project",
            details: "Project Details",
            year: "Year",
            client: "Client",
            services: "Services",
            category: "Category",
            read: "Read PDF"
        },
        navigation: {
            gallery: "thewhizkind gallery",
            previous: "Previous",
            next: "Next",
            close: "Close",
            imageViewer: "image viewer",
            galleryPreview: "gallery preview"
        },
        sections: {
            mobiarts: {
                title: "Goethe MobiArts 2025",
                description: "Goethe MobiArts is a programme by the Goethe-Institut that promotes intercultural dialogue and supports emerging artists from Sub-Saharan Africa through international mobility and exchange. We developed the visual identity for Goethe MobiArts 2025, shaping a bold and cohesive design system that reflects movement, diversity and cross-cultural connection. The identity provides a strong visual framework for communication across multiple countries and formats."
            },
            "mein-weg": {
                title: "Mein Weg nach Deutschland",
                description: "As part of the Goethe-Institut\u2019s Mein Weg nach Deutschland project, the initiative supports people who want to live, study or work in Germany. It does so through courses, guidance and clear information on language, culture and careers. We supported the project through online editorial work, multilingual content design, social media support and newsletter coordination, working closely with the design and quality assurance teams to help ensure that information reaches people clearly and reliably."
            },
            spaziertreff: {
                title: "Spaziertreff",
                description: "Spaziertreff is a community health initiative by Fit in Frankfurt that brings people together through regular neighborhood walks across the city. We designed a scalable visual system for the project, creating a series of location-specific posters and communication materials that remain clear, accessible and instantly recognisable while adapting to different districts and meeting points. The result is a calm and approachable visual identity that supports social connection, movement and public participation."
            },
            "august-sander": {
                title: "August Sander Schule",
                description: "August Sander Schule is a vibrant vocational school in Berlin with a strong focus on practical skills, personal development and inclusive learning. We developed its complete digital identity, from corporate design and logo to website and social media, and launched its Instagram presence. The result is clear, human and future focused communication that reflects the school\u2019s values."
            },
            kaleidoskop: {
                title: "Kaleidoskop",
                description: "Kaleidoskop is the German student newspaper of the Goethe-Institut New Delhi. It presents young voices and cultural perspectives from India and Germany. We have been designing the print editions since 2023. Click on the newspaper to read it. The publication is in German only. Content \xa9 Goethe-Institut New Delhi. No rights are held by us."
            },
            apero: {
                title: "Ap\xe9ro Litt\xe9raire",
                description: "Ap\xe9ro Litt\xe9raire is a monthly cultural gathering that brings people together around a shared love of literature in a relaxed and welcoming atmosphere. Over a drink, participants exchange ideas, discuss books and authors, and discover new perspectives through open conversation. We developed the visual identity and continue to produce graphic materials for each edition, ensuring a consistent yet evolving visual presence that reflects the event\u2019s warm and inclusive spirit."
            },
            "goethe-connect": {
                title: "Games Connect Africa",
                description: "Games Connect Africa is a regional initiative dedicated to building a strong, connected and sustainable gaming ecosystem across the continent. We developed the project\u2019s visual identity and graphic language, translating its mission into a clear, inclusive and forward-looking design. Our work reinforces the initiative\u2019s commitment to empowering local talent, encouraging collaboration and raising the global profile of African game development."
            },
            "graphic-passages": {
                title: "Graphic Passages",
                description: "Graphic Passages is a cross-cultural project that translates German graphic novels into South Asian languages, expanding access to graphic literature for an adult audience. We developed its visual identity and communication to clearly reflect the project\u2019s aim of cultural exchange between Germany and South Asia."
            },
            "goethe-gboro-nights": {
                title: "Goethe Gb\xf4r\xf4 Nights",
                description: "Goethe Gb\xf4r\xf4 Nights is an after-work gaming event series in Abidjan that brings the local gaming community together for relaxed and social evenings. We developed the project\u2019s visual identity and graphic assets, supporting an event format that blends gaming tournaments, expert meet-ups, board and party games, karaoke and creative workshops such as 3D printing. The programme is designed to encourage connection, exchange and enjoyment within the Ivorian gaming scene."
            },
            "silent-book-club": {
                title: "Silent Book Club Abidjan",
                description: "Silent Book Club Abidjan is one of the first Silent Book Clubs on the African continent, bringing readers together at the Goethe-Institut Abidjan for a shared, quiet reading experience. We created the visual assets and graphic materials for the club, supporting its open, inclusive concept where participants read their own books and connect afterward in a relaxed, pressure-free atmosphere."
            },
            fecojazzhb: {
                title: "FECOJAZZHB 2024",
                description: "FECOJAZZHB 2024 (Festival Codijazz et Humour de Bingerville) is a music and culture festival celebrating Afro-Jazz, humour and contemporary artistic expression in C\xf4te d\u2019Ivoire. We developed social media content for the festival, designing bold, high-impact visuals to promote the closing concert and showcase the event\u2019s artists, atmosphere and cultural energy across digital platforms."
            },
            "goethe-kreativ": {
                title: "World Wanderers",
                description: "World Wanderers is a two-day, family-friendly event celebrating linguistic and cultural diversity, organised by the British Council and the Goethe-Institut. We created the visual assets and graphic materials, designing playful and welcoming visuals that engage children and families while supporting a joyful introduction to languages and cultures."
            },
            "data-and-drama": {
                title: "Data & Drama",
                description: "Data & Drama was an interactive workshop that explores the intersection of AI and visual art, introducing participants to vision language models, AI-generated audio and creative AI tools. We developed the visual assets and graphic materials for the workshop, supporting a hands-on learning experience for artists, students and visual creation enthusiasts. The programme is complemented by discussions on how emerging technologies are shaping the future of art and the creative industries."
            },
            "the-city-dreams-in-ai": {
                title: "The City Dreams in AI",
                description: "The City Dreams in AI is a two-day experimental workshop that explores speculative audiovisual world-building through AI. Participants gathered sights and sounds across Delhi through city drifting and combined them with AI tools to create speculative, audio-reactive visuals. We developed the visual assets and graphic materials for the workshop, supporting an immersive format that brought together artists, designers and creative technologists. The programme invited participants to explore AI as part of existing creative workflows, with no coding experience required."
            },
            weihnachten: {
                title: "Christmas in the Library of Goethe-Institut Abidjan",
                description: "Christmas in the Library was a festive event series at the Goethe-Institut Abidjan, bringing together visitors of all ages through creative workshops, film screenings, games and shared moments in the library. We developed the visual assets and graphic materials for the series, creating a warm and festive look that reflected togetherness, creativity and a strong sense of community."
            },
            "team-bildung": {
                title: "Announcement Post",
                description: "A social media post designed for the Goethe-Institut Abidjan to communicate a special internal team day, combining clear information with a warm and community-focused visual tone. We designed the social media visual to balance clarity and approachability, while highlighting togetherness and internal engagement."
            },
            "fonds-artvenir": {
                title: "Fonds A(rt)venir",
                description: "Fonds A(rt)venir is a funding programme by the Goethe-Institut C\xf4te d\u2019Ivoire that has been supporting the local artistic scene since 2021. The fund focuses on strengthening artistic resilience in times of ongoing crisis while looking toward the future, promoting innovative, collaborative, and internationally relevant artistic productions. We supported Fonds A(rt)venir with social media communication for the programme, helping amplify its visibility, reach local creative communities, and communicate key calls and timelines through clear and engaging digital content."
            },
            "masa-lab": {
                title: "MASA Lab",
                description: "MASA Lab is an incubator programme supporting performing arts talent in C\xf4te d\u2019Ivoire, offering professional guidance, training and visibility for artists working in music, dance and theatre. We designed a social media visual to support the programme\u2019s communication, translating the energy of live performance and artistic development into a clear and engaging post for digital platforms."
            },
            "beau-decembre": {
                title: "Beau D\xe9cembre: Christmas Concert Postcard",
                description: "A festive postcard designed for Beau D\xe9cembre, a Christmas concert celebrating classical music and the spirit of the holiday season at the Goethe-Institut C\xf4te d\u2019Ivoire. We designed the postcard visual by combining warm, seasonal imagery with a soft and atmospheric aesthetic. The design reflects the joy, light and calm of a musical evening inspired by No\xebl."
            },
            "concert-codijazz": {
                title: "Concert \u2014 Racines by Jean Baptiste Moundele",
                description: "A concert by Jean Baptiste Moundele, presented as part of the Codijazz platform at the Goethe-Institut Abidjan. We designed a social media post to promote the event, translating the concert\u2019s atmosphere and musical identity into a clear and engaging visual tailored for digital platforms."
            },
            "uber-literatur-sprechen": {
                title: "\xdcber Literatur sprechen",
                description: "\u201CTalking About Literature\u201D is a German-language workshop held at the Goethe-Institut Abidjan as part of the pre-integration programme Living and Working in Germany. The workshop invites participants to discuss selected contemporary German novels from the institute\u2019s library and to practise spoken German in an open and interactive setting. We developed the visual assets and graphic materials for the workshop, supporting clear communication and a welcoming learning environment focused on literature, language exchange and dialogue."
            },
            blickpunkt: {
                title: "Blickpunkt \u2013 Point de vue",
                description: "Blickpunkt \u2013 Point de vue has become a well-established event format that alternates between film screenings with Q&A sessions and discussion evenings focused on pressing topics within the Ivorian and African film scenes. These conversations are critically explored with prominent guests and moderated by Prof. Assie Boni. We had the pleasure of designing visual materials for several editions of the series, contributing to a clear and engaging visual presence that supports dialogue, exchange, and contemporary cultural debate."
            }
        }
    },
    de: {
        hero: {
            title: "thewhizkind galerie",
            eyebrow: "galerie / thewhizkind \u2014 archiv 2023\u2014laufend. einige kooperationen bleiben vertraulich.",
            title1: "ausgew\xe4hlte",
            title2: "grafikprojekte.",
            subtitle: "\xfcber diese galerie",
            description: "eine auswahl unserer grafischen arbeiten \u2014 corporate identity, kampagnen, publikationen und digitale teilhabe. nur ein teil dessen, was wir tun.",
            kicker: "markenbildung / corporate identity / grafikdesign / kampagnen / redaktion / \xf6ffentlichkeitsarbeit"
        },
        cta: {
            label: "ein gespr\xe4ch beginnen",
            title: "lass uns das n\xe4chste ding",
            subtitle: "beachtenswert machen.",
            linkWebsite: "besuche die offizielle website"
        },
        project: {
            view: "projekt ansehen",
            details: "projektdetails",
            year: "jahr",
            client: "f\xfcr",
            services: "leistungen",
            category: "kategorie",
            read: "pdf lesen"
        },
        navigation: {
            gallery: "thewhizkind galerie",
            previous: "zur\xfcck",
            next: "weiter",
            close: "schlie\xdfen",
            imageViewer: "bildbetrachter",
            galleryPreview: "galerie-vorschau"
        },
        sections: {
            mobiarts: {
                title: "Goethe MobiArts 2025",
                description: "Goethe MobiArts ist ein programm des Goethe-Instituts, das den interkulturellen dialog f\xf6rdert, indem es aufstrebenden k\xfcnstlerinnen und k\xfcnstlern aus Subsahara-Afrika internationale mobilit\xe4t und austausch erm\xf6glicht. wir haben das \xf6ffentliche image f\xfcr Goethe MobiArts 2025 gestaltet und ein markantes, stimmiges designsystem geschaffen, das bewegung, vielfalt und interkulturelle verbundenheit ausstrahlt. das ergebnis bildet einen starken visuellen rahmen f\xfcr die kommunikation \xfcber mehrere l\xe4nder und formate hinweg."
            },
            "mein-weg": {
                title: "Mein Weg nach Deutschland",
                description: "im rahmen des projekts Mein Weg nach Deutschland des Goethe-Instituts werden menschen unterst\xfctzt, die in Deutschland leben, studieren oder arbeiten m\xf6chten. dies gelingt mit kursen, beratung und klaren informationen zu sprache, kultur und berufen. wir haben das projekt durch redaktionelle online-arbeit, mehrsprachiges content-design, social-media-betreuung und die koordination des newsletters begleitet und eng mit den design- und qualit\xe4tssicherungsteams zusammengearbeitet, damit informationen die menschen eindeutig und zuverl\xe4ssig erreichen."
            },
            spaziertreff: {
                title: "Spaziertreff",
                description: "Spaziertreff ist eine gemeinschaftliche gesundheitsinitiative von Fit in Frankfurt, die menschen durch regelm\xe4\xdfig stattfindende spazierg\xe4nge mit der nachbarschaft in der ganzen stadt zusammenbringt. wir haben ein skalierbares grafisches konzept f\xfcr das projekt entworfen und eine reihe standortspezifischer plakate und kommunikationsformen gestaltet, die klar, barrierefrei und sofort wiedererkennbar sind und sich zugleich in die unterschiedlichen stadtteile und treffpunkte einf\xfcgen. das ergebnis ist ein ruhiges, einladendes design, das soziale verbindung, bewegung und \xf6ffentliche teilhabe ausdr\xfcckt."
            },
            "august-sander": {
                title: "August Sander Schule",
                description: "die August Sander Schule ist eine lebendige berufsschule in Berlin mit einem starken fokus auf praktische kompetenz, pers\xf6nlichkeitsentwicklung und inklusives lernen. wir haben ihren gesamten digitalen auftritt gestaltet \u2013 vom corporate design und logo bis zur website und social media \u2013 und ihre Instagram-pr\xe4senz aufgebaut. das ergebnis ist eine klare, menschliche und zukunftsorientierte botschaft, die die werte der schule betont."
            },
            kaleidoskop: {
                title: "Kaleidoskop",
                description: "kaleidoskop ist die deutschsprachige sch\xfclerzeitung des Goethe-Instituts Neu-Delhi. sie repr\xe4sentiert junge stimmen und kulturelle perspektiven aus Indien und Deutschland. seit 2023 gestalten wir die printausgaben. zum lesen einfach auf die zeitung klicken. die publikation erscheint ausschlie\xdflich auf deutsch. inhalte \xa9 Goethe-Institut Neu-Delhi. wir besitzen keine rechte daran."
            },
            apero: {
                title: "Ap\xe9ro Litt\xe9raire",
                description: "Ap\xe9ro Litt\xe9raire ist ein monatliches kulturtreffen, das menschen in gel\xf6ster, einladender atmosph\xe4re mit der gemeinsamen liebe zur literatur zusammenbringt. bei einem drink tauschen die teilnehmenden ideen aus, diskutieren \xfcber b\xfccher und autorinnen und autoren und entdecken im offenen gespr\xe4ch neue blickwinkel. wir haben das \xf6ffentliche gesicht modelliert und entwerfen weiterhin die grafischen akzente f\xfcr jede ausgabe \u2013 f\xfcr einen einheitlichen und zugleich wandelbaren visuellen auftritt, der ein gef\xfchl f\xfcr den herzlichen und inklusiven charakter der veranstaltung gibt."
            },
            "goethe-connect": {
                title: "Games Connect Africa",
                description: "Games Connect Africa ist eine regionale initiative, die ein starkes, vernetztes und nachhaltiges gaming-\xf6kosystem auf dem gesamten kontinent aufbauen m\xf6chte. wir haben das visuelle image und die bildsprache des projekts kreiert und seinen gesellschaftlichen auftrag in ein klares, inklusives und zukunftsweisendes design \xfcbersetzt. unsere arbeit st\xe4rkt das engagement der initiative, lokale talente zu f\xf6rdern, zusammenarbeit anzuregen und die internationale bekanntheit der afrikanischen spieleentwicklung zu steigern."
            },
            "graphic-passages": {
                title: "Graphic Passages",
                description: "Graphic Passages ist ein interkulturelles projekt, das deutsche graphic novels in s\xfcdasiatische sprachen \xfcbersetzt, um einem erwachsenen publikum den zugang zu grafischer literatur zu erleichtern. wir haben die digitale identit\xe4t des projekts entworfen und die kommunikation des projektziels, den kulturellen austausch zwischen Deutschland und S\xfcdasien zu st\xe4rken, zum ausdruck gebracht."
            },
            "goethe-gboro-nights": {
                title: "Goethe Gb\xf4r\xf4 Nights",
                description: "Goethe Gb\xf4r\xf4 Nights ist eine gaming-veranstaltungsreihe nach feierabend in Abidjan, die die lokale gaming-community zu entspannten, geselligen abenden zusammenbringt. wir haben den digitalen auftritt und das grafische gut des projekts erstellt und damit ein veranstaltungsformat unterst\xfctzt, das gaming-turniere, treffen mit gamingexpertinnen und -experten an abenden mit brett-, partyspielen und karaoke sowie kreativen workshops wie beispielsweise zum 3D-druck vereint. das programm soll verbindung, austausch und spa\xdf innerhalb der ivorischen gaming-szene best\xe4rken."
            },
            "silent-book-club": {
                title: "Silent Book Club Abidjan",
                description: "Silent Book Club Abidjan ist einer der ersten Silent Book Clubs auf dem afrikanischen kontinent und bringt lesebegeisterte im Goethe-Institut Abidjan zu einem gemeinsamen, stillen leseerlebnis zusammen. wir haben die visuellen und grafischen materialien f\xfcr den club erstellt und damit sein offenes, inklusives konzept sichtbarer gemacht: die teilnehmenden lesen ihre mitgebrachten b\xfccher und tauschen sich anschlie\xdfend in entspannter, zwangloser atmosph\xe4re aus."
            },
            fecojazzhb: {
                title: "FECOJAZZHB 2024",
                description: "FECOJAZZHB 2024 (Festival Codijazz et Humour de Bingerville) ist ein musik- und kulturfestival, das afro-jazz, komik und zeitgen\xf6ssischen k\xfcnstlerischen ausdruck in der C\xf4te d\u2019Ivoire feiert. wir haben social-media-inhalte f\xfcr das festival erstellt und markante, wirkungsstarke visuals gestaltet, um das abschlusskonzert zu bewerben und die k\xfcnstlerinnen und k\xfcnstler, die atmosph\xe4re und die kulturelle energie des events auf digitalen plattformen zum leuchten zu bringen."
            },
            "goethe-kreativ": {
                title: "World Wanderers",
                description: "World Wanderers ist eine zweit\xe4gige, familienfreundliche veranstaltung, die sprachliche und kulturelle vielfalt feiert und gemeinsam vom British Council und dem Goethe-Institut organisiert wird. wir haben die visuellen und grafischen materialien erstellt und dabei verspielte, einladende visuals gestaltet, die kinder und familien ansprechen und einen heiteren einstieg in sprachen und kulturen unterst\xfctzen."
            },
            "data-and-drama": {
                title: "Data & Drama",
                description: "Data & Drama war ein interaktiver workshop an der schnittstelle von ki und bildender kunst, der die teilnehmenden in vision-language-modelle, ki-generierte audioinhalte und kreative ki-tools einf\xfchrte. wir haben die visuellen und grafischen materialien f\xfcr den workshop entwickelt und damit ein praxisnahes lernerlebnis f\xfcr k\xfcnstlerinnen und k\xfcnstler, studierende und alle, die sich f\xfcr visuelle gestaltung interessieren, unterst\xfctzt. erg\xe4nzt wurde das programm durch diskussionen dar\xfcber, wie neue technologien die zukunft der kunst und der kreativbranche pr\xe4gen."
            },
            "the-city-dreams-in-ai": {
                title: "The City Dreams in AI",
                description: "The City Dreams in AI war ein zweit\xe4giger experimenteller workshop f\xfcr spekulatives audiovisuelles world-building mit ki. die teilnehmenden sammelten bei streifz\xfcgen durch die stadt (city drifting) bilder und kl\xe4nge in ganz Delhi und kombinierten sie mit ki-tools zu neuartigen, audioreaktiven visuals. wir haben die visuellen und grafischen materialien f\xfcr den workshop entwickelt und damit ein immersives format begleitet, das k\xfcnstlerinnen und k\xfcnstler, designerinnen und designer sowie kreative k\xf6pfe aus technischen berufen zusammenbrachte. das programm lud dazu ein, ki als teil bestehender kreativer arbeitsabl\xe4ufe zu erkunden \u2013 ganz ohne programmierkenntnisse."
            },
            weihnachten: {
                title: "Weihnachten in der Bibliothek des Goethe-Instituts Abidjan",
                description: "Weihnachten in der Bibliothek war eine festliche veranstaltungsreihe im Goethe-Institut Abidjan, die besucherinnen und besucher jeden alters mit kreativen workshops, filmvorf\xfchrungen, spielen und allgemeiner geselligkeit in der bibliothek zusammenbrachte. wir haben die visuellen und grafischen materialien f\xfcr die reihe entwickelt und einen warmen, festlichen look gestaltet, der zusammengeh\xf6rigkeit, kreativit\xe4t und ein starkes gemeinschaftsgef\xfchl erzeugt."
            },
            "team-bildung": {
                title: "Ank\xfcndigungs-Post",
                description: "ein social-media-beitrag f\xfcr das Goethe-Institut Abidjan, der einen besonderen internen teamtag ank\xfcndigt und klare informationen mit einem warmen, gemeinschaftlichen gef\xfchl \xfcbermittelt. wir haben das social-media-poster so gestaltet, dass es gleichzeitig klarheit und nahbarkeit ausdr\xfcckt und zugleich den zusammenhalt und das interne engagement hervorhebt."
            },
            "fonds-artvenir": {
                title: "Fonds A(rt)venir",
                description: "Fonds A(rt)venir ist ein f\xf6rderprogramm des Goethe-Instituts C\xf4te d\u2019Ivoire, das die lokale kunstszene seit 2021 unterst\xfctzt. der fonds konzentriert sich darauf, die k\xfcnstlerische resilienz in zeiten anhaltender krisen zu st\xe4rken und zugleich der zukunft zugewandt zu sein, und f\xf6rdert innovative, kollaborative und international relevante k\xfcnstlerische beitr\xe4ge. wir haben Fonds A(rt)venir bei der social-media-kommunikation f\xfcr das programm unterst\xfctzt und dazu beigetragen, seine sichtbarkeit zu erh\xf6hen, die lokalen kreativszenen zu erreichen und wichtige ausschreibungen und fristen durch klare, ansprechende digitale inhalte zu vermitteln."
            },
            "masa-lab": {
                title: "MASA Lab",
                description: "MASA Lab ist ein f\xf6rderprogramm, das nachwuchstalente der darstellenden k\xfcnste in der C\xf4te d\u2019Ivoire unterst\xfctzt und k\xfcnstlerinnen und k\xfcnstlern in musik, tanz und theater professionelle begleitung, weiterbildung und sichtbarkeit bietet. wir haben ein social-media-visual gestaltet, das die \xf6ffentlichkeitsarbeit des programms unterst\xfctzt und die energie von live-auftritten und k\xfcnstlerischer entwicklung in einen klaren, ansprechenden beitrag f\xfcr digitale plattformen \xfcbersetzt."
            },
            "beau-decembre": {
                title: "Beau D\xe9cembre: Weihnachtspostkarte",
                description: "eine festliche postkarte f\xfcr das weihnachtskonzert Beau D\xe9cembre, das klassische musik und den geist der weinacht im Goethe-Institut C\xf4te d\u2019Ivoire beschw\xf6rt. wir haben das postkartenmotiv gestaltet und dabei warme, jahreszeitliche bildsprache mit einer sanften, stimmungsvollen \xe4sthetik verbunden. das design spiegelt die freude, das licht und die ruhe eines weihnachtlichen musikabends wider."
            },
            "concert-codijazz": {
                title: "Konzert \u2014 Racines von Jean Baptiste Moundele",
                description: "ein konzert von Jean Baptiste Moundele, pr\xe4sentiert vom kollektiv Codijazz im Goethe-Institut Abidjan. wir haben einen social-media-beitrag entworfen, um die veranstaltung zu bewerben und die atmosph\xe4re und musikalit\xe4t des konzerts in ein klares, ansprechendes und auf digitale plattformen zugeschnittenes visual \xfcbersetzt."
            },
            "uber-literatur-sprechen": {
                title: "\xdcber Literatur sprechen",
                description: "\u201E\xdcber Literatur sprechen\u201C ist ein deutschsprachiger workshop am Goethe-Institut Abidjan im rahmen des pr\xe4-integrationsprogramms \u201ELeben und Arbeiten in Deutschland\u201C. der workshop l\xe4dt die teilnehmenden ein, \xfcber ausgew\xe4hlte zeitgen\xf6ssische deutsche romane aus der bibliothek des instituts zu diskutieren und das deutschsprechen in einem offenen, interaktiven rahmen zu \xfcben. wir haben die visuellen und grafischen materialien f\xfcr den workshop gestaltet und damit eine klare kommunikation umgesetzt. damit wird eine \xe4u\xdferst einladende lernumgebung unterst\xfctzt, die literatur, sprachaustausch und dialog in den mittelpunkt stellt."
            },
            blickpunkt: {
                title: "Blickpunkt \u2013 Point de vue",
                description: "Blickpunkt \u2013 Point de vue hat sich als veranstaltungsformat etabliert, das zwischen filmvorf\xfchrungen mit anschlie\xdfendem publikumsgespr\xe4ch und diskussionsabenden zu dr\xe4ngenden themen der ivorischen und afrikanischen filmszene wechselt. diese dialoge entstehen gemeinsam mit namhaften g\xe4sten und werden von Prof. Assie Boni moderiert. wir hatten das vergn\xfcgen, gestaltungsmaterialien f\xfcr mehrere ausgaben der reihe zu entwerfen und konnten damit zu einem klaren, ansprechenden visuellen auftritt beizutragen, der dialog, austausch und die zeitgen\xf6ssische kulturelle debatte unterst\xfctzt."
            }
        }
    }
};
exports.default = galleryTranslations;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"lC98R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const mapTranslations = {
    en: {
        head: {
            index: "network / 14 locations",
            title: "across chapters",
            right: "where we've evolved"
        },
        cities: {
            saoPaulo: "Sao Paulo",
            abidjan: "Abidjan",
            frankfurt: "Frankfurt",
            fulda: "Fulda",
            munich: "Munich",
            berlin: "Berlin",
            prague: "Prague",
            budapest: "Budapest",
            mumbai: "Mumbai",
            pune: "Pune",
            newDelhi: "New Delhi",
            hyderabad: "Hyderabad",
            kolkata: "Kolkata",
            bangkok: "Bangkok"
        }
    },
    de: {
        head: {
            index: "netzwerk / 14 standorte",
            title: "kapitel um kapitel",
            right: "wo wir uns weiterentwickelt haben"
        },
        cities: {
            saoPaulo: "S\xe3o Paulo",
            abidjan: "Abidjan",
            frankfurt: "Frankfurt",
            fulda: "Fulda",
            munich: "M\xfcnchen",
            berlin: "Berlin",
            prague: "Prag",
            budapest: "Budapest",
            mumbai: "Mumbai",
            pune: "Pune",
            newDelhi: "Neu-Delhi",
            hyderabad: "Hyderabad",
            kolkata: "Kolkata",
            bangkok: "Bangkok"
        }
    }
};
exports.default = mapTranslations;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"6txYo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _i18N = require("../../utils/i18n");
var _languageContext = require("../../utils/LanguageContext");
var _languageSelectorCss = require("./LanguageSelector.css");
const LanguageSelector = ({ className: className = '' })=>{
    const { currentLang, changeLanguage } = (0, _languageContext.useLanguage)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `lang-toggle${className ? ` ${className}` : ''}`,
        role: "group",
        "aria-label": "Language",
        children: (0, _i18N.LANGUAGES).map((lang, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "lang-toggle-item",
                children: [
                    i > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "lang-toggle-sep",
                        "aria-hidden": "true",
                        children: "/"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: `lang-toggle-btn${lang === currentLang ? ' is-active' : ''}`,
                        onClick: ()=>changeLanguage(lang),
                        "aria-label": lang === 'en' ? 'switch to English' : 'zu Deutsch wechseln',
                        "aria-current": lang === currentLang ? 'true' : undefined,
                        disabled: lang === currentLang,
                        children: lang
                    })
                ]
            }, lang))
    });
};
exports.default = LanguageSelector;

},{"react/jsx-runtime":"a7gVT","../../utils/i18n":"4Kl7i","../../utils/LanguageContext":"5u50e","./LanguageSelector.css":"edxoY","@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"edxoY":[function() {},{}],"ebLXg":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("iLUhZ");

},{}],"eVQfk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _footerCss = require("./Footer.css");
var _reactRouterDom = require("react-router-dom");
var _i18N = require("../../utils/i18n");
var _translations = require("../../utils/translations");
var _languageContext = require("../../utils/LanguageContext");
var _arrowIcon = require("../ArrowIcon/ArrowIcon");
var _arrowIconDefault = parcelHelpers.interopDefault(_arrowIcon);
var _logoMarkInvertSvg = require("url:../../../assets/logo-mark-invert.svg");
var _logoMarkInvertSvgDefault = parcelHelpers.interopDefault(_logoMarkInvertSvg);
var _augustSanderSchukePng = require("url:../../../assets/partner-logos/august-sander-schuke.png");
var _augustSanderSchukePngDefault = parcelHelpers.interopDefault(_augustSanderSchukePng);
var _bahamPng = require("url:../../../assets/partner-logos/baham.png");
var _bahamPngDefault = parcelHelpers.interopDefault(_bahamPng);
var _dataAndDramaPng = require("url:../../../assets/partner-logos/data-and-drama.png");
var _dataAndDramaPngDefault = parcelHelpers.interopDefault(_dataAndDramaPng);
var _euPng = require("url:../../../assets/partner-logos/eu.png");
var _euPngDefault = parcelHelpers.interopDefault(_euPng);
var _fitInFrankfurtPng = require("url:../../../assets/partner-logos/fit-in-frankfurt.png");
var _fitInFrankfurtPngDefault = parcelHelpers.interopDefault(_fitInFrankfurtPng);
var _fuPng = require("url:../../../assets/partner-logos/fu.png");
var _fuPngDefault = parcelHelpers.interopDefault(_fuPng);
var _gamesConnectPng = require("url:../../../assets/partner-logos/games-connect.png");
var _gamesConnectPngDefault = parcelHelpers.interopDefault(_gamesConnectPng);
var _giPng = require("url:../../../assets/partner-logos/gi.png");
var _giPngDefault = parcelHelpers.interopDefault(_giPng);
var _giMmbPng = require("url:../../../assets/partner-logos/gi-mmb.png");
var _giMmbPngDefault = parcelHelpers.interopDefault(_giMmbPng);
var _kaleidoskopPng = require("url:../../../assets/partner-logos/kaleidoskop.png");
var _kaleidoskopPngDefault = parcelHelpers.interopDefault(_kaleidoskopPng);
var _monetiquePng = require("url:../../../assets/partner-logos/monetique.png");
var _monetiquePngDefault = parcelHelpers.interopDefault(_monetiquePng);
var _preIntegrationPng = require("url:../../../assets/partner-logos/pre-integration.png");
var _preIntegrationPngDefault = parcelHelpers.interopDefault(_preIntegrationPng);
var _thewhizstorePng = require("url:../../../assets/partner-logos/thewhizstore.png");
var _thewhizstorePngDefault = parcelHelpers.interopDefault(_thewhizstorePng);
var _you9Png = require("url:../../../assets/partner-logos/you9.png");
var _you9PngDefault = parcelHelpers.interopDefault(_you9Png);
var _indafPng = require("url:../../../assets/partner-logos/indaf.png");
var _indafPngDefault = parcelHelpers.interopDefault(_indafPng);
var _averaSvg = require("url:../../../assets/partner-logos/avera.svg");
var _averaSvgDefault = parcelHelpers.interopDefault(_averaSvg);
var _byovSvg = require("url:../../../assets/partner-logos/byov.svg");
var _byovSvgDefault = parcelHelpers.interopDefault(_byovSvg);
const PARTNER_LOGOS = [
    {
        src: (0, _giPngDefault.default),
        alt: "Goethe-Institut"
    },
    {
        src: (0, _giMmbPngDefault.default),
        alt: "Goethe-Institut Max Mueller Bhavan"
    },
    {
        src: (0, _bahamPngDefault.default),
        alt: "Baham"
    },
    {
        src: (0, _preIntegrationPngDefault.default),
        alt: "Pre-Integration and Transition Management"
    },
    {
        src: (0, _euPngDefault.default),
        alt: "European Union"
    },
    {
        src: (0, _dataAndDramaPngDefault.default),
        alt: "Data and Drama"
    },
    {
        src: (0, _monetiquePngDefault.default),
        alt: "Mon\xe9tique"
    },
    {
        src: (0, _fitInFrankfurtPngDefault.default),
        alt: "fit in Frankfurt"
    },
    {
        src: (0, _kaleidoskopPngDefault.default),
        alt: "Kaleidoskop"
    },
    {
        src: (0, _gamesConnectPngDefault.default),
        alt: "Games Connect Africa"
    },
    {
        src: (0, _fuPngDefault.default),
        alt: "Freie Universit\xe4t Berlin"
    },
    {
        src: (0, _augustSanderSchukePngDefault.default),
        alt: "August Sander Schule"
    },
    {
        src: (0, _you9PngDefault.default),
        alt: "You9"
    },
    {
        src: (0, _thewhizstorePngDefault.default),
        alt: "TheWhizStore"
    },
    {
        src: (0, _indafPngDefault.default),
        alt: "INDAF"
    },
    {
        src: (0, _averaSvgDefault.default),
        alt: "Avera Homes"
    },
    {
        src: (0, _byovSvgDefault.default),
        alt: "byov."
    }
];
const Footer = ()=>{
    const { currentLang } = (0, _languageContext.useLanguage)();
    const { t } = (0, _translations.useTranslations)();
    const paths = (0, _i18N.getRoutePaths)(currentLang);
    // Get service groups from translations
    const serviceGroupSlugs = {
        automation: `#${t('service', 'groups.automation.slug')}`,
        webDigital: `#${t('service', 'groups.webDigital.slug')}`,
        finance: `#${t('service', 'groups.finance.slug')}`,
        brandDesign: `#${t('service', 'groups.brandDesign.slug')}`
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("footer", {
        className: "footer",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                className: "footer-partners",
                "data-label": t('footer', 'footerPartners', 'along the way / selected collaborators / some remain confidential.'),
                "aria-label": "Partners and collaborators",
                children: PARTNER_LOGOS.map((partner)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            src: partner.src,
                            alt: partner.alt,
                            loading: "lazy",
                            decoding: "async"
                        })
                    }, partner.src))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "footer-inner",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "footer-left",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "footer-brand",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "footer-logo",
                                        src: (0, _logoMarkInvertSvgDefault.default),
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "footer-wordmark",
                                        children: "thewhizkind"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: t('footer', 'brandTagline', 'independent / creative / technology')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("nav", {
                        className: "footer-center",
                        "aria-label": "Footer navigation",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "footer-column-label",
                                children: t('footer', 'navigate', '01 / navigate')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: paths.services,
                                className: "footer-link",
                                children: t('footer', 'footerLinks.services', 'services')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: paths.lab,
                                className: "footer-link",
                                children: t('footer', 'footerLinks.lab', 'lab')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: paths.gallery,
                                className: "footer-link",
                                children: t('footer', 'footerLinks.gallery', 'gallery')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: paths.about,
                                className: "footer-link",
                                children: t('footer', 'footerLinks.about', 'about')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: paths.contact,
                                className: "footer-link",
                                children: t('footer', 'footerLinks.contact', 'contact')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: paths.principles,
                                className: "footer-link",
                                children: t('footer', 'footerLinks.principles', 'principles')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("nav", {
                        className: "footer-services",
                        "aria-label": "Services",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "footer-column-label",
                                children: t('footer', 'capabilities', '02 / capabilities')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: `${paths.services}${serviceGroupSlugs.brandDesign}`,
                                className: "footer-link",
                                children: t('footer', 'footerLinks.brandAndIdentity', 'branding & identity')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: `${paths.services}${serviceGroupSlugs.webDigital}`,
                                className: "footer-link",
                                children: t('footer', 'footerLinks.webDevelopment', 'web development')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: `${paths.services}${serviceGroupSlugs.brandDesign}`,
                                className: "footer-link",
                                children: t('footer', 'footerLinks.graphicDesign', 'graphic design')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: `${paths.services}${serviceGroupSlugs.automation}`,
                                className: "footer-link",
                                children: t('footer', 'footerLinks.aiAndAutomation', 'ai & automation')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: `${paths.services}${serviceGroupSlugs.brandDesign}`,
                                className: "footer-link",
                                children: t('footer', 'footerLinks.communication', 'communication')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: `${paths.services}${serviceGroupSlugs.webDigital}`,
                                className: "footer-link",
                                children: t('footer', 'footerLinks.digitalisation', 'digitalisation')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: `${paths.services}${serviceGroupSlugs.finance}`,
                                className: "footer-link",
                                children: t('footer', 'footerLinks.creativeDevelopment', 'creative development')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: `${paths.services}${serviceGroupSlugs.automation}`,
                                className: "footer-link",
                                children: t('footer', 'footerLinks.processOptimisation', 'process optimisation')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "footer-right",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "footer-column-label",
                                children: t('footer', 'connect', '03 / connect')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "footer-socials",
                                "aria-label": "Social links",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        className: "footer-social",
                                        href: "https://www.instagram.com/thewhizkind",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        "aria-label": t('footer', 'socialAriaLabels.instagram', 'thewhizkind on Instagram (opens in new tab)'),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            viewBox: "0 0 24 24",
                                            "aria-hidden": "true",
                                            focusable: "false",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M7 3h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4Zm0 2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H7Zm5 3.5A4.5 4.5 0 1 1 7.5 13 4.5 4.5 0 0 1 12 8.5Zm0 2A2.5 2.5 0 1 0 14.5 13 2.5 2.5 0 0 0 12 10.5Zm5.25-2.65a1.05 1.05 0 1 1-1.05 1.05 1.05 1.05 0 0 1 1.05-1.05Z"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        className: "footer-social",
                                        href: "https://www.linkedin.com/in/prayrit-singh/",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        "aria-label": t('footer', 'socialAriaLabels.linkedin', 'Prayrit Singh on LinkedIn (opens in new tab)'),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            viewBox: "0 0 24 24",
                                            "aria-hidden": "true",
                                            focusable: "false",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M6.94 8.5H4v12h2.94v-12ZM5.47 3.5A1.73 1.73 0 1 0 7.2 5.23 1.72 1.72 0 0 0 5.47 3.5ZM20 13.2c0-3.24-1.73-4.75-4.05-4.75a3.5 3.5 0 0 0-3.18 1.75h-.04v-1.5H9.9c.04 1 .04 12 .04 12h2.94v-6.7c0-.36.03-.72.13-.98.29-.72.94-1.46 2.04-1.46 1.44 0 2.02 1.1 2.02 2.7v6.44H20Z"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        className: "footer-social",
                                        href: "https://discord.com/users/pray.rit",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        "aria-label": t('footer', 'socialAriaLabels.discord', 'Prayrit Singh on Discord (opens in new tab)'),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            viewBox: "0 0 24 24",
                                            "aria-hidden": "true",
                                            focusable: "false",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M20.32 4.37a17.5 17.5 0 0 0-4.3-1.34c-.19.34-.4.79-.55 1.15a16.6 16.6 0 0 0-4.94 0 8.9 8.9 0 0 0-.56-1.15 17.6 17.6 0 0 0-4.3 1.34C2.6 8.6 1.9 12.7 2.2 16.75a17.7 17.7 0 0 0 5.37 2.73c.44-.6.82-1.24 1.15-1.92a11.5 11.5 0 0 1-1.82-.88c.15-.11.3-.23.44-.35a12.6 12.6 0 0 0 10.66 0c.15.12.29.24.44.35-.58.35-1.19.64-1.83.88.33.68.71 1.32 1.15 1.92a17.6 17.6 0 0 0 5.37-2.73c.36-4.7-.78-8.76-3.31-12.38ZM9.68 14.3c-.9 0-1.63-.83-1.63-1.85 0-1.02.72-1.85 1.63-1.85.92 0 1.65.84 1.63 1.85 0 1.02-.71 1.85-1.63 1.85Zm5.64 0c-.9 0-1.63-.83-1.63-1.85 0-1.02.72-1.85 1.63-1.85.93 0 1.65.84 1.63 1.85 0 1.02-.7 1.85-1.63 1.85Z"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                        className: "footer-social",
                                        href: "https://github.com/prayritsingh",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        "aria-label": t('footer', 'socialAriaLabels.github', 'Prayrit Singh on GitHub (opens in new tab)'),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            viewBox: "0 0 24 24",
                                            "aria-hidden": "true",
                                            focusable: "false",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M12 2A10 10 0 0 0 8.84 21.5c.5.08.66-.23.66-.5v-1.69c-2.77.6-3.36-1.34-3.36-1.34-.46-1.16-1.11-1.47-1.11-1.47-.91-.62.07-.6.07-.6 1 .07 1.53 1.03 1.53 1.03.89 1.52 2.34 1.08 2.91.83.09-.65.35-1.08.63-1.33-2.22-.25-4.55-1.11-4.55-4.92 0-1.09.39-1.98 1.03-2.68-.1-.25-.45-1.27.1-2.64 0 0 .84-.27 2.75 1.02a9.58 9.58 0 0 1 5 0c1.91-1.29 2.75-1.02 2.75-1.02.55 1.37.2 2.39.1 2.64.64.7 1.03 1.59 1.03 2.68 0 3.82-2.34 4.66-4.57 4.91.36.31.68.92.68 1.85v2.74c0 .27.16.59.67.5A10 10 0 0 0 12 2Z"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "footer-legal",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                        to: paths.disclaimer,
                                        className: "footer-link",
                                        children: t('footer', 'legal.disclaimer', 'impressum / disclaimer')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                        to: paths.privacy,
                                        className: "footer-link",
                                        children: t('footer', 'legal.privacy', "datenschutzerkl\xe4rung / privacy policy")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                        to: paths.accessibility,
                                        className: "footer-link",
                                        children: t('footer', 'legal.accessibility', 'accessibility')
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "footer-bottom",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: t('common', 'copyright', "\xa9 2026 thewhizkind")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        children: [
                            "frankfurt am main ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowIconDefault.default), {
                                direction: "both"
                            }),
                            " new delhi"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "footer-signature",
                        children: "<powered by thewhizkind>"
                    })
                ]
            })
        ]
    });
};
exports.default = Footer;

},{"react/jsx-runtime":"a7gVT","./Footer.css":"b4I8s","react-router-dom":"hhXgL","../../utils/i18n":"4Kl7i","../../utils/translations":"kdPrY","../../utils/LanguageContext":"5u50e","../ArrowIcon/ArrowIcon":"dULmT","url:../../../assets/logo-mark-invert.svg":"bhoJp","url:../../../assets/partner-logos/august-sander-schuke.png":"71Uxz","url:../../../assets/partner-logos/baham.png":"j6t8n","url:../../../assets/partner-logos/data-and-drama.png":"lt9CE","url:../../../assets/partner-logos/eu.png":"24npZ","url:../../../assets/partner-logos/fit-in-frankfurt.png":"fxHbp","url:../../../assets/partner-logos/fu.png":"c1TwX","url:../../../assets/partner-logos/games-connect.png":"jCQXx","url:../../../assets/partner-logos/gi.png":"g4ZMW","url:../../../assets/partner-logos/gi-mmb.png":"lyj5i","url:../../../assets/partner-logos/kaleidoskop.png":"hlIZD","url:../../../assets/partner-logos/monetique.png":"28GWO","url:../../../assets/partner-logos/pre-integration.png":"kAXjE","url:../../../assets/partner-logos/thewhizstore.png":"lbeSP","url:../../../assets/partner-logos/you9.png":"4m5IN","url:../../../assets/partner-logos/indaf.png":"coykI","url:../../../assets/partner-logos/avera.svg":"dsFbD","url:../../../assets/partner-logos/byov.svg":"cJoyC","@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"b4I8s":[function() {},{}],"dULmT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _arrowIconCss = require("./ArrowIcon.css");
const paths = {
    external: "M5 19 19 5M8 5h11v11",
    left: "M20 12H4m6-6-6 6 6 6",
    right: "M4 12h16m-6-6 6 6-6 6",
    both: "M4 12h16M9 7l-5 5 5 5m6-10 5 5-5 5"
};
const ArrowIcon = ({ direction: direction = "external", className: className = "" })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: `arrow-icon${className ? ` ${className}` : ""}`,
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        focusable: "false",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: paths[direction]
        })
    });
exports.default = ArrowIcon;

},{"react/jsx-runtime":"a7gVT","react":"7d7jl","./ArrowIcon.css":"j9RQe","@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"j9RQe":[function() {},{}],"bhoJp":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("4ej8W");

},{}],"71Uxz":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("dsini");

},{}],"j6t8n":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("cEDX3");

},{}],"lt9CE":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("dpv7V");

},{}],"24npZ":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("8Xndk");

},{}],"fxHbp":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("evtvq");

},{}],"c1TwX":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("lzvHB");

},{}],"jCQXx":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("4WzLt");

},{}],"g4ZMW":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("hm7Lo");

},{}],"lyj5i":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("4dSY4");

},{}],"hlIZD":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("jMqk0");

},{}],"28GWO":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("fN1Ce");

},{}],"kAXjE":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("cyJo3");

},{}],"lbeSP":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("blD2o");

},{}],"4m5IN":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("6RrYp");

},{}],"coykI":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("aecME");

},{}],"dsFbD":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("imrBR");

},{}],"cJoyC":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("1NRxp");

},{}],"irnzY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _mainPhotoJpg = require("url:../../../assets/main-photo.jpg");
var _mainPhotoJpgDefault = parcelHelpers.interopDefault(_mainPhotoJpg);
var _prayritJpeg = require("url:../../../assets/prayrit.jpeg");
var _prayritJpegDefault = parcelHelpers.interopDefault(_prayritJpeg);
var _i18N = require("../../utils/i18n");
var _translations = require("../../utils/translations");
var _languageContext = require("../../utils/LanguageContext");
var _acrossChaptersMap = require("../AcrossChaptersMap/AcrossChaptersMap");
var _acrossChaptersMapDefault = parcelHelpers.interopDefault(_acrossChaptersMap);
var _arrowIcon = require("../ArrowIcon/ArrowIcon");
var _arrowIconDefault = parcelHelpers.interopDefault(_arrowIcon);
var _mainCss = require("./Main.css");
const Main = ()=>{
    const { currentLang } = (0, _languageContext.useLanguage)();
    const { t } = (0, _translations.useTranslations)();
    const paths = (0, _i18N.getRoutePaths)(currentLang);
    // Get disciplines from translations
    const disciplines = t('home', 'hero.disciplines', [
        'AI',
        'Digitalisation',
        'Process optimisation',
        'Web development',
        'Automation',
        'Graphic design',
        'Branding'
    ]);
    // Get capabilities list from translations
    const capabilitiesList = t('home', 'capabilities.list', [
        'finance',
        'web development',
        'graphic design',
        'ai & automation',
        'communication',
        'digitalisation',
        'creative development',
        'process optimisation',
        'branding & identity'
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                className: "home-hero",
                "aria-labelledby": "home-title",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "home-hero-strip",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                children: [
                                    t('home', 'hero.strip.establish'),
                                    " ",
                                    t('home', 'hero.strip.year'),
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "home-hero-strip-divider",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                                to: paths.principles,
                                className: "home-hero-strip-link",
                                children: [
                                    t('home', 'hero.strip.principlesLink'),
                                    " ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowIconDefault.default), {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "home-hero-text",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                className: `home-title${currentLang === 'de' ? ' home-title--de' : ''}`,
                                id: "home-title",
                                children: (()=>{
                                    const title = t('home', 'hero.title');
                                    const lastSpace = title.lastIndexOf(' ');
                                    if (lastSpace === -1) return title;
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            title.slice(0, lastSpace + 1),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "home-title-accent",
                                                children: title.slice(lastSpace + 1)
                                            })
                                        ]
                                    });
                                })()
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "home-script",
                                children: t('home', 'hero.script')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "home-locations",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: t('home', 'hero.locations')
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                className: "home-disciplines",
                                "aria-label": t('common', 'capabilities', 'Core capabilities') || 'Core capabilities',
                                children: disciplines.map((discipline, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                children: [
                                                    "0",
                                                    index + 1
                                                ]
                                            }),
                                            discipline
                                        ]
                                    }, discipline))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "home-actions",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                                        to: paths.services,
                                        className: "home-button home-button-primary",
                                        children: [
                                            t('home', 'hero.actions.seeServices'),
                                            " ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowIconDefault.default), {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                                        to: paths.contact,
                                        className: "home-button",
                                        children: [
                                            t('home', 'hero.actions.startProject'),
                                            " ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowIconDefault.default), {})
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "home-hero-image",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: (0, _mainPhotoJpgDefault.default),
                                alt: "thewhizkind main visual",
                                width: "800",
                                height: "1000",
                                decoding: "async",
                                fetchpriority: "high"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "hero-register hero-register-top",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "hero-register hero-register-bottom",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "hero-scan",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "hero-system",
                                "aria-hidden": "true",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "hero-system-status",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {}),
                                            "system Online"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                                children: "mode"
                                            }),
                                            " ",
                                            t('home', 'hero.system.mode')
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                                children: "nodes"
                                            }),
                                            " ",
                                            t('home', 'hero.locations')
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                                children: "build"
                                            }),
                                            " ",
                                            t('home', 'hero.system.build')
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                className: "home-capabilities",
                "aria-labelledby": "capabilities-title",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "home-capabilities-aside",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "section-kicker",
                                children: t('home', 'capabilities.kicker')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                                to: paths.services,
                                className: "capabilities-about-link",
                                children: [
                                    t('home', 'capabilities.exploreLink'),
                                    " ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowIconDefault.default), {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "capability-axis",
                        "aria-hidden": "true",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: t('home', 'capabilities.axis.thinking')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: t('home', 'capabilities.axis.making')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "home-capabilities-heading",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                                id: "capabilities-title",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: t('home', 'capabilities.title')[0]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: t('home', 'capabilities.title')[1]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "home-capabilities-lede",
                                children: t('home', 'capabilities.lede')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                        "aria-label": t('common', 'capabilities', 'Capabilities') || 'Capabilities',
                        children: capabilitiesList.map((capability, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                children: capability
                            }, capability))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "capability-mark",
                        "aria-hidden": "true",
                        children: "+"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
                className: "work-portal",
                id: "selected-work",
                "aria-labelledby": "work-portal-title",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                    to: paths.gallery,
                    className: "work-portal-link",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "work-portal-kicker",
                            children: t('home', 'workPortal.kicker')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            id: "work-portal-title",
                            children: t('home', 'workPortal.title').split('/').map((part, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                    children: [
                                        i > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                        part.trim()
                                    ]
                                }, i))
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "work-portal-arrow",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowIconDefault.default), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: t('home', 'workPortal.description')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "work-portal-signal",
                            "aria-hidden": "true",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {})
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                className: "founder-intro",
                "aria-labelledby": "founder-intro-title",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("figure", {
                        className: "founder-intro-portrait",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "founder-intro-portrait-frame",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    src: (0, _prayritJpegDefault.default),
                                    alt: "Prayrit, founder of thewhizkind",
                                    width: "480",
                                    height: "640",
                                    loading: "lazy",
                                    decoding: "async"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("figcaption", {
                                    className: "founder-intro-caption",
                                    children: [
                                        currentLang === 'de' ? "portr\xe4t" : 'portrait',
                                        " / frankfurt"
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "founder-intro-text",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "section-kicker",
                                children: t('home', 'founder.kicker')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                id: "founder-intro-title",
                                children: (()=>{
                                    const title = t('home', 'founder.title');
                                    const parts = title.split('prayrit');
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            parts[0],
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                                                children: "prayrit"
                                            }),
                                            parts.slice(1).join('prayrit')
                                        ]
                                    });
                                })()
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: t('home', 'founder.bio')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "founder-intro-meta",
                                children: t('home', 'founder.meta').map((meta, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: meta
                                    }, meta))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                                to: paths.about,
                                className: "founder-intro-link",
                                children: [
                                    t('home', 'founder.moreLink'),
                                    " ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowIconDefault.default), {})
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
                className: "home-contact-cta",
                "aria-labelledby": "home-contact-title",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "section-kicker",
                        children: t('home', 'contactCta.kicker')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                        id: "home-contact-title",
                        className: currentLang === 'de' ? 'home-contact-title--de' : undefined,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: t('home', 'contactCta.title')[0]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "contact-title-emphasis",
                                children: (()=>{
                                    const subtitle = t('home', 'contactCta.title')[1];
                                    const lastSpace = subtitle.lastIndexOf(' ');
                                    if (lastSpace === -1) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                                        children: subtitle
                                    });
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            subtitle.slice(0, lastSpace + 1),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("em", {
                                                children: subtitle.slice(lastSpace + 1)
                                            })
                                        ]
                                    });
                                })()
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                        to: paths.contact,
                        className: "home-contact-link",
                        children: [
                            t('home', 'contactCta.link'),
                            " ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowIconDefault.default), {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _acrossChaptersMapDefault.default), {
                className: "home-map"
            })
        ]
    });
};
exports.default = Main;

},{"react/jsx-runtime":"a7gVT","react":"7d7jl","react-router-dom":"hhXgL","url:../../../assets/main-photo.jpg":"a9HKS","url:../../../assets/prayrit.jpeg":"bdXE0","../../utils/i18n":"4Kl7i","../../utils/translations":"kdPrY","../../utils/LanguageContext":"5u50e","../AcrossChaptersMap/AcrossChaptersMap":"ijrCK","../ArrowIcon/ArrowIcon":"dULmT","./Main.css":"kgr6z","@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"a9HKS":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("lNZtw");

},{}],"bdXE0":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("asKom");

},{}],"ijrCK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _translations = require("../../utils/translations");
var _acrossChaptersMapCss = require("./AcrossChaptersMap.css");
const cityPins = [
    {
        id: "saoPaulo",
        lat: -23.55,
        lon: -46.63
    },
    {
        id: "abidjan",
        lat: 5.36,
        lon: -4.01
    },
    {
        id: "frankfurt",
        lat: 50.11,
        lon: 8.68
    },
    {
        id: "fulda",
        lat: 50.56,
        lon: 9.68
    },
    {
        id: "munich",
        lat: 48.14,
        lon: 11.58
    },
    {
        id: "berlin",
        lat: 52.52,
        lon: 13.4
    },
    {
        id: "prague",
        lat: 50.08,
        lon: 14.44
    },
    {
        id: "budapest",
        lat: 47.5,
        lon: 19.04
    },
    {
        id: "mumbai",
        lat: 19.08,
        lon: 72.88
    },
    {
        id: "pune",
        lat: 18.52,
        lon: 73.86
    },
    {
        id: "newDelhi",
        lat: 28.61,
        lon: 77.21
    },
    {
        id: "hyderabad",
        lat: 17.39,
        lon: 78.49
    },
    {
        id: "kolkata",
        lat: 22.57,
        lon: 88.36
    },
    {
        id: "bangkok",
        lat: 13.75,
        lon: 100.52
    }
];
const MAP_LON_MIN = -50;
const MAP_LON_MAX = 102;
const curveOffsets = [
    -1,
    0,
    1
];
const curveRoutes = [
    {
        from: "saoPaulo",
        to: "frankfurt",
        lift: -12,
        spread: 2.2,
        tone: "warm"
    },
    {
        from: "saoPaulo",
        to: "newDelhi",
        lift: -8,
        spread: 2.6,
        tone: "cool"
    },
    {
        from: "abidjan",
        to: "frankfurt",
        lift: -4.2,
        spread: 1.4,
        tone: "warm"
    },
    {
        from: "berlin",
        to: "newDelhi",
        lift: -8,
        spread: 1.8,
        tone: "neutral"
    },
    {
        from: "berlin",
        to: "mumbai",
        lift: -6,
        spread: 1.7,
        tone: "cool"
    },
    {
        from: "frankfurt",
        to: "hyderabad",
        lift: -4,
        spread: 1.4,
        tone: "warm"
    },
    {
        from: "prague",
        to: "kolkata",
        lift: -3,
        spread: 1.6,
        tone: "cool"
    },
    {
        from: "munich",
        to: "pune",
        lift: 2.5,
        spread: 1.2,
        tone: "neutral"
    },
    {
        from: "berlin",
        to: "budapest",
        lift: -3.2,
        spread: 0.8,
        tone: "cool"
    },
    {
        from: "frankfurt",
        to: "fulda",
        lift: 0.8,
        spread: 0.6,
        tone: "neutral"
    },
    {
        from: "newDelhi",
        to: "hyderabad",
        lift: 1.5,
        spread: 0.8,
        tone: "warm"
    },
    {
        from: "newDelhi",
        to: "kolkata",
        lift: -1.8,
        spread: 0.8,
        tone: "cool"
    },
    {
        from: "newDelhi",
        to: "mumbai",
        lift: 1.6,
        spread: 0.8,
        tone: "neutral"
    },
    {
        from: "newDelhi",
        to: "pune",
        lift: 2.1,
        spread: 0.8,
        tone: "neutral"
    },
    {
        from: "bangkok",
        to: "kolkata",
        lift: -2.5,
        spread: 1.0,
        tone: "warm"
    },
    {
        from: "bangkok",
        to: "berlin",
        lift: -9,
        spread: 2.0,
        tone: "cool"
    }
];
// Abstract continent blobs — same coordinate system as city pins:
// x = ((lon + 50) / 150) * 100,  y = ((90 - lat) / 180) * 100
const continentPaths = [
    {
        id: "south-america",
        // Eastern coastal sliver visible within lon range (Sao Paulo sits at ~x2, y63)
        d: "M 0 46 C 9 42 14 48 14 53 C 14 58 12 62 9 66 C 6 69 3 72 0 73 L 0 46 Z"
    },
    {
        id: "africa",
        // Wide in north, narrows to cape in south; Abidjan at ~x31, y47
        d: "M 23 40 C 31 33 43 30 57 33 C 65 36 68 43 66 52 C 63 59 53 68 45 70 C 36 72 26 64 24 53 C 22 48 21 44 23 40 Z"
    },
    {
        id: "europe",
        // Compact mass above Africa; European cities cluster around x39-46, y21-24
        d: "M 27 28 C 33 20 42 13 48 12 C 57 11 66 14 68 17 C 68 22 63 25 57 27 C 51 29 43 29 36 29 C 32 29 28 30 27 28 Z"
    },
    {
        id: "arabia",
        // Small peninsula between Africa and India
        d: "M 57 33 C 63 31 71 33 73 38 C 73 43 68 46 63 46 C 60 46 58 43 57 39 C 55 36 56 34 57 33 Z"
    },
    {
        id: "india",
        // Teardrop peninsula; Indian cities sit at x82-92, y34-40
        d: "M 74 30 C 82 28 92 30 98 33 C 98 37 95 39 93 40 C 91 43 90 46 88 48 C 86 50 85 52 83 58 C 81 62 82 66 82 67 C 79 62 78 57 77 52 C 75 48 73 42 74 30 Z"
    },
    {
        id: "southeast-asia",
        // Indochina peninsula; Bangkok sits at ~x99, y42
        d: "M 93 33 C 98 30 102 34 101 40 C 100 45 98 49 96 51 C 93 53 90 49 91 44 C 91 39 91 35 93 33 Z"
    }
];
const TIMEZONE_CLOCKS = [
    {
        label: "S\xe3o Paulo",
        tz: "America/Sao_Paulo"
    },
    {
        label: "Abidjan",
        tz: "Africa/Abidjan"
    },
    {
        label: "MEZ",
        tz: "Europe/Berlin"
    },
    {
        label: "IST",
        tz: "Asia/Kolkata"
    },
    {
        label: "Thailand",
        tz: "Asia/Bangkok"
    }
];
const formatTime = (tz)=>new Intl.DateTimeFormat("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        timeZone: tz
    }).format(new Date());
const clampPercent = (value)=>Math.min(100, Math.max(0, value));
const projectCityCoordinates = ({ lat, lon })=>({
        x: clampPercent((lon - MAP_LON_MIN) / (MAP_LON_MAX - MAP_LON_MIN) * 100),
        y: clampPercent((90 - lat) / 180 * 100)
    });
const projectCityPin = (city)=>{
    const { x, y } = projectCityCoordinates(city);
    return {
        left: `${x}%`,
        top: `${y}%`
    };
};
const cityCoordinates = cityPins.reduce((accumulator, city)=>{
    accumulator[city.id] = projectCityCoordinates(city);
    return accumulator;
}, {});
const buildCurvePath = (start, end, lift = 0, offset = 0)=>{
    const deltaX = end.x - start.x;
    const deltaY = end.y - start.y;
    const distance = Math.hypot(deltaX, deltaY) || 1;
    const normalX = -deltaY / distance;
    const normalY = deltaX / distance;
    const middleX = (start.x + end.x) / 2;
    const middleY = (start.y + end.y) / 2;
    const controlX = middleX + normalX * (lift + offset);
    const controlY = middleY + normalY * (lift + offset);
    return `M ${start.x.toFixed(2)} ${start.y.toFixed(2)} Q ${controlX.toFixed(2)} ${controlY.toFixed(2)} ${end.x.toFixed(2)} ${end.y.toFixed(2)}`;
};
const AcrossChaptersMap = ({ className: className = "" })=>{
    const { t } = (0, _translations.useTranslations)();
    const cityLabel = (id)=>t("acrossChaptersMap", `cities.${id}`, id);
    const [activeCity, setActiveCity] = (0, _react.useState)("");
    const [, setTick] = (0, _react.useState)(0);
    const titleId = (0, _react.useId)();
    (0, _react.useEffect)(()=>{
        const id = setInterval(()=>setTick((t)=>t + 1), 30000);
        return ()=>clearInterval(id);
    }, []);
    const rootClassName = [
        "about-map",
        className
    ].filter(Boolean).join(" ");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("section", {
        className: rootClassName,
        "aria-labelledby": titleId,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "about-map-head",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "about-map-title-wrap",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "about-map-index",
                                children: t('acrossChaptersMap', 'head.index')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                id: titleId,
                                children: t('acrossChaptersMap', 'head.title')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "about-map-head-right",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: t('acrossChaptersMap', 'head.right')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "about-map-clocks",
                                "aria-label": "Local times",
                                children: TIMEZONE_CLOCKS.map(({ label, tz }, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Fragment), {
                                        children: [
                                            i > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "about-map-clock-sep",
                                                "aria-hidden": "true",
                                                children: "\xb7"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "about-map-clock-time",
                                                "aria-label": `${label} time`,
                                                children: formatTime(tz)
                                            })
                                        ]
                                    }, tz))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "about-map-frame",
                role: "group",
                "aria-label": "Map with city locations",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                        className: "about-map-curves",
                        viewBox: "0 0 100 100",
                        preserveAspectRatio: "none",
                        "aria-hidden": "true",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                className: "about-map-continents",
                                children: continentPaths.map((continent)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        className: "about-map-continent",
                                        d: continent.d
                                    }, continent.id))
                            }),
                            curveRoutes.map((route)=>{
                                const start = cityCoordinates[route.from];
                                const end = cityCoordinates[route.to];
                                if (!start || !end) return null;
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                    children: curveOffsets.map((offset)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            className: `about-map-curve about-map-curve-${route.tone}${offset === 0 ? " is-core" : ""}`,
                                            d: buildCurvePath(start, end, route.lift, offset * route.spread)
                                        }, `${route.from}-${route.to}-${offset}`))
                                }, `${route.from}-${route.to}`);
                            })
                        ]
                    }),
                    cityPins.map((city)=>{
                        const position = projectCityPin(city);
                        const coordinates = cityCoordinates[city.id];
                        const isActive = activeCity === city.id;
                        const label = cityLabel(city.id);
                        var _coordinates_x;
                        const isEdgeLeft = ((_coordinates_x = coordinates === null || coordinates === void 0 ? void 0 : coordinates.x) !== null && _coordinates_x !== void 0 ? _coordinates_x : 50) < 10;
                        var _coordinates_x1;
                        const isEdgeRight = ((_coordinates_x1 = coordinates === null || coordinates === void 0 ? void 0 : coordinates.x) !== null && _coordinates_x1 !== void 0 ? _coordinates_x1 : 50) > 90;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            type: "button",
                            className: `about-map-pin${isActive ? " is-active" : ""}${isEdgeLeft ? " is-edge-left" : ""}${isEdgeRight ? " is-edge-right" : ""}`,
                            style: {
                                left: position.left,
                                top: position.top
                            },
                            onMouseEnter: ()=>setActiveCity(city.id),
                            onMouseLeave: ()=>setActiveCity(""),
                            onFocus: ()=>setActiveCity(city.id),
                            onBlur: ()=>setActiveCity(""),
                            "aria-label": label,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "about-map-dot",
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "about-map-tooltip",
                                    children: label
                                })
                            ]
                        }, city.id);
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                className: "about-map-cities",
                "aria-label": "City locations",
                children: cityPins.map((city)=>{
                    const isActive = activeCity === city.id;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: `about-map-city${isActive ? " is-active" : ""}`,
                            onMouseEnter: ()=>setActiveCity(city.id),
                            onMouseLeave: ()=>setActiveCity(""),
                            onFocus: ()=>setActiveCity(city.id),
                            onBlur: ()=>setActiveCity(""),
                            children: cityLabel(city.id)
                        })
                    }, `${city.id}-city`);
                })
            })
        ]
    });
};
exports.default = AcrossChaptersMap;

},{"react/jsx-runtime":"a7gVT","react":"7d7jl","../../utils/translations":"kdPrY","./AcrossChaptersMap.css":"ahYV3","@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"ahYV3":[function() {},{}],"kgr6z":[function() {},{}],"c3sef":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
const Error = ()=>{
    const err = (0, _reactRouterDom.useRouteError)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("main", {
        role: "alert",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                children: "Oops"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Something went wrong"
            }),
            ((err === null || err === void 0 ? void 0 : err.status) || (err === null || err === void 0 ? void 0 : err.statusText)) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "Status: ",
                    err === null || err === void 0 ? void 0 : err.status,
                    " \u2014 ",
                    err === null || err === void 0 ? void 0 : err.statusText
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                href: "/",
                children: "back to main page"
            })
        ]
    });
};
exports.default = Error;

},{"react/jsx-runtime":"a7gVT","react-router-dom":"bYbo7","@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"4rnt2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const UserContext = /*#__PURE__*/ (0, _react.createContext)({
    loggedInUser: "Default User"
});
exports.default = UserContext;

},{"react":"7d7jl","@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"ijseP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccessibilityProvider", ()=>AccessibilityProvider);
parcelHelpers.export(exports, "useAccessibilityPrefs", ()=>useAccessibilityPrefs);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _accessibilityPrefs = require("./accessibilityPrefs");
const AccessibilityContext = /*#__PURE__*/ (0, _react.createContext)(null);
const AccessibilityProvider = ({ children })=>{
    const [prefs, setPrefs] = (0, _react.useState)(()=>(0, _accessibilityPrefs.readStoredPrefs)());
    (0, _react.useEffect)(()=>{
        // Reconcile in case the inline pre-hydration script (index.html) and
        // this initial state ever disagree — keeps <html> classes authoritative.
        (0, _accessibilityPrefs.applyPrefsToDocument)(prefs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const setPref = (0, _react.useCallback)((key, value)=>{
        setPrefs((prev)=>{
            const next = (0, _objectSpreadProps._)((0, _objectSpread._)({}, prev), {
                [key]: value
            });
            (0, _accessibilityPrefs.persistPrefs)(next);
            return next;
        });
    }, []);
    const resetPrefs = (0, _react.useCallback)(()=>{
        const next = (0, _objectSpread._)({}, (0, _accessibilityPrefs.DEFAULT_PREFS));
        setPrefs(next);
        (0, _accessibilityPrefs.persistPrefs)(next);
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(AccessibilityContext.Provider, {
        value: {
            prefs,
            setPref,
            resetPrefs
        },
        children: children
    });
};
const useAccessibilityPrefs = ()=>{
    const ctx = (0, _react.useContext)(AccessibilityContext);
    if (!ctx) throw new Error("useAccessibilityPrefs must be used within an AccessibilityProvider");
    return ctx;
};

},{"@swc/helpers/_/_object_spread":"evX8V","@swc/helpers/_/_object_spread_props":"9c2oY","react/jsx-runtime":"a7gVT","react":"7d7jl","./accessibilityPrefs":"6AXZg","@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"6AXZg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "STORAGE_KEY", ()=>STORAGE_KEY);
parcelHelpers.export(exports, "DEFAULT_PREFS", ()=>DEFAULT_PREFS);
parcelHelpers.export(exports, "REDUCE_MOTION_CLASS", ()=>REDUCE_MOTION_CLASS);
parcelHelpers.export(exports, "PREFS_CHANGED_EVENT", ()=>PREFS_CHANGED_EVENT);
parcelHelpers.export(exports, "readStoredPrefs", ()=>readStoredPrefs);
parcelHelpers.export(exports, "applyPrefsToDocument", ()=>applyPrefsToDocument);
parcelHelpers.export(exports, "persistPrefs", ()=>persistPrefs);
// Combines the manual "reduce motion" preference with the OS-level
// prefers-reduced-motion media query — either one is enough to reduce motion.
parcelHelpers.export(exports, "isReducedMotionPreferred", ()=>isReducedMotionPreferred);
var _objectSpread = require("@swc/helpers/_/_object_spread");
const STORAGE_KEY = "twk_a11y_prefs";
const DEFAULT_PREFS = {
    largerText: false,
    higherContrast: false,
    reduceMotion: false,
    underlineLinks: false
};
const CLASS_MAP = {
    largerText: "a11y-larger-text",
    higherContrast: "a11y-high-contrast",
    reduceMotion: "a11y-reduce-motion",
    underlineLinks: "a11y-underline-links"
};
const REDUCE_MOTION_CLASS = CLASS_MAP.reduceMotion;
const PREFS_CHANGED_EVENT = "twk-a11y-prefs-changed";
function readStoredPrefs() {
    if (typeof window === "undefined") return (0, _objectSpread._)({}, DEFAULT_PREFS);
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return (0, _objectSpread._)({}, DEFAULT_PREFS);
        const parsed = JSON.parse(raw);
        return (0, _objectSpread._)({}, DEFAULT_PREFS, parsed);
    } catch (error) {
        return (0, _objectSpread._)({}, DEFAULT_PREFS);
    }
}
function applyPrefsToDocument(prefs) {
    if (typeof document === "undefined") return;
    const root = document.documentElement;
    Object.entries(CLASS_MAP).forEach(([key, className])=>{
        root.classList.toggle(className, Boolean(prefs[key]));
    });
}
function persistPrefs(prefs) {
    applyPrefsToDocument(prefs);
    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
    } catch (error) {
    // localStorage unavailable (private browsing, quota) — preference just won't persist
    }
    if (typeof window !== "undefined" && typeof window.dispatchEvent === "function") window.dispatchEvent(new CustomEvent(PREFS_CHANGED_EVENT, {
        detail: prefs
    }));
}
function isReducedMotionPreferred() {
    if (typeof document === "undefined") return false;
    const manual = document.documentElement.classList.contains(REDUCE_MOTION_CLASS);
    const system = typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    return manual || Boolean(system);
}

},{"@swc/helpers/_/_object_spread":"evX8V","@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"aWZ8p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _i18N = require("../../utils/i18n");
var _translations = require("../../utils/translations");
var _languageContext = require("../../utils/LanguageContext");
var _cookieBannerCss = require("./CookieBanner.css");
const STORAGE_KEY = 'twk_cookie_consent';
const CookieBanner = ()=>{
    const [visible, setVisible] = (0, _react.useState)(false);
    const { currentLang } = (0, _languageContext.useLanguage)();
    const { t } = (0, _translations.useTranslations)();
    const paths = (0, _i18N.getRoutePaths)(currentLang);
    const declineRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        const stored = localStorage.getItem(STORAGE_KEY);
        if (!stored) setVisible(true);
    }, []);
    const handleAccept = ()=>{
        var _window_twkLoadAnalytics, _window;
        localStorage.setItem(STORAGE_KEY, 'accepted');
        (_window_twkLoadAnalytics = (_window = window).twkLoadAnalytics) === null || _window_twkLoadAnalytics === void 0 ? void 0 : _window_twkLoadAnalytics.call(_window);
        setVisible(false);
    };
    const handleDecline = ()=>{
        localStorage.setItem(STORAGE_KEY, 'declined');
        setVisible(false);
    };
    (0, _react.useEffect)(()=>{
        if (!visible) return undefined;
        window.requestAnimationFrame(()=>{
            var _declineRef_current;
            (_declineRef_current = declineRef.current) === null || _declineRef_current === void 0 ? void 0 : _declineRef_current.focus();
        });
        const handleKeyDown = (event)=>{
            if (event.key === 'Escape') handleDecline();
        };
        window.addEventListener('keydown', handleKeyDown);
        return ()=>window.removeEventListener('keydown', handleKeyDown);
    }, [
        visible
    ]);
    if (!visible) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "cookie-banner",
        role: "region",
        "aria-label": t('common', 'cookies.label'),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "cookie-banner-eyebrow",
                children: t('common', 'cookies.eyebrow')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                className: "cookie-banner-text",
                children: [
                    t('common', 'cookies.text'),
                    ' ',
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: paths.privacy,
                        className: "cookie-banner-link",
                        children: t('common', 'cookies.link')
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "cookie-banner-actions",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "cookie-banner-decline",
                        onClick: handleDecline,
                        ref: declineRef,
                        children: t('common', 'cookies.decline')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "cookie-banner-accept",
                        onClick: handleAccept,
                        children: [
                            t('common', 'cookies.accept'),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "arrow-icon",
                                children: "\u2192"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = CookieBanner;

},{"react/jsx-runtime":"a7gVT","react":"7d7jl","react-router-dom":"hhXgL","../../utils/i18n":"4Kl7i","../../utils/translations":"kdPrY","../../utils/LanguageContext":"5u50e","./CookieBanner.css":"3JpWD","@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"3JpWD":[function() {},{}],"bxZc0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _accessibilityContext = require("../../utils/AccessibilityContext");
var _accessibilityMenuCss = require("./AccessibilityMenu.css");
const PREFERENCES = [
    {
        key: "largerText",
        label: "larger text"
    },
    {
        key: "higherContrast",
        label: "higher contrast"
    },
    {
        key: "reduceMotion",
        label: "reduce motion"
    },
    {
        key: "underlineLinks",
        label: "underline links"
    }
];
const AccessibilityMenu = ()=>{
    const { prefs, setPref, resetPrefs } = (0, _accessibilityContext.useAccessibilityPrefs)();
    const [isCollapsed, setIsCollapsed] = (0, _react.useState)(false);
    const lastScrollY = (0, _react.useRef)(0);
    const groupId = (0, _react.useId)();
    const labelId = `${groupId}-label`;
    const hasNonDefault = Object.values(prefs).some(Boolean);
    (0, _react.useEffect)(()=>{
        lastScrollY.current = window.scrollY;
        if (window.scrollY > 24) setIsCollapsed(true);
        const handleScroll = ()=>{
            const currentScrollY = window.scrollY;
            if (currentScrollY <= 24) setIsCollapsed(false);
            else if (currentScrollY > lastScrollY.current + 2) setIsCollapsed(true);
            lastScrollY.current = currentScrollY;
        };
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return ()=>window.removeEventListener("scroll", handleScroll);
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `a11y-dock${isCollapsed ? " is-collapsed" : ""}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "button",
                className: "a11y-dock-toggle",
                onClick: ()=>setIsCollapsed((current)=>!current),
                "aria-expanded": !isCollapsed,
                "aria-controls": `${groupId}-panel`,
                "aria-label": isCollapsed ? "Show accessibility preferences" : "Hide accessibility preferences",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    "aria-hidden": "true",
                    children: isCollapsed ? "\u2039" : "\u203A"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                id: `${groupId}-panel`,
                className: "a11y-dock-panel",
                role: "group",
                "aria-labelledby": labelId,
                "aria-hidden": isCollapsed,
                inert: isCollapsed ? "" : undefined,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        id: labelId,
                        className: "a11y-dock-label",
                        children: "accessibility"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                        className: "a11y-dock-list",
                        children: PREFERENCES.map((item, index)=>{
                            const inputId = `${groupId}-${item.key}`;
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                className: "a11y-dock-row",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "a11y-dock-index",
                                        "aria-hidden": "true",
                                        children: String(index + 1).padStart(2, "0")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                        className: "a11y-dock-field",
                                        htmlFor: inputId,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "a11y-dock-text",
                                                children: item.label
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "a11y-dock-control",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        type: "checkbox",
                                                        id: inputId,
                                                        checked: prefs[item.key],
                                                        onChange: (event)=>setPref(item.key, event.target.checked)
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "a11y-dock-dot",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, item.key);
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "a11y-dock-reset",
                        onClick: resetPrefs,
                        disabled: !hasNonDefault,
                        children: "reset preferences"
                    })
                ]
            })
        ]
    });
};
exports.default = AccessibilityMenu;

},{"react/jsx-runtime":"a7gVT","react":"7d7jl","../../utils/AccessibilityContext":"ijseP","./AccessibilityMenu.css":"ivpI7","@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"ivpI7":[function() {},{}],"hbtmi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _accessibilityPrefs = require("../utils/accessibilityPrefs");
const ScrollToTop = ()=>{
    const { pathname, search, hash, key } = (0, _reactRouterDom.useLocation)();
    const isInitialRender = (0, _react.useRef)(true);
    (0, _react.useEffect)(()=>{
        if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return undefined;
        }
        const behavior = (0, _accessibilityPrefs.isReducedMotionPreferred)() ? "auto" : "smooth";
        // Hash navigation: scroll to the target element instead of the top.
        // Lazy-loaded pages render after the navigation, so retry until the
        // element exists.
        if (hash) {
            const id = decodeURIComponent(hash.slice(1));
            let frame;
            let attempts = 0;
            const scrollToTarget = ()=>{
                const el = document.getElementById(id);
                if (el) {
                    el.scrollIntoView({
                        behavior
                    });
                    return;
                }
                if (attempts < 120) {
                    attempts += 1;
                    frame = window.requestAnimationFrame(scrollToTarget);
                }
            };
            frame = window.requestAnimationFrame(scrollToTarget);
            return ()=>window.cancelAnimationFrame(frame);
        }
        const frame = window.requestAnimationFrame(()=>{
            window.scrollTo({
                top: 0,
                left: 0,
                behavior
            });
        });
        return ()=>window.cancelAnimationFrame(frame);
    }, [
        pathname,
        search,
        hash,
        key
    ]);
    return null;
};
exports.default = ScrollToTop;

},{"react":"7d7jl","react-router-dom":"hhXgL","../utils/accessibilityPrefs":"6AXZg","@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"G0hsL":[function(require,module,exports,__globalThis) {
// Shared content for /services — used by both the Service page component and
// App.js's structured data, so visible copy and JSON-LD never drift apart.
// Kept as a plain data module (no React/CSS) so importing it from App.js does
// not pull the lazy-loaded Service page into the main bundle.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serviceGroupSlug", ()=>serviceGroupSlug);
parcelHelpers.export(exports, "serviceGroups", ()=>serviceGroups);
parcelHelpers.export(exports, "faqs", ()=>faqs);
const serviceGroupSlug = (title)=>title.replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
const serviceGroups = [
    {
        number: "01",
        title: "groups.automation.title",
        intro: "groups.automation.intro",
        services: [
            "groups.automation.services.aiAutomation",
            "groups.automation.services.privateLocalAi",
            "groups.automation.services.processOptimisation",
            "groups.automation.services.customTools"
        ]
    },
    {
        number: "02",
        title: "groups.webDigital.title",
        intro: "groups.webDigital.intro",
        services: [
            "groups.webDigital.services.webDevelopment",
            "groups.webDigital.services.digitalisation"
        ]
    },
    {
        number: "03",
        title: "groups.finance.title",
        intro: "groups.finance.intro",
        services: [
            "groups.finance.services.finance",
            "groups.finance.services.creativeDevelopment"
        ]
    },
    {
        number: "04",
        title: "groups.brandDesign.title",
        intro: "groups.brandDesign.intro",
        services: [
            "groups.brandDesign.services.brandingIdentity",
            "groups.brandDesign.services.graphicDesign",
            "groups.brandDesign.services.communication"
        ]
    }
];
const faqs = "faq.questions";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"aDlyA"}],"262m3":[function() {},{}],"b4Fi2":[function() {},{}],"4NlaM":[function() {},{}],"feUX4":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("c82491795b9c2146")(module.bundle.resolve("gfzcu")),
    require("f0a413ccb8d020f")(module.bundle.resolve("jCfwA"))
]).then(()=>module.bundle.root('qfrMP'));

},{"c82491795b9c2146":"1OgkP","f0a413ccb8d020f":"h72nR"}],"1OgkP":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ae7c5e215a4907e2");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

},{"ae7c5e215a4907e2":"kPoTh"}],"kPoTh":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"h72nR":[function(require,module,exports,__globalThis) {
var global = arguments[3];
"use strict";
var cacheLoader = require("7ed6ff764dcc7ef");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(('' + Math.random()).slice(2));
        global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement('script');
        script.async = true;
        script.type = 'module';
        script.charset = 'utf-8';
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

},{"7ed6ff764dcc7ef":"kPoTh"}],"hF8ot":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("8bbb09f50b254e5b")(module.bundle.resolve("6QlvJ")),
    require("c181e8fd8299db58")(module.bundle.resolve("jlkyU"))
]).then(()=>module.bundle.root('hrhId'));

},{"8bbb09f50b254e5b":"1OgkP","c181e8fd8299db58":"h72nR"}],"ccXrN":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("30d749bd9a454bb4")(module.bundle.resolve("42H8B")),
    require("6d73b2bba8db0926")(module.bundle.resolve("cl9Bd"))
]).then(()=>module.bundle.root('fMBy3'));

},{"30d749bd9a454bb4":"1OgkP","6d73b2bba8db0926":"h72nR"}],"36z8C":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("ec3d0534bcf8457")(module.bundle.resolve("athmk")),
    require("68b594f91d172346")(module.bundle.resolve("hCIgL"))
]).then(()=>module.bundle.root('4DrNT'));

},{"ec3d0534bcf8457":"1OgkP","68b594f91d172346":"h72nR"}],"96YN2":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("dd4c234dc8cff16f")(module.bundle.resolve("iYQ95")),
    require("61ccfffabc6284c9")(module.bundle.resolve("4ecuy"))
]).then(()=>module.bundle.root('9cZAe'));

},{"dd4c234dc8cff16f":"1OgkP","61ccfffabc6284c9":"h72nR"}],"drIH9":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("530578dd780def7b")(module.bundle.resolve("gX0Yw")),
    require("138598f2344bb766")(module.bundle.resolve("7d7ez"))
]).then(()=>module.bundle.root('catKY'));

},{"530578dd780def7b":"1OgkP","138598f2344bb766":"h72nR"}],"8gdbq":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("924677ee57d2903d")(module.bundle.resolve("fI4oH")),
    require("b645a1170c89214d")(module.bundle.resolve("awgD4"))
]).then(()=>module.bundle.root('3Vt2t'));

},{"924677ee57d2903d":"1OgkP","b645a1170c89214d":"h72nR"}],"23N0I":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("ca7ea04c01dc8b2d")(module.bundle.resolve("bxSu2")),
    require("3e38f251f52968ea")(module.bundle.resolve("95kq0"))
]).then(()=>module.bundle.root('bmNWW'));

},{"ca7ea04c01dc8b2d":"1OgkP","3e38f251f52968ea":"h72nR"}],"XtncN":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("55fbe2991f074702")(module.bundle.resolve("9qlZc")),
    require("3ce3bfda9771a1ca")(module.bundle.resolve("68tww"))
]).then(()=>module.bundle.root('h7Nc8'));

},{"55fbe2991f074702":"1OgkP","3ce3bfda9771a1ca":"h72nR"}]},["68Vv6","kwgBA"], "kwgBA", "parcelRequire1185", {}, "./", "/")

//# sourceMappingURL=path0.70bb500e.js.map
